(function() {
  'use strict';

  angular.module('app.partials.dialogs.user-profile', []).controller('UserProfileDialogController', UserProfileDialogController);

  function UserProfileDialogController(
    $timeout,
    // ACCESS,
    OPERATION,
    DialogService,
    InfoBarService,
    LoaderService,
    UserService,
    locals) {

    var vm = this,
        FADE_DURATION = 200;

    // Data
    vm.loading = false;
    vm.dialog = locals;
    vm.isCreation  = (vm.dialog.operation == OPERATION.CREATE);
    vm.isEdition   = (vm.dialog.operation == OPERATION.UPDATE);
    vm.isReadOnly  = (vm.dialog.operation == OPERATION.READ_ONLY);

    vm.user = angular.copy(vm.dialog.user);
    
    // vm.isLoggedProfile = vm.dialog.isLogged;
    vm.isLoggedProfile = vm.user && vm.user.id == 1;

    // Methods
    vm.closeDialog = DialogService.cancel;
    vm.onChangePasswordClick = onChangePasswordClick;
    vm.onCloseDialogClick = DialogService.cancel;
    vm.onSaveClick = onSaveClick;

    _init();

    //////////

    function _init() {
      _hideLoader();
    }

    /**
     * Hides the loader.
     */
    function _hideLoader() {
      vm.loading = false;
      LoaderService.hide('userProfileDialogLoader');
    }

    /**
     * Shows the loader.
     */
    function _showLoader() {
      vm.loading = true;
      LoaderService.show('userProfileDialogLoader');
    }
    
    /**
     * Click event for opening the change password modal.
     */
    function onChangePasswordClick() {
      var showing = true;
      toggleDialog();
      
      DialogService.changePassword(vm.user).then(function (res) {}, function (err) {
        console.error('err', err);
      }).then(toggleDialog);
      
      /**
       * Toggles this dialog visibility when showing the password dialog.
       */
      function toggleDialog() {        
        if (showing) // Hides this dialog.
          angular.element('.user-profile-dialog').fadeOut(FADE_DURATION);
        else // Shows this dialog again.
          angular.element('.user-profile-dialog').show();
        showing = !showing;
      }
    }

    /**
     * Click event for saving new profile.
     */
    function onSaveClick() {
      if (vm.loading)
        return;
        
      _showLoader();
      
      vm.user.role_id = 1;
      vm.user.name = vm.user.first_name;
      
      if (vm.user.last_name)
        vm.user.name += ' ' + vm.user.last_name;
        
      // TEMP: simulate API call
      $timeout(function () {
        DialogService.hide(vm.user);
      }, 1000);
        
      // var promise;
      // if (vm.isCreation)
      //   promise = UserService.createUser(vm.user);
      // else
      //   promise = UserService.updateUser(vm.user);
      // 
      // promise.then(function(profile) {
      //   DialogService.hide(profile);
      // }, function(err) {
      //   InfoBarService.error(err);
      // }).finally(_hideLoader);
    }
  }
})();

(function() {
  'use strict';

  angular.module('app.partials.dialogs.document-preview', []).controller('DocumentPreviewDialogController', DocumentPreviewDialogController);
  
  function DocumentPreviewDialogController(
    $http,
    $timeout,
    locals,
    DialogService,
    LoaderService
  ){
    // Vars
    var vm = this,
        LOADER_TIMEOUT = 1000;

    // Data
    vm.dialog = locals;
    vm.document = vm.dialog.document;
    
    // Methods
    vm.onCloseDialogClick = DialogService.cancel;
    
    _init();
    
    ////////
    
    function _init() {
      // Load the document image.
      $http.get(vm.document.uploaded_document.url).then(function(data) {
        vm.document.image = vm.document.uploaded_document.url;
        $timeout(_hideLoader, LOADER_TIMEOUT);
      });
    }

    /**
     * Hides the loader.
     */
    function _hideLoader() {
      vm.loading = false;
      LoaderService.hide('documentImageLoader');
    }
    
    /**
     * Shows the loader.
     */
    function _showLoader() {
      vm.loading = true;
      LoaderService.show('documentImageLoader');
    }
  }
})();  

(function() {
  'use strict';

  angular.module('app.partials.dialogs.chat-history', []).controller('ChatHistoryDialogController', ChatHistoryDialogController);
  
  function ChatHistoryDialogController(
    $timeout,
    ChatService,
    LoaderService,
    DialogService,
    InfoBarService,
    locals
  ){

    var vm = this;

    // Data
    vm.loading = false;
    vm.dialog = locals;
    vm.chat = vm.dialog.chat;
    vm.chatId = vm.dialog.chatId;

    // Methods
    vm.onCloseDialogClick = DialogService.cancel;
    vm.onViewPreviousChatClick = onViewPreviousChatClick;

    _init();

    ////////

    function _init() {
      if (vm.chat)
        _loadMessages();
      else if (vm.chatId)
        _loadChat(vm.chatId);
    }

    /**
     * Load conversation.
     * @param {*} chatId 
     */
    function _loadChat(chatId) {
      _showLoader();

      ChatService.getChat(chatId).then(function (chat) {
        vm.chat = chat;
        _loadMessages();
      }, function (err) {
        console.error('err', err);
        InfoBarService.error(err);
        _hideLoader();
      });
    }

    /**
     * Load conversation messages.
     * @param {*} page 
     */
    function _loadMessages(page) {
      _showLoader();

      ChatService.getMessages(vm.chat.id, page).then(function (res) {
        vm.messages = res.messages;
        vm.pagination = res.pagination;
        $timeout(function () {
          _scrollToBottomOfChat(vm.chat.id);
          _hideLoader();
        }, 200);
      }, function (err) {
        console.error('err', err);
        InfoBarService.error(err);
        _hideLoader();
      });
    }
    
    /**
     * Hides the loader.
     */
    function _hideLoader() {
      vm.loading = false;
      LoaderService.hide('chatLoader');
    }

    /**
     * Shows the loader.
     */
    function _showLoader() {
      vm.loading = true;
      LoaderService.show('chatLoader');
    }

    /**
     * View previous chat click event.
     */
    function onViewPreviousChatClick() {
      _loadChat(vm.chat.previous_conversation_id);
    }

    /**
     * Scrolls the chat to the bottom.
     */
    function _scrollToBottomOfChat(chatId, speed) {
      var chatDialog = angular.element('#chat-dialog' + chatId);

      $timeout(function() {
        chatDialog.animate({
          scrollTop: chatDialog[0].scrollHeight
        }, speed);
      }, 10);
    }
  }
})();  

(function() {
  'use strict';

  angular
    .module('app.pages.issues.issue', [])
    .config(config);

  /** @ngInject */
  function config(
    ACCESS,
    $stateProvider, 
    $translatePartialLoaderProvider, 
    msNavigationServiceProvider
  ) {
    // State
    $stateProvider.state('app.pages_issues_issue', {
      url: '/chamado/:id',
      views: {
        'content@app': {
          templateUrl: 'app/main/pages/issues/issue/issue.html',
          controller: 'IssueController as vm'
        }
      },
      bodyClass: 'issue',
      access: ACCESS.ONLINE.PUBLIC
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('app.pages.issues.issue')
    .controller('IssueController', IssueController);

  /** @ngInject */
  function IssueController(
    msUtils,
    $timeout,
    AuthService,
    BROADCAST,
    BroadcastService,
    LoaderService,
    StateService,
    IssueService,
    $filter,
    InfoBarService,
    ActivityService
  ) {
    // Data
    var vm = this,
        TABS = {
          ACTIVITIES: 0,
          DETAILS: 1,
          DOCUMENTS: 2,
          CHATS: 3
        };
    
    vm.occurrence = []; 
    vm.activities = [];
    vm.issueId = null;
    vm.currentTab = TABS.ACTIVITIES;
    vm.currentUser = AuthService.getUser();
    // vm.tabBadges = [1];
    vm.isClient = AuthService.isClient();
    vm.hideStatus = true;
    vm.breadcrumbs = [];
    vm.successSendMessage = false;
    
    // Methods
    
    vm.onLoadMoreClick = onLoadMoreClick;
    vm.onTabChange = onTabChange;
    vm.onMessageSend = onMessageSend;
    
    _init();
    
    ////////
    
    function _init() {
      BroadcastService.broadcast(BROADCAST.FAB.SHOW, null, true);

      vm.issueId =  parseInt(StateService.getParam('id'));
      if (!vm.issueId) StateService.go('app.pages_home')

      vm.action = {
        id: 'expand',
        callback: console.log('fn callback')
      };

      _loadIssuesAndActivities();
    }

    /**
     * Handle with breadcrumb
     * @param {Object} issue 
     */
    function _resolveBreadcrumb(issue) {
      var name = issue.client.company_fantasy_name || issue.client.name;
      vm.breadcrumbs = [
        {
          label: 'Home',
          state: 'app.pages_home'
        },
        {
          label: name + ' - ' + $filter('numberFixedLen')(issue.id, 5)
        }
      ];
    }

    /**
     * Load activities
     * @param {Number} page 
     * @param {Object} options 
     */
    function _loadActivities(page, options) {
      return ActivityService.getIssueActivities(vm.issueId, page)
      .then(function(resActivities) {
        _addActivities(resActivities.activities, options)
        vm.pagination = resActivities.pagination;
        return resActivities;
      })
    }

    /**
     * Load issues and activities
     * @param {Object} params 
     */
    function _loadIssuesAndActivities(params) {
      _showLoader();
      _loadActivities().then(function() {
        return IssueService.getIssue(vm.issueId)
      }).then(function(resp) {
        vm.lastAccess = resp.updated_at;
        vm.occurrence = resp; 
        _resolveBreadcrumb(resp);
      },function(err) {
        InfoBarService.error(err);
      }).finally(_hideLoader)
    }

    /**
     * Add paginated activities to existing activities.
     */
    function _addActivities(items, options) {
      var existingIds = vm.activities.map(function (activity) {
        return activity.id;
      });

      items.forEach(function (activity) {
        if (existingIds.indexOf(activity.id) == -1) {
          if (options && options.orderDesc) {
            vm.activities.unshift(activity);
          } else {
            vm.activities.push(activity);
          }
        }
      });
    }
    
    /**
     * Hides the loader.
     */
    function _hideLoader() {
      vm.loading = false;
      LoaderService.hideGlobal();
    }
    
    /**
     * Shows the loader.
     */
    function _showLoader() {
      vm.loading = true;
      LoaderService.showGlobal();
    }

    /**
     * Send a message to an issue
     * @param {String} message 
     */
    function onMessageSend(message) {
      if (vm.successSendMessage) return vm.successSendMessage = false;  

      IssueService.sendMessage(vm.issueId, message)
      .then(function(resp) {
        vm.successSendMessage = true;
        _loadActivities(1, {
          orderDesc: true
        });
      }, function(err) {
        InfoBarService.error(err);
      })
    }

    /**
     * Load more activities click event.
     * First pagination only increases per page to 3. Next paginations actually navigate pages.
     */
    function onLoadMoreClick() {
      var nextPage = (vm.pagination.per_page == 1) ? vm.pagination.page : vm.pagination.page + 1;
      _loadActivities(nextPage);
    }
    
    /**
     * Tab change event.
     */
    function onTabChange() {
      vm.fixDynamicHeight = true;
      $timeout(function () {
        vm.fixDynamicHeight = false;
      }, 750);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.pages.auth.reset-password', [])
    .config(config);

  /** @ngInject */
  function config(
    ACCESS,
    $stateProvider, 
    $translatePartialLoaderProvider, 
    msNavigationServiceProvider
  ) {
    // State
    $stateProvider.state('app.pages_auth_reset-password', {
      url: '/resetar-senha?type&t',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.pages_auth_reset-password': {
          templateUrl: 'app/main/pages/auth/reset-password/reset-password.html',
          controller: 'ResetPasswordController as vm'
        }
      },
      bodyClass: 'reset-password',
      access: ACCESS.OFFLINE
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('app.pages.auth.reset-password')
    .controller('ResetPasswordController', ResetPasswordController);

  /** @ngInject */
  function ResetPasswordController(
    StateService,
    AuthService,
    InfoBarService
  ) {
    var vm = this,
        params = StateService.getParams();
    // Data
    vm.success = false;
    vm.requestIn = false;

    // Methods
    vm.onSubmit = onSubmit;
    vm.backToLogin = backToLogin;
    //////////


    function backToLogin() {
      StateService.go('app.pages_auth_login')
    }

    function onSubmit(isInvalid) {
      if (isInvalid) return;

      vm.requestIn = true;

      AuthService.resetPassword({
        password: vm.form.password,
        reset_password_token: params.t,
        type: params.type
      })
      .then(function(res) {
        vm.success = true;
        vm.requestIn = false;
      }, function(err) {
        vm.requestIn = false;
        InfoBarService.error(err);
      })
    }

    function _init() {
      if (!params.t || !params.type) return backToLogin();
    }

    _init();
  }
})();

(function() {
  'use strict';

  angular
    .module('app.pages.auth.register', [])
    .config(config);

  /** @ngInject */
  function config(
    ACCESS,
    $stateProvider
  ) {
    // State
    $stateProvider.state('app.pages_auth_register', {
      url: '/cadastro?t&type',
      views: {
        'content@app': {
          templateUrl: 'app/main/pages/auth/register/register.html',
          controller: 'RegisterController as vm'
        }
      },
      bodyClass: 'register',
      access: ACCESS.UNRESTRICTED,
      simpleHeader: true
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('app.pages.auth.register')
    .controller('RegisterController', RegisterController);

  /** @ngInject */
  function RegisterController(
    AuthService,
    ClientService,
    CompletionBarService,
    InfoBarService,
    LoaderService,
    StateService,
    LocationService,
    msUtils,
    $timeout,
    ObserverService
  ) {
    // Data
    var vm = this,
        weights = {},
        STARTING_PROGRESS = 20,
        LOADERS = {
          WELCOME: 'welcomeLoader',
          INFO: 'infoFormLoader',
          PASSWORD: 'passwordFormLoader',
          SUCCESS: 'successLoader'
        },
        STEPS = {
          WELCOME: 0,
          INFO: 1,
          PASSWORD: 2,
          SUCCESS: 3
        };
    vm.currentStep = STEPS.WELCOME;
    vm.isClient = null;
    vm.token = null;
    vm.user = {
      type: null
    };
    
    // Methods
    vm.onInfoSubmit = onInfoSubmit;
    vm.onLoginClick = onLoginClick;
    vm.onPasswordSubmit = onPasswordSubmit;
    vm.onStartClick = onStartClick;
    vm.onUpdateProgress = onUpdateProgress;
    
    _init();
    
    ////////
    
    function _init() {
      if (AuthService.isLogged()) {
        var blockRedirect = true;
        AuthService.logout(blockRedirect);
      }

      _showLoader(LOADERS.WELCOME);
      
      vm.token = StateService.getParam('t');
      vm.user.type = StateService.getParam('type') || 'client';
      vm.clientDocName = 'CPF';
      
      if (!vm.token) {
        StateService.login();
        return;
      }
      
      vm.isClient = (vm.user.type == 'client');
      
      // Fetch states.
      LocationService.fetchStates().then(function (states) {
        vm.states = states;
        _previewUser();
      }, function (err) {
        console.error(err);
        InfoBarService.error(err);
        _hideLoader(LOADERS.WELCOME);
        StateService.login();
      });
    }
    
    /**
     * Validate token and retrieve user info.
     */
    function _previewUser() {
      var method = vm.isClient ? ClientService.previewClient : ObserverService.previewObserver;

      method(vm.token).then(function (user) {
        vm.user = angular.extend({}, vm.user, user);
        vm.clientDocName = vm.isClient ? ((vm.user.entity_type == 'NATURAL_PERSON') ? 'CPF' : 'CNPJ') : null;
        _setupFieldWeights();
      }, function (err) {
        console.error(err);
        InfoBarService.error(err);
        StateService.login();
      }).finally(function () {
        _hideLoader(LOADERS.WELCOME);
      });
    }
    
    /**
     * Goes to a given step.
     *
     * @param {Number} step
     */
    function _goToStep(step) {
      var nextStep = step;
      
      if (nextStep == STEPS.SUCCESS) {
        CompletionBarService.update(100);
      }
      
      vm.currentStep = nextStep;
    }
    
    /**
     * Hides the loader.
     */
    function _hideLoader(loaderId) {
      vm.loading = false;
      LoaderService.hideGlobal();
      LoaderService.hide(loaderId);
    }
    
    /**
     * Goes to the next step.
     */
    function _nextStep() {
      _goToStep(vm.currentStep + 1);
    }
    
    /**
     * Returns to the previous step.
     */
    function _prevStep() {
      _goToStep(vm.currentStep - 1);
    }
    
    /**
     * Scrolls the window to the top.
     */
    function _scrollToTop() {
      var content = document.getElementById('content');
      if (content)
        content.scrollTop = 0;
    }
    
    /**
     * Setup fields state and weight.
     */
    function _setupFieldWeights() {
      weights = {
        cellphone: vm.isClient ? 10 : 20,
        address: vm.isClient ? 10 : 0,
        address_number: vm.isClient ? 10 : 0,
        district: vm.isClient ? 10 : 0,
        city: vm.isClient ? 10 : 20,
        state: vm.isClient ? 10 : 20,
        password: 9,
        password_confirmation: 5,
        terms: 5
      }
      $timeout(CompletionBarService.show.bind(null, STARTING_PROGRESS), 1000);
    }
    
    /**
     * Shows the loader.
     */
    function _showLoader(loaderId) {
      vm.loading = true;
      if (msUtils.isMobile())
        LoaderService.showGlobal();
      else
        LoaderService.show(loaderId);
    }
    
    /**
     * Updates the completion bar progress.
     */
    function onUpdateProgress() {
      var progress = STARTING_PROGRESS;
    
      for (var key in weights) {
        var weight = weights[key] ? weights[key] : 0,
            field = vm.infoForm[key] ? vm.infoForm[key] : vm.passwordForm[key],
            isValid = field ? field.$valid : false;
    
        if (key == 'terms') {
          isValid = (vm.user.terms === true);
        }
        if (isValid)
          progress += weight;
      }
    
      CompletionBarService.update(progress);
    }
    
    /**
     * Info form submit event.
     */
    function onInfoSubmit(isInvalid) {
      if (isInvalid || vm.loading)
        return;
      
      _scrollToTop();
      _nextStep();
    }
    
    /**
     * On success, redirect to login page.
     */
    function onLoginClick() {
      CompletionBarService.hide();

      var login = {
        password: vm.user.password,
        type: vm.user.type
      };

      if (login.type == 'client')
        login.document = vm.user.document;
      else
        login.email = vm.user.email;

      _showLoader(LOADERS.SUCCESS);

      AuthService.login(login).then(function (res) {
        if (res.id)
          StateService.index();
        else
          InfoBarService.show(res);
      }, function (err) {
        console.error('err', err);
        InfoBarService.error(err);
        StateService.login(); // redirect to login if any error happens
      }).finally(function () {
        _hideLoader(LOADERS.SUCCESS);
      });
    }
    
    /**
     * Password form submit event.
     */
    function onPasswordSubmit(isInvalid) {
      if (isInvalid || vm.loading)
        return;
        
      _scrollToTop();
      _showLoader(LOADERS.PASSWORD);
      
      var method = vm.isClient ? ClientService.activateClient : ObserverService.activateObserver;
      method(vm.token, vm.user).then(function (res) {
        console.log('res:', res);
        _nextStep();
      }, function (err) {
        console.error(err);
        InfoBarService.error();
      }).finally(function () {
        _hideLoader(LOADERS.PASSWORD);
      });
    }
    
    /**
     * Start button click event.
     */
    function onStartClick() {
      _scrollToTop();
      _nextStep();
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.pages.auth.login', [])
    .config(config);

  /** @ngInject */
  function config(
    ACCESS,
    $stateProvider, 
    $translatePartialLoaderProvider, 
    msNavigationServiceProvider
  ) {
    // State
    $stateProvider.state('app.pages_auth_login', {
      url: '/login',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.pages_auth_login': {
          templateUrl: 'app/main/pages/auth/login/login.html',
          controller: 'LoginController as vm'
        }
      },
      bodyClass: 'login',
      animationClass: 'animate-fade',
      access: ACCESS.OFFLINE,
      params: {
        login: null
      }
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('app.pages.auth.login')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController(
    AuthService, 
    msUtils,
    CompletionBarService,
    InfoBarService, 
    StateService, 
    localStorageService,
    $timeout,
    LoaderService
  ) {
    var vm = this,
        MASKS = {
          CPF: '999.999.999-999?',
          CNPJ: '99.999.999/9999-99'
        };
        
    // Data
    vm.clientLogin = true;
    vm.documentMask = MASKS.CPF;
    vm.login = {
      type: 'client'
    }

    // Methods
    vm.onSubmit = onSubmit;
    vm.onToggleLoginClick = onToggleLoginClick;
    vm.onDocumentChange = onDocumentChange;
    vm.goForgotPassword = goForgotPassword;
    
    _init();

    //////////
    
    function _init() {
      CompletionBarService.hide();
      var params = StateService.getParams(),
          browserInfo = msUtils.detectBrowser();

      if (params && params.login) {
        vm.login = params.login;
        onSubmit(false);
      }

      if (browserInfo && browserInfo.os) {
        vm.os = browserInfo.os;
      }

      singleSignOnCheck();
    }

    /**
     * Check for url tokens and redirects.
     */
    function singleSignOnCheck() {
      var token = StateService.getQueryParam('token'),
          url = StateService.getQueryParam('url'),
          isLogged = AuthService.isLogged();

      if (!token)
        return;

      if (isLogged) {
        StateService.goTo(url);
      } else {
        LoaderService.showLogin();
        AuthService.tokenLogin(token).then(function (res) {
          if (res.id)
            StateService.goTo(url);
          else
            InfoBarService.show(res);
        }, function (err) {
          console.error('err', err);
          InfoBarService.error(err);
        }).finally(function () {
          LoaderService.hideLogin();
        });
      }
    }

    function goForgotPassword() {
      StateService.go('app.pages_auth_forgot-password', {
        type: !vm.clientLogin ? 'observer' : 'client'
      })
    }
    
    /**
     * Login submission event.
     */
    function onSubmit(isInvalid) {      
      if (isInvalid)
        return;
        
      vm.loggingIn = true;
      
      AuthService.login(vm.login).then(function (res) {
        if (res.id)
          StateService.index();
        else
          InfoBarService.show(res);
      }, function (err) {
        console.error('err', err);
        InfoBarService.error(err);
      }).then(function () {        
        vm.loggingIn = false;
      });
      
      return false;
    }
    
    /**
     * Toggles the client login on and off.
     */
    function onToggleLoginClick() {
      vm.login = {};
      vm.clientLogin = !vm.clientLogin;
      
      if (vm.clientLogin)
        vm.login.type = 'client';
      else
        vm.login.type = 'observer';
    }
    
    /**
     * Change event for swapping document masks.
     */
    function onDocumentChange() {
      if (!vm.login.document) {
        vm.documentMask = MASKS.CPF;
        return;
      }
      var stripped = vm.login.document.replace(/\.|\-|\//g, ''),
          length = stripped.length;
      
      if (length <= 11) {
        vm.documentMask = MASKS.CPF;
      } else if (length > 11) {
        vm.documentMask = MASKS.CNPJ;
      }

      if (vm.os && (vm.os === 'linux' || vm.os === 'android')) {
        if (length === 4 || length === 7 || length === 10 || length === 13) {
          var value = vm.login.document;
          vm.login.document = '';
          $timeout(function(){ vm.login.document = value; }, 10);
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.pages.auth.forgot-password', [])
    .config(config);

  /** @ngInject */
  function config(
    ACCESS,
    $stateProvider, 
    $translatePartialLoaderProvider, 
    msNavigationServiceProvider
  ) {
    // State
    $stateProvider.state('app.pages_auth_forgot-password', {
      url: '/recuperar-senha?type',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.pages_auth_forgot-password': {
          templateUrl: 'app/main/pages/auth/forgot-password/forgot-password.html',
          controller: 'ForgotPasswordController as vm'
        }
      },
      bodyClass: 'forgot-password',
      access: ACCESS.OFFLINE
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('app.pages.auth.forgot-password')
    .controller('ForgotPasswordController', ForgotPasswordController);

  /** @ngInject */
  function ForgotPasswordController(
    StateService,
    AuthService,
    InfoBarService
  ) {
    var vm = this,
        MASKS = {
          CPF: '999.999.999-999?',
          CNPJ: '99.999.999/9999-99'
        };

    // Data
    vm.success = false;
    vm.requestIn = false;
    vm.isClient = true;
    vm.documentMask = MASKS.CPF;

    // Methods
    vm.onSubmit = onSubmit;
    vm.backToLogin = backToLogin;
    vm.onDocumentChange = onDocumentChange;
    //////////


    function backToLogin() {
      StateService.go('app.pages_auth_login')
    }

    function onSubmit(isInvalid) {
      if (isInvalid) return;

      var data = {};

      vm.requestIn = true;
      if (vm.isClient) {
        data.document = vm.form.document;
        data.type = 'client';
      } else {
        data.email = vm.form.email;
        data.type = 'observer';
      }

      return AuthService.requestPasswordReset(data).
      then(function(res) {
        var email = res.email,
            at    = email.indexOf('@');

        vm.emailToReset = email.slice(0, 2) + "**@" + email.charAt(at+1, at+2) + "*********";
        vm.success = true;
        vm.requestIn = false;
      }, function(err) {
        InfoBarService.error(err);
        vm.requestIn = false;
      });
    }

    /**
     * Change event for swapping document masks.
     */
    function onDocumentChange() {
      if (!vm.form.document) {
        vm.documentMask = MASKS.CPF;
        return;
      }
      var stripped = vm.form.document.replace(/\.|\-|\//g, ''),
          length = stripped.length;
      
      if (length <= 11) {
        vm.documentMask = MASKS.CPF;
      } else if (length > 11) {
        vm.documentMask = MASKS.CNPJ;
      }
    }

    function _init() {
      var type = StateService.getParam('type');

      if (type && type === 'observer') vm.isClient = false;
    }

    _init();
  }
})();

(function() {
  'use strict';

  angular.module('app.shared.services', []);

})();

(function() {
  'use strict';

  angular
    .module('app.shared.services')
    .factory('UserService', UserService);

  /** @ngInject */
  function UserService(
    $q,
    AuthService, 
    HelperService
  ) {

    /**
     * Abstract method to User Model.
     *
     * @param  {String} method
     * @return {Function}
     */
    function _onUser(method) {
      return HelperService.handle('UserModel', arguments);
    }
    
    /**
     * Creates an user.
     *
     * @param {Object} userData
     * @returns {Object} created user
     */
    function createUser(userData) {
      return _onUser('createUser', null, userData).then(function (res) {
        var user = res.data;
        user.name = user.first_name;
        if (user.last_name && user.last_name.length > 0)
          user.name += ' ' + user.last_name;
        return user;
      });
    }
    
    /**
     * Deletes any users.
     *
     * @param {Array} users
     */
    function deleteUsers(users) {
      var deferred = $q.defer(),
          finished = 0,
          anyProblems = false;
      users.forEach(function (user) {
        _onUser('deleteUser', null, {
          userId: user.id
        }).then(function (res) {
          finish();
        }, function (err) {
          anyProblems = true;
          finish();
        });
      });

      function finish() {
        finished++;
        if (finished == users.length) {
          if (anyProblems)
            deferred.reject();
          else
            deferred.resolve();
        }
      }

      return deferred.promise;
    }
    
    /**
     * Gets all users.
     *
     * @returns {Object} updated user
     */
    function getUsers() {
      return _onUser('getUsers').then(function (res) {
        var users = res.data.map(function (user) {
          user.name = user.first_name;
          if (user.last_name && user.last_name.length > 0)
            user.name += ' ' + user.last_name;
          return user;
        });
        
        return users;
      });
    }
    
    /**
     * Updates an user.
     *
     * @param {Object} userData
     * @returns {Object} created user
     */
    function updateUser(userData) {
      userData.userId = userData.id;
      return _onUser('updateUser', null, userData).then(function (res) {
        var user = res.data;
        
        if (user.id == AuthService.getUser('id'))
          AuthService.setUser(user);
        
        user.name = user.first_name;
        if (user.last_name && user.last_name.length > 0)
          user.name += ' ' + user.last_name;
        return user;
      });
    }

    return {
      createUser: createUser,
      deleteUsers: deleteUsers,
      getUsers: getUsers,
      updateUser: updateUser
    };
  }

})();


(function() {
  'use strict';

  angular
    .module('app.shared.services')
    .factory('i18n', i18n);

  /** @ngInject */
  function i18n(
    $filter
  ) {

    /**
     * Translate a given term by its translation key.
     *
     * @param {String} translationKey
     */
    function translate(translationKey) {
      return $filter('translate')(translationKey);
    }

    /**
     * Shorthand method to 'translate'.
     */
    function t(translationKey) {
      return translate(translationKey);
    }

    return {
      t: t,
      translate: translate
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('app.shared.services')
    .factory('StructureService', StructureService);

  /** @ngInject */
  function StructureService(
    localStorageService,
    HelperService
  ) {
    
    // Vars
    var STRUCTURES = null;

    /**
     * Abstract method to Structure Model.
     *
     * @param  {String} method
     * @return {Function}
     */
    function _onStructure(method) {
      return HelperService.handle('StructureModel', arguments);
    }
    
    /**
     * Returns all available structures.
     */
    function _getStructures() {
      if (!STRUCTURES)
        STRUCTURES = localStorageService.get('structures');
      return STRUCTURES;
    }
    
    /**
     * Builds a stringified version of the structure. 
     *
     * @param {Object} structure
     * @returns {Object} stringified structure
     */
    function _stringify(structure) {
      Object.keys(structure).forEach(function (key, index) {
        structure[key] = key.toString().toUpperCase();
      });
      return structure;
    }
    
    /**
     * Fetch structure variables and init structures object.
     */
    function fetchStructures() {
      return _onStructure('getStructures').then(function (res) {
        STRUCTURES = res.data || res;
        localStorageService.set('structures', STRUCTURES);
        return STRUCTURES;
      });
    }
    
    /**
     * Gets a single structure by name or all structures.
     */
    function getStructure(structure, prop, raw) {
      var structures = _getStructures();
      
      if (!structures || !structure)
        return;
        
      var rawStructure = prop ? structures[structure][prop] : structures[structure];
      return raw ? rawStructure : _stringify(rawStructure);
    }

    return {
      getStructure: getStructure,
      fetchStructures: fetchStructures
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('app.shared.services')
    .factory('StateService', StateService);

  /** @ngInject */
  function StateService(APP, $state, $stateParams, $window) {
    
    /**
     * Returns to previous state.
     */
    function back() {
      $window.history.back();
    }
    
    /**
     * Returns current state date.
     *
     * @returns {Object}
     */
    function current() {
      return angular.extend({}, $state.current, { params: angular.extend({}, getParams()) });
    }
    
    /**
    * Returns the clean name of the current state.
    * 
    * @return {String} 
    */
    function getName() {
      var parts = current().name.split('_');
      return parts[parts.length - 1];
    }
    
    /**
    * Returns the full name of the current state.
    * 
    * @return {String} 
    */
    function getFullName() {
      return current().name;
    }
        
    /**
    * Returns a single parameter of the current state.
    * 
    * @param  {String} param
    * @return {Any} 
    */
    function getParam(param) {
      return $stateParams[param];
    }

    /**
     * Returns current state parameters.
     * 
     * @return {Object}
     */
    function getParams() {
      return $stateParams;
    }
    
    /**
     * Performs a state change
     * 
     * @param  {String} stateName
     * @param  {Object} stateParams
     * @param  {Object} stateOptions
     * @return {Promise}
     */
    function go(stateName, stateParams, stateOptions) {
      return $state.go(stateName, stateParams, stateOptions);
    }

    /**
     * Performs a URL change.
     */
    function goTo(path) {
      window.location.href = APP.CLIENTS_URL + '/' + path;
    }
    
    /**
     * Shorthand for go('index') method.
     */
    function index() {
      return go('app.pages_home');
    }
    
    /**
     * Shorthand for go('login') method.
     */
    function login(data) {
      return go('app.pages_auth_login', data);
    }
    
    /**
     * Shorthand for go('app.pages_init') method.
     */
    function logout() {
      return go('app.pages_init');
    }

    /**
     * Get query param by name.
     */
    function getQueryParam(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    /**
     * Reloads the current state.
     */
    function reload() {
      $state.reload();
    }
    
    return {
      back: back,
      current: current,
      getFullName: getFullName,
      getName: getName,
      getParam: getParam,
      getParams: getParams,
      getQueryParam: getQueryParam,
      go: go,
      goTo: goTo,
      index: index,
      login: login,
      logout: logout,
      reload: reload
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('app.shared.services')
    .factory('QuickPanelService', QuickPanelService);

  /** @ngInject */
  function QuickPanelService(
    $mdSidenav,
    APP,
    BROADCAST,
    BroadcastService,
    IssueService
  ) {

    /**
     * Closes the panel.
     */
    function close() {
      $mdSidenav('quick-panel').close().then(function () {
        BroadcastService.broadcast(BROADCAST.QUICK_PANEL.CLOSE);
      });
    }

    /**
     * Check if panel is open.
     */
    function isOpen() {
      return $mdSidenav('quick-panel').isOpen();
    }

    /**
     * Opens the panel.
     * @param {*} issueId 
     */
    function open(issueId, clear) {
      var recentIssueId = issueId || IssueService.getRecentIssue().id;

      if (!recentIssueId)
        return;
      
      if (clear)
        BroadcastService.broadcast(BROADCAST.QUICK_PANEL.CLEAR);
        
      $mdSidenav('quick-panel').open().then(function () {
        BroadcastService.broadcast(BROADCAST.QUICK_PANEL.OPEN, {
          new: true,
          issueId: recentIssueId
        });
      });
    }

    return {
      close: close,
      isOpen: isOpen,
      open: open
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('app.shared.services')
    .factory('PusherService', PusherService);

  /** @ngInject */
  function PusherService(
    $http,
    $rootScope,
    $window,
    API,
    APP,
    BROADCAST,
    AuthService,
    BroadcastService,
    QuickPanelService,
    StructureService
  ) {

    var PUSHER = APP.PUSHER,
        pusher = null,
        auth = null,
        channels = {
          presence: null,
          conversation: null,
          updates: null
        },
        listeners = [];

    /**
     * Initiate service.
     */
    function init() {
      listeners.push($rootScope.$on(BROADCAST.AUTH.LOGOUT, _onLogout));

      // Init.
      _initPusher();
    }

    /**
     * Start pusher socket.
     */
    function _initPusher() {
      var token = AuthService.getToken();

      if (!token || pusher)
        return;

      pusher = new Pusher(PUSHER.KEY, {
        cluster: PUSHER.CLUSTER,
        authorizer: function(channel, options) {
          return {
            authorize: function(socketId, callback) {
              return $http.post(API.HOST + '/conversations/auth', {
                socket_id: socketId, 
                channel_name: channel.name
              }).then(function(res) {
                callback(false, res.data);
              });
            }
          }
        },
        encrypted: true
      });

      // Callback
      function _onConnected() {
        _subscribeToPresenceChannel();
      }
      
      // Unbind, to prevent double binding
      pusher.connection.unbind(PUSHER.EVENTS.CONNECTED, _onConnected);
      
      // Bind
      pusher.connection.bind(PUSHER.EVENTS.CONNECTED, _onConnected);
    }

    /**
     * Unsubscribe all channels on logout.
     */
    function _onLogout() {
      unsubscribeAll();
    }

    /**
     * Subscribe user to the presence channel.
     */
    function _subscribeToPresenceChannel() {
      if (channels.presence)
        return;
        
      channels.presence = pusher.subscribe('presence-default');

      // Callbacks
      function _onSuccess() {
        BroadcastService.broadcast(BROADCAST.PUSHER.ONLINE);
        _subscribeToConversationChannel();
        _subscribeToUpdatesChannel();
      }
      function _onError(status) {
        console.error('SUBSCRIPTION_ERROR:', status);
      }
      function _onMemberAdded(user) {
        BroadcastService.broadcast(BROADCAST.CHAT.USERS_CHANGED, user);
      }
      function _onMemberRemoved(user) {
        BroadcastService.broadcast(BROADCAST.CHAT.USERS_CHANGED, user);
      }

      // Unbind, to prevent double binding
      channels.presence.unbind(PUSHER.EVENTS.SUBSCRIPTION_SUCCEEDED, _onSuccess);
      channels.presence.unbind(PUSHER.EVENTS.SUBSCRIPTION_ERROR, _onError);
      channels.presence.unbind(PUSHER.EVENTS.MEMBER_ADDED, _onMemberAdded);
      channels.presence.unbind(PUSHER.EVENTS.MEMBER_REMOVED, _onMemberRemoved);

      // Bind
      channels.presence.bind(PUSHER.EVENTS.SUBSCRIPTION_SUCCEEDED, _onSuccess);
      channels.presence.bind(PUSHER.EVENTS.SUBSCRIPTION_ERROR, _onError);
      channels.presence.bind(PUSHER.EVENTS.MEMBER_ADDED, _onMemberAdded);
      channels.presence.bind(PUSHER.EVENTS.MEMBER_REMOVED, _onMemberRemoved);
    }

    /**
     * Subscribes to the updates channel.
     */
    function _subscribeToUpdatesChannel() {
      if (channels.updates)
        return;

      channels.updates = pusher.subscribe('private-general-updates');

      // Callback
      function _onUpdate(event) {
        var user = AuthService.getUser();

        if (!user || !event.conversation || !event.conversation.Client || user.id !== event.conversation.Client.id)
          return;

        switch (event.type) {
          case 'ASSIGNED': BroadcastService.broadcast(BROADCAST.CHAT.ASSIGNED, event.conversation); break;
          case 'CLOSED': BroadcastService.broadcast(BROADCAST.CHAT.CLOSED, event.conversation); break;
          case 'CREATED': BroadcastService.broadcast(BROADCAST.CHAT.CREATED, event.conversation); break;
          case 'DEASSIGNED': BroadcastService.broadcast(BROADCAST.CHAT.DEASSIGNED, event.conversation); break;
        }
      }

      // Unbind, to prevent double binding
      channels.updates.unbind(PUSHER.EVENTS.CONVERSATION_UPDATE, _onUpdate);

      // Bind
      channels.updates.bind(PUSHER.EVENTS.CONVERSATION_UPDATE, _onUpdate);
    }

    /**
     * Subscribes to the user's conversation channel.
     * @param {*} user 
     * @param {*} conversationId 
     */
    function _subscribeToConversationChannel() {
      if (channels.conversation)
        return;

      var USER_TYPES = StructureService.getStructure('LOGIN', 'USER_TYPES'),
          user = AuthService.getUser(),
          userType = (user.user_type == USER_TYPES.CLIENT) ? 'clients' : user.user_type.toLowerCase(),
          channelName = 'private-user-' + userType + '-' + user.id;
      
      // Subscribe to channel.
      channels.conversation = pusher.subscribe(channelName);

      // Callback
      function _onNewMessage(message) {
        if (message && message.author_id != user.id) {
          BroadcastService.broadcast(BROADCAST.CHAT.NEW_MESSAGE, message);
        }
      }

      // Unbind, to prevent double binding
      channels.conversation.unbind(PUSHER.EVENTS.NEW_MESSAGE, _onNewMessage);

      // Bind
      channels.conversation.bind(PUSHER.EVENTS.NEW_MESSAGE, _onNewMessage);
    }

    /**
     * Check if the browser supports notifications.
     */
    function _supportsLocalNotifications() {
      if (!("Notification" in window)) {
        console.log('Este browser não suporta notificações de desktop.');
        return false;
      }
      return true;
    }

    /**
     * Unsubscribe from all channels.
     */
    function unsubscribeAll() {
      var USER_TYPES = StructureService.getStructure('LOGIN', 'USER_TYPES'),
          user = AuthService.getUser(),
          userType = (user.user_type == USER_TYPES.CLIENT) ? 'clients' : user.user_type.toLowerCase(),
          channelName = 'private-user-' + userType + '-' + user.id;

      if (!pusher)
        return;
        
      pusher.unsubscribe('presence-default');
      pusher.unsubscribe(channelName);
      pusher.unsubscribe('private-general-updates');

      channels = {
        presence: null,
        conversation: null,
        updates: null
      };
      pusher = null;
    }

    /**
     * Returns the conversation channel.
     */
    function getConversationChannel() {
      return channels.conversation;
    }
    
    /**
     * Returns an array with all online members' IDs.
     */
    function getStaffIds() {
      return Object.keys(channels.presence.members.members).filter(function (id) {
        return id.indexOf('STAFF') != -1;
      }).map(function (id) {
        return parseInt(id.replace('STAFF_', ''));
      });
    }

    /**
     * Returns the presence channel.
     */
    function getPresenceChannel() {
      return channels.presence;
    }

    /**
     * Check if the pusher is connected and online.
     */
    function isConnected() {
      return pusher && channels.presence;
    }

    /**
     * Asks the user for permission and register for desktop notifications.
     */
    function requestNotificationPermission() {
      // Request permission
      if (_supportsLocalNotifications()) {
        Notification.requestPermission();
      }
    }

    /**
     * Sends a local notification.
     * @param {*} body 
     * @param {*} icon 
     * @param {*} title 
     */
    function sendNotification(title, body) {
      if (!_supportsLocalNotifications())
        return;

      // Send notification
      var options = {
        body: body,
        icon: 'assets/images/logos/favicon-64.ico'
      };
      var n = new Notification(title || 'Nova mensagem', options);

      // Bind click
      n.onclick = function(evt) { 
        $window.focus();
        QuickPanelService.open();
      };

      // Play sound
      var audio = new Audio('assets/sounds/message.ogg');
      if (audio) {
        var playPromise = audio.play();
        
        // In browsers that don’t yet support this functionality,
        // playPromise won’t be defined.
        if (playPromise !== undefined) {
          playPromise.then(function() {
            // Automatic playback started!
          }).catch(function(error) {
            // Automatic playback failed.
            // Show a UI element to let the user manually start playback.
          });
        }
      }
    }

    /**
     * Destroy any broadcast listener.
     */
    $rootScope.$on('$destroy', function () {
      listeners.forEach(function (killListener) {
        killListener();
      });
    });
    
    return {
      getConversationChannel: getConversationChannel,
      getStaffIds: getStaffIds,
      getPresenceChannel: getPresenceChannel,
      init: init,
      isConnected: isConnected,
      requestNotificationPermission: requestNotificationPermission,
      sendNotification: sendNotification,
      unsubscribeAll: unsubscribeAll
    };
  }

})();

(function() {
	'use strict';

	angular
		.module('app.shared.services')
		.factory('ObserverService', ObserverService);

	/** @ngInject */
	function ObserverService(
    HelperService,
    AuthService
	) {

		/**
		 * Abstract method to Observer Model.
		 *
		 * @param  {String} method
		 * @return {Function}
		 */
		function _onObserver(method) {
			return HelperService.handle('ObserverModel', arguments);
		}
		
		/**
		 * Resolve observer properties for showing.
		 *
		 * @param {Object} observer
		 */
		function resolveObserver(observer) {
			if (!observer.invited) {
				observer.status = {
					classes: 'red-800-fg',
					value: 'Convite pendente'
				}
			} else {
				observer.status = {
					classes: observer.activated ? 'green-600-fg' : 'orange-800-fg',
					value: observer.activated ? 'Cadastrado' : 'Convidado'
				}
			}
			
			return observer;
		}

		/**
		 * Preview infos on a single observer.
		 */
		function previewObserver(token) {
			return _onObserver('previewObserver', {
				token: token
			}).then(function (res) {
				return resolveObserver(res.data);
			});
    }
    
    /**
     * Activates a observer.
     */
    function activateObserver(token, observerData) {
      return _onObserver('activateObserver', {
        token: token
      }, observerData).then(function (res) {
        var observer = res.data;
        return resolveObserver(observer);
      });
    }

    /**
     * Updates an observer.
     *
     * @param {Object} observerData
     * @returns {Object} created observer
     */
    function updateObserver(observerData) {
      observerData.userId = observerData.id;
      return _onObserver('updateObserver', null, observerData)
      .then(function(resp) {
        var observer = resp.data;
        
        if (observer.id == AuthService.getUser('id'))
          AuthService.setUser(observer);
      })
    }

		return {
      previewObserver: previewObserver,
      activateObserver: activateObserver,
      updateObserver: updateObserver
		};
	}

})();

(function() {
  'use strict';

  angular
    .module('app.shared.services')
    .factory('LocationService', LocationService);

  /** @ngInject */
  function LocationService(
    localStorageService,
    HelperService
  ) {
    
    var STATES = null;
    
    /**
     * Abstract method to Location Model.
     *
     * @param  {String} method
     * @return {Function}
     */
    function _onLocation(method) {
      return HelperService.handle('LocationModel', arguments);
    }
    
    /**
     * Abstract method to Zipcode Model.
     *
     * @param  {String} method
     * @return {Function}
     */
    function _onZipcode(method) {
      return HelperService.handle('ZipcodeModel', arguments);
    }
    
    /**
     * Resolves a zipcode.
     *
     * @param {String} zipcode
     * @returns {Object} address
     */
    function resolve(zipcode) {
      return _onZipcode('resolveZipcode', null, {
        zipcode: zipcode
      }).then(function (res) {
        return res;
      });
    }
    
    /**
     * Fetch states from API.
     */
    function fetchStates() {
      return _onLocation('getStates').then(function (res) {
        STATES = res.data || res;
        localStorageService.set('states', STATES);
        return STATES;
      });
    }
    
    /**
     * Return a state ID by it's string code.
     */
    function getStateByCode(code) {
      var states = getStates();
      
      return states.filter(function (state) {
        return state.code == code;
      })[0];
    }
    
    /**
     * Return a state by it's ID.
     */
    function getStateById(stateId) {
      var states = getStates();
      
      return states.filter(function (state) {
        return state.id == stateId;
      })[0];
    }
    
    /**
     * Returns a list of all states.
     */
    function getStates() {
      if (!STATES)
        STATES = localStorageService.get('states');
      return STATES;
    }
    
    return {
      fetchStates: fetchStates,
      getStateByCode: getStateByCode,
      getStateById: getStateById,
      getStates: getStates,
      resolve: resolve
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('app.shared.services')
    .factory('LoaderService', LoaderService);

  /** @ngInject */
  function LoaderService(
    BROADCAST,
    $timeout,
    BroadcastService
  ) {

    /**
     * Hides the loader.
     *
     * @param {Number} loaderId
     */
    function hide(loaderId) {
      var time = $timeout(function() {
        BroadcastService.broadcast(BROADCAST.LOADER.STOP, loaderId);
        $timeout.cancel(time);
      }, 1);
    }

    /**
     * Hides the global loader.
     */
    function hideGlobal() {
      hide('globalLoader');
    }

    /**
     * Hides the login loader.
     */
    function hideLogin() {
      hide('loginLoader');
    }

    /**
     * Shows the loader.
     *
     * @param {Number} loaderId
     * @param {Object} configs
     */
    function show(loaderId, configs) {
      configs = configs || {};
      var time = $timeout(function() {
        BroadcastService.broadcast(BROADCAST.LOADER.START, loaderId, configs);
        $timeout.cancel(time);
      }, 1);
    }

    /**
     * Shows the global loader.
     */
    function showGlobal() {
      show('globalLoader');
    }

    /**
     * Shows the login loader.
     */
    function showLogin() {
      show('loginLoader');
    }

    return {
      hide: hide,
      hideGlobal: hideGlobal,
      hideLogin: hideLogin,
      show: show,
      showGlobal: showGlobal,
      showLogin: showLogin
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('app.shared.services')
    .factory('IssueService', IssueService);

  /** @ngInject */
  function IssueService(
    $filter,
    $rootScope,
    API,
    BROADCAST,
    ClientService,
    HelperService,
    StructureService
  ) {
    
    var METHODS = API.METHODS,
        recentIssue = null,
        listeners = [];

    function _init() {
      listeners.push($rootScope.$on(BROADCAST.AUTH.LOGOUT, _onLogout));
    }

    _init();

    /**
     * Abstract method to Issue Model.
     *
     * @param  {String} method
     * @return {Function}
     */
    function _onIssue(method) {
      return HelperService.handle('IssueModel', arguments);
    }

    // Clear recent issue on logout.
    function _onLogout() {
      recentIssue = null;
    }
    
    /**
     * Resolve issue properties for showing.
     *
     * @param {Object} issue
     */
    function _resolveIssue(issue) {
      
      // Accident
      if (issue.Accident) {
        issue.accident = issue.Accident;
        delete issue.Accident;
        
        // Date / Time
        if (issue.accident.happened_at_date)
          issue.accident.happened_at_date += 'T00:00:00';
        if (issue.accident.happened_at_time)
          issue.accident.happened_at_time = issue.accident.happened_at_time.substring(0, 5);
      }
      
      // Client
      if (issue.Client) {
        issue.client = issue.Client;
        delete issue.Client;
      }
      if (issue.client)
        issue.client = ClientService.resolveClient(issue.client);
      
      // Status
      var STATUS = StructureService.getStructure('ISSUE', 'STATUS');
      
      if (issue.status == STATUS.PENDING) {
        issue.readable_status = {
          classes: 'orange-800-fg',
          value: $filter('issueStatus')(issue.status)
        }
      } else {
        issue.readable_status = {
          classes: 'grey-500-fg',
          value: $filter('issueStatus')(issue.status)
        }
      }
      
      return issue;
    }
    
    /**
     * Gets all of the client's issues.
     */
    function getClientIssues(clientId, page, options) {
      var queryOptions = angular.extend({}, {
        by_client_id: clientId,
        page: page || 1,
        per_page: 3
      }, options);
      return _onIssue('getIssues', queryOptions).then(function (res) {
        var issues = res.data.map(_resolveIssue),
            pagination = HelperService.getPagination(res);

        if (!recentIssue && issues.length)
          recentIssue = issues[0];
            
        return {
          issues: issues,
          pagination: pagination
        }
      });
    }

    /**
     * Get issue by id.
     */
    function getIssue(issueId) {
      return _onIssue('getIssue', {
        complete: true
      }, {
        issueId: issueId
      }).then(function (res) {
        var issue = _resolveIssue(res.data);

        if (!recentIssue && issue.length)
          recentIssue = issue;
            
        return issue
      });
    }

    /**
     * Gets the client's most recent issue.
     */
    function getRecentIssue() {
      return recentIssue;
    }
    
    /**
     * Updates an issue.
     *
     * @param {Object} issueData
     * @returns {Object} updated issue
     */
    function updateIssue(issueData) {
      issueData.issueId = issueData.id;
      return _onIssue('updateIssue', null, issueData).then(function (res) {
        var issue = res.data;
        return _resolveIssue(issue);
      });
    }

    /**
     * Gets all issues of a observer.
     */
    function getObserverIssues(observerId, page, options) {
      var queryOptions = angular.extend({}, {
        page: page || 1,
        per_page: 3
      }, options);

      return _onIssue('getIssuesByObserver', queryOptions, {
        observerId: observerId
      }).then(function (res) {
        var issues = res.data.map(_resolveIssue),
            pagination = HelperService.getPagination(res);
            
        return {
          issues: issues,
          pagination: pagination
        }
      });
    }

    /**
     * Send a message to an issue
     * 
     * @param {Number} issueId 
     * @param {String} message 
     */
    function sendMessage(issueId, message) {
      return _onIssue('sendMessage', {
        issueId: issueId,
        message: message
      })
    }

    /**
     * Destroy any broadcast listener.
     */
    $rootScope.$on('$destroy', function () {
      listeners.forEach(function (killListener) {
        killListener();
      });
    });

    return {
      getClientIssues: getClientIssues,
      getRecentIssue: getRecentIssue,
      updateIssue: updateIssue,
      getObserverIssues: getObserverIssues,
      getIssue: getIssue,
      sendMessage: sendMessage
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('app.shared.services')
    .factory('InfoBarService', InfoBarService);

  /** @ngInject */
  function InfoBarService(
    BROADCAST,
    $timeout,
    AuthService,
    BroadcastService,
    StateService
  ) {
    
    var INFOBAR_HIDE_DELAY = 3000;
    
    /**
     * Resolve the error and extract the message.
     *
     * @param {Object} err
     */
    function error(err) {
      var data = err.data;
      if (data && data.message)
        show(data.message);
      else if (data && data.errors)
        show(data.errors);
      else if (err.status && err.status != -1)
        show([err.statusText]);
        
      if (err.status == 401)
        AuthService.logout();
    }
    
    /**
     * Hides the infobar.
     */
    function hide() {
      BroadcastService.broadcast(BROADCAST.INFOBAR.HIDE);
    }
    
    /**
     * Shows the infobar with a message.
     *
     * @param {String} message
     */
    function show(message, success) {
      if (!Array.isArray(message))
        message = [message];
      BroadcastService.broadcast(BROADCAST.INFOBAR.SHOW, {
        message: message,
        success: success
      });
      
      $timeout(hide, INFOBAR_HIDE_DELAY);
    }
    
    /**
     * Shorthand to show(message, true) method.
     */
    function success(message) {
      show(message, true);
    }
    
    return {
      error: error,
      hide: hide,
      show: show,
      success: success
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('app.shared.services')
    .factory('HelperService', HelperService);

  /** @ngInject */
  function HelperService($http, $injector, $rootScope) {
    
    var HOST = '',
        MODELS = {},
        cancelables = [];
    
    /**
     * Helper constructor
     * 
     * @param {String} endpoint
     */
    function Helper(endpoint) {
      if (!(this instanceof Helper)) {
        return new Helper(endpoint);
      }
      this.endpoint = endpoint + '/';
    };

    Helper.prototype = {
      request: function(method, predicate, data) {
        var endpoint = this.endpoint;
        return request(endpoint, method, predicate, data);
      },
      getPage: getPage,
      buildRoute: buildRoute,
      handle: handle
    };
    
    /**
     * Abstract method to a given Model that implements 
     * the $resource service.
     *
     * @param  {String} ModelName
     * @param  {Array} args
     * @return {Promise}
     */
    function handle(ModelName, args) {
      if (!ModelName || !args || !args.length) throw 'You can\'t call HelperService.handle without a Model Class and a list of arguments';
      args = [].slice.call(args);
      
      var method = args[0],
          Model = MODELS[ModelName] || $injector.get(ModelName),
          requestCancelable = true,
          request;
      
      if (!MODELS[ModelName]) MODELS[ModelName] = Model;

      if (!Model[method]) throw 'HelperService.handle can\'t call ' + method + '() method.';

      args = args.splice(1);

      args.forEach(function(arg) {
        if (arg && arg.CANCELABLE === false) {
          requestCancelable = false;
          delete arg.CANCELABLE;
        }
      });

      request = Model[method].apply(Model, args);

    if (angular.isFunction(request.$cancelRequest) && requestCancelable) {
      cancelables.push(request);
    }

      return request.$promise;
    };

    /**
     * Abstract method to a given endpoint
     * 
     * @param  {String} method
     * @param  {String} predicate
     * @param  {Object} data
     * @return {Promise}
     */
    function request(endpoint, method, predicate, data) {
      var methods = ['GET', 'POST', 'DELETE', 'PUT'];
      if (!method || methods.indexOf(method.toString().toUpperCase()) === -1) {
        data = predicate;
        predicate = method;
        method = 'GET';
      }
      if (endpoint[endpoint.length - 1] !== '/') endpoint += '/';
      method = method.toLowerCase();
      predicate = (predicate) ? predicate : '';
      return $http[method](HOST + endpoint + predicate, data);
    };

    /**
     * Returns the next page of a pagination
     * 
     * @param  {Object} pagination
     * @return {Number}
     */
    function getPage(pagination) {
      pagination = pagination || {};
      return pagination.next_page || 1;
    };

    /**
     * Returns the pagination info inside an object.
     * 
     * @param  {Response} res
     * @return {Object} pagination
     */
    function getPagination(res) {
      var pagination = {
        page: res.page,
        per_page: res.per_page,
        total: res.total,
        total_pages: Math.ceil(res.total / res.per_page)
      }
      return pagination;
    };

    /**
     * Creates a new route object for $resource Service
     * 
     * @param  {String} method
     * @param  {Object} params
     * @return {Object}
     */
    function buildRoute(method, params, options) {
      return angular.extend({}, {
        method: method,
        params: params,
        cancellable: true
      }, options);
    };

    $rootScope.$on('$stateChangeStart', _cancelAllRequests);      
    
    /**
     * Cancels all requests on state change or broadcast event.
     */
    function _cancelAllRequests() {
      if (!cancelables)
        cancelables = [];
      
      cancelables.forEach(function(cancelable) {
        if (cancelable) {
          cancelable.$cancelRequest();
        }
      });
      cancelables = [];
    }

    return {
      getPage           : getPage,
      getPagination     : getPagination,
      request           : request,
      buildRoute        : buildRoute,
      handle            : handle,
      Helper            : Helper
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('app.shared.services')
    .factory('DocumentService', DocumentService);

  /** @ngInject */
  function DocumentService(
    $filter,
    API,
    HelperService,
    Upload
  ) {

    /**
     * Abstract method to Issue Model.
     *
     * @param  {String} method
     * @return {Function}
     */
    function _onIssue(method) {
      return HelperService.handle('IssueModel', arguments);
    }
    
    /**
     * Resolve document properties for showing.
     *
     * @param {Object} document
     */
    function resolveDocument(document) {

      // Image
      if (document.resource) {
        document.img = document.resource.resized;
      }
      
      // Status
      if (!document.uploaded_at)
        document.status = 'pending_upload';
      else if (!document.reviewed_at)
        document.status = 'pending_review';
      else if (document.valid)
        document.status = 'approved';
      else
        document.status = 'rejected';

      // Document
      if (document.Document) {
        document.document = document.Document;
        delete document.Document;
      }

      // Uploaded Document
      if (document.UploadedDocument) {
        document.uploaded_document = document.UploadedDocument;
        delete document.UploadedDocument;
      }

      return document;
    }
    
    /**
     * Gets documents of an issue.
     */
    function getIssueDocuments(issueId, options) {
      return _onIssue('getDocuments', options, {
        issueId: issueId
      }).then(function (res) {
        return res.data.map(resolveDocument);
      });
    }

    /**
     * Uploads a document to S3 and updates the API.
     *
     * @param {Object} document
     */
    function uploadDocumentFile(issueId, file, document) {
      if (!document.uploaded_document)
        return;

      var uploadUrl = document.uploaded_document.upload_url;
      var typeDoc = 'image';

      if(file.type == 'application/pdf')
      {
        typeDoc = 'pdf';
      }

      return Upload.http({
        url: uploadUrl,
        data: file,
        method: API.METHODS.PUT,
        headers: { 'Content-Type': file.type }
      }).then(function (res) {
        return _onIssue('activateDocumentFile', null, {
          issueId: issueId,
          documentId: document.id,
          typeDocument: typeDoc
        }).then(function (res) {
          return resolveDocument(res.data);
        });
      });
    }
    
    return {
      getIssueDocuments: getIssueDocuments,
      resolveDocument: resolveDocument,
      uploadDocumentFile: uploadDocumentFile
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('app.shared.services')
    .factory('DialogService', DialogService);

  /** @ngInject */
  function DialogService(
    $document, 
    $mdDialog, 
    OPERATION,
    i18n
  ) {

    var DIALOGS_PATH = 'app/main/partials/dialogs';

    /**
     * Base dialog builder.
     */
    function _baseDialog(options) {
      options = angular.extend({}, {
        controller: 'DialogController',
        controllerAs: 'vm',
        clickOutsideToClose: true,
        parent: angular.element($document.body),
        locals: {
          options: {}
        }
      }, options);

      return $mdDialog.show(options);
    }

    /**
     * User profile dialog.
     */
    function _userProfile(user, operation, logged) {
      return _baseDialog({
        controller: 'UserProfileDialogController',
        templateUrl: DIALOGS_PATH + '/user-profile/user-profile-dialog.html',
        locals: {
          user: user,
          operation: operation,
          isLogged: logged
        }
      });
    }

    /**
     * Cancel dialog function wrapper.
     */
    function cancel(options) {
      $mdDialog.cancel(options);
    }

    /**
     * Confirmation dialog.
     *
     * @param {Object} options (title, message, ok text, cancel text)
     */
    function confirm(options) {
      return _baseDialog({
        templateUrl: DIALOGS_PATH + '/confirm/confirm-dialog.html',
        locals: {
          title: options.title || 'Confirmar',
          message: options.message,
          ok: options.ok || 'OK',
          cancel: options.cancel || 'Cancelar'
        }
      });
    }

    /**
     * Chat history dialog.
     *
     * @param {Object} chat
     */
    function chatHistory(chat, chatId) {
      return _baseDialog({
        templateUrl: DIALOGS_PATH + '/chat-history/chat-history-dialog.html',
        controller: 'ChatHistoryDialogController',
        multiple: false,
        locals: {
          chat: chat,
          chatId: chatId
        }
      });
    }

    /**
     * User creation dialog.
     */
    function createUser() {
      return _userProfile(null, OPERATION.CREATE);
    }

    /**
     * Document review modal.
     *
     * @param {Object} document
     * @param {Object} options
     */
    function documentPreview(document) {
      return _baseDialog({
        templateUrl: DIALOGS_PATH + '/document-preview/document-preview-dialog.html',
        controller: 'DocumentPreviewDialogController',
        locals: {
          document: document
        }
      });
    }

    /**
     * Hide dialog function wrapper.
     */
    function hide(options) {
      $mdDialog.hide(options);
    }

    /**
     * Terms dialog.
     */
    function terms() {
      return _baseDialog({
        templateUrl: DIALOGS_PATH + '/terms/terms-dialog.html'
      });
    }
    
    /**
     * Unsaved changes confirmation dialog.
     */
    function unsavedChanges() {
      return confirm({
        title: i18n.t('APP.UNSAVED_CHANGES_TITLE'),
        message: i18n.t('APP.UNSAVED_CHANGES_MESSAGE'),
        ok: i18n.t('APP.UNSAVED_CHANGES_LEAVE'),
        cancel: i18n.t('APP.UNSAVED_CHANGES_STAY')
      });
    }
    
    /**
     * User update dialog.
     */
    function updateUser(user, logged) {
      return _userProfile(user, OPERATION.UPDATE, logged);
    }

    return {
      cancel: cancel,
      chatHistory: chatHistory,
      confirm: confirm,
      createUser: createUser,
      documentPreview: documentPreview,
      hide: hide,
      terms: terms,
      unsavedChanges: unsavedChanges,
      updateUser: updateUser
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('app.shared.services')
    .factory('CompletionBarService', CompletionBarService);

  /** @ngInject */
  function CompletionBarService(
    BROADCAST,
    BroadcastService
  ) {
    
    var DEFAULT_PROGRESS = 10,
        currentProgress = 0;
        
    /**
     * Adds a given amount to the current progress.
     *
     * @param {Number} progressStep
     */
    function add(progressStep) {
      var newProgress = currentProgress + progressStep;
      update(newProgress);
    }
    
    /**
     * Hides the completion bar.
     */
    function hide() {
      BroadcastService.broadcast(BROADCAST.COMPLETION_BAR.HIDE);
    }
    
    /**
     * Shows the completion bar with a progress value.
     *
     * @param {Number} progress
     */
    function show(progress) {
      BroadcastService.broadcast(BROADCAST.COMPLETION_BAR.SHOW);
      update(progress || DEFAULT_PROGRESS);
    }
    
    /**
     * Updates the completion bar with a progress value.
     *
     * @param {Number} progress
     */
    function update(progress) {
      currentProgress = progress;
      BroadcastService.broadcast(BROADCAST.COMPLETION_BAR.UPDATE, {
        progress: progress
      });
    }
    
    return {
      add: add,
      hide: hide,
      show: show,
      update: update
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('app.shared.services')
    .factory('ClientService', ClientService);

  /** @ngInject */
  function ClientService(
    API,
    AuthService, 
    HelperService
  ) {
    
    var METHODS = API.METHODS;

    /**
     * Abstract method to Client Model.
     *
     * @param  {String} method
     * @return {Function}
     */
    function _onClient(method) {
      return HelperService.handle('ClientModel', arguments);
    }
    
    /**
     * Activates a client.
     */
    function activateClient(token, clientData) {
      return _onClient('activateClient', {
        token: token
      }, clientData).then(function (res) {
        var client = res.data;
        return resolveClient(client);
      });
    }
    
    /**
     * Preview infos on a single client.
     */
    function previewClient(token) {
      return _onClient('previewClient', {
        token: token
      }).then(function (res) {
        return resolveClient(res.data);
      });
    }
    
    /**
     * Resolve client properties for showing.
     *
     * @param {Object} client
     */
    function resolveClient(client) {
      if (!client.invited) {
        client.status = {
          classes: 'red-800-fg',
          value: 'Convite pendente'
        }
      } else {
        client.status = {
          classes: client.activated ? 'green-600-fg' : 'orange-800-fg',
          value: client.activated ? 'Cadastrado' : 'Convidado'
        }
      }
      
      return client;
    }
    
    /**
     * Updates an client.
     *
     * @param {Object} clientData
     * @returns {Object} updated client
     */
    function updateClient(clientData) {
      clientData.clientId = clientData.id;
      return _onClient('updateClient', null, clientData).then(function (res) {
        var client = resolveClient(res.data);
        
        if (client.id == AuthService.getUser('id'))
          AuthService.setUser(client);
        
        return client;
      });
    }

    return {
      activateClient: activateClient,
      previewClient: previewClient,
      resolveClient: resolveClient,
      updateClient: updateClient
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('app.shared.services')
    .factory('ChatService', ChatService);

  /** @ngInject */
  function ChatService(
    HelperService,
    PusherService
  ) {

    /**
     * Abstract method to Conversation Model.
     *
     * @param  {String} method
     * @return {Function}
     */
    function _onConversation(method) {
      return HelperService.handle('ConversationModel', arguments);
    }

    /**
     * Creates a chat.
     */
    function createChat(clientId, issueId) {
      return _onConversation('createConversation', null, {
        client_id: clientId, 
        issue_id: issueId 
      }).then(function (res) {
        return resolveChat(res.data);
      });
    }

    /**
     * Gets a single chat.
     */
    function getChat(chatId) {
      return _onConversation('getConversation', null, {
        conversationId: chatId
      }).then(function (res) {
        return resolveChat(res.data);
      });
    }

    /**
     * Gets all of the issue's chats.
     */
    function getIssueChats(issueId) {
      var options = {
        issue_id: issueId,
        active: false
      };
      return _onConversation('getConversations', options).then(function (res) {
        return res.data.map(resolveChat);
      });
    }

    /**
     * Get conversation messages.
     */
    function getMessages(conversationId, page, options) {
      var queryOptions = angular.extend({}, {
        page: page || 1
      }, options);
      return _onConversation('getMessages', queryOptions, {
        conversationId: conversationId
      }).then(function (res) {
        var messages = res.data.sort(function(a, b) {
              return a.id - b.id;
            }),
            pagination = HelperService.getPagination(res);
        return {
          messages: messages,
          pagination: pagination
        };
      });
    }

    /**
     * Resolve chat properties for showing.
     *
     * @param {Object} chat
     */
    function resolveChat(newChat) {
      var chat = angular.copy(newChat);

      // Client
      if (chat.Client || chat.Client === null) {
        chat.client = chat.Client;
        delete chat.Client;
      }
      
      // Staff
      if (chat.Staff || chat.Staff === null) {
        chat.staff = chat.Staff;
        delete chat.Staff;
      }

      // User
      chat.user = chat.staff;

      // Date and time
      chat.date = chat.created_at;
      chat.time = chat.created_at;

      // Online / offline.
      var onlineIds = PusherService.getStaffIds();

      if (chat.staff_id && onlineIds.indexOf(chat.staff_id) != -1) {
        chat.status = 'online';
      } else {
        chat.status = 'offline';
      }

      return chat;
    }
    
    /**
     * Send conversation message.
     */
    function sendMessage(conversationId, message) {
      return _onConversation('sendMessage', null, {
        conversationId: conversationId,
        message: message
      }).then(function (res) {
        return res.data;
      });
    }
    
    return {
      createChat: createChat,
      getChat: getChat,
      getIssueChats: getIssueChats,
      getMessages: getMessages,
      resolveChat: resolveChat,
      sendMessage: sendMessage,
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('app.shared.services')
    .factory('BroadcastService', BroadcastService);

  /** @ngInject */
  function BroadcastService($rootScope, $timeout) {
    
    var DELAY = 250;

    /**
     * Broadcasts an event.
     *
     * @param {String} eventId
     * @param {Object} params
     */
    function broadcast(eventId, params, delayed) {
      if (delayed) {
        $timeout(function () {
          $rootScope.$broadcast(eventId, params);
        }, DELAY);
      } else
        $rootScope.$broadcast(eventId, params);
    }

    return {
      broadcast: broadcast
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('app.shared.services')
    .factory('AuthService', AuthService);

  /** @ngInject */
  function AuthService(
    $rootScope, 
    ACCESS, 
    BROADCAST, 
    localStorageService, 
    BroadcastService, 
    HelperService,
    LocationService,
    StateService,
    StructureService
  ) {

    /**
     * Initialize the service setting login status to $rootScope.
     */
    function _init() {
      var loggedUser = getUser();

      if (loggedUser) {
        $rootScope.currentUser = loggedUser;
        BroadcastService.broadcast(BROADCAST.AUTH.LOGIN);
      }
    }

    /**
     * Abstract method to Auth Model.
     *
     * @param  {String} method
     * @return {Function}
     */
    function _onAuth(method) {
      return HelperService.handle('AuthModel', arguments);
    }

    /**
     * Saves a new login session.
     */
    function _setLogged(res) {
      var token = res.token,
          user = res.user;

      if (token && user) {
        _setToken(token);
        setUser(user);
        $rootScope.currentUser = user;
        BroadcastService.broadcast(BROADCAST.AUTH.LOGIN);
        return user;
      } else {
        return null;
      }
    }

    /**
     * Destroys current session.
     */
    function _setNotLogged() {
      BroadcastService.broadcast(BROADCAST.AUTH.LOGOUT);
      setUser(null);
      _setToken(null, null);
      $rootScope.currentUser = null;
    }
    
    /**
     * Set token.
     */
    function _setToken(token) {
      localStorageService.set('access-token', token);
    }

    /**
     * Returns current logged user's token.
     *
     * @return {String}
     */
    function getToken() {
      var token = localStorageService.get('access-token');
      return token;
    }

    /**
     * Returns current logged user or one of its properties.
     *
     * @param  {String} key
     * @return {Object}
     */
    function getUser(key) {
      var user = localStorageService.get('user');
      return user ? ((key && user[key]) ? user[key] : user) : null;
    }

    /**
     * Check if user has 'admin' role.
     */
    function hasAdminAccessOnly() {
      return getUser('access_level') === 'ADMIN';
    }

    /**
     * Returns if current user has access based on a given array or access level.
     *
     * @param {Array | Number} access
     * @returns {Boolean}
     */
    function is(access) {
      var role = getUser('access_level'),
        ONLINE = ACCESS.ONLINE,
        token = getToken();
        
      if (!token)
        return false;

      if (angular.isArray(access)) {
        return access.some(function(item) {
          return is(item);
        });
      }

      switch (access) {
        case ONLINE.PUBLIC:
          return true;
        case ONLINE.ADMIN:
          return hasAdminAccessOnly();
      }
    }

    /**
     * Returns true if exists a login session.
     *
     * @return {Boolean}
     */
    function isLogged() {
      return !!getUser() && getToken();
    }

    /**
     * Login a admin user.
     *
     * @param {Object} credentials
     */
    function login(credentials) {
      var user = null;
      
      return _onAuth('login', null, credentials).then(function(res) {
        if (res.errors)
          return res.errors;
        else if (res.message)
          return res.message;
        else {
          user = _setLogged(res);
        }
      })
      .then(StructureService.fetchStructures)
      .then(LocationService.fetchStates)
      .then(function () {
        return user;
      });
    }

    /**
     * Login via token.
     */
    function tokenLogin(token) {
      return login({token: token});
    }

    /**
     * Main method to logout a user.
     *
     * @param {Object} credentials
     */
    function logout(blockRedirect) {
      _setNotLogged(); 
      if (blockRedirect)
        return;
      StateService.logout();
    }

    /**
     * Request password reset.
     *
     * @param {Object} data
     */
    function requestPasswordReset(data) {
      return _onAuth('requestPasswordReset', null, data).then(function(res) {
        return res;
      });
    }

    /**
     * Set user when updated.
     *
     * @param {Object} user
     */
    function setUser(user) {
      localStorageService.set('user', user);
      BroadcastService.broadcast(BROADCAST.AUTH.UPDATED, user);
    }

    /**
     * Check if params are a valid reset password token.
     * @param {*} params
     */
    function validateResetPwdParams(params) {
      return !!(params.token && params.uid && params.client_id)
    }

    /**
     * Sets auth params for next request.
     * @param {*} data
     */
    function _setAuthData(data) {
      localStorageService.set('access-token', data.token);
      localStorageService.set('access-token-expiry', data.client_id);
    }

    /**
     * Updates User Password.
     * @param {String} password
     * @param {String} confirmation
     * @param {*} authData
     */
    function updatePassword(password, confirmation, authData) {
      _setAuthData(authData);
      var data = {
        password: password,
        password_confirmation: confirmation,
      }

      return _onAuth('updatePassword', null, data)
        .then(function(res) {
          setUser(res.data);
          return res;
        }, function(res) {
          return res;
        });
    }

    function resetPassword(data) {
      return _onAuth('resetPassword', null, data).then(function(res) {
        return res;
      });
    }

    /**
     * Return true if user logged is client
     * @return {Boolean}
     */
    function isClient() {
      var USER_TYPES = StructureService.getStructure('LOGIN', 'USER_TYPES');
      return USER_TYPES && getUser() && USER_TYPES.CLIENT == getUser().user_type;
    }

    _init();

    return {
      getToken: getToken,
      getUser: getUser,
      hasAdminAccessOnly: hasAdminAccessOnly,
      is: is,
      isLogged: isLogged,
      login: login,
      logout: logout,
      requestPasswordReset: requestPasswordReset,
      setUser: setUser,
      validateResetPwdParams: validateResetPwdParams,
      updatePassword: updatePassword,
      isClient: isClient,
      resetPassword: resetPassword,
      tokenLogin: tokenLogin
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('app.shared.services')
    .factory('ActivityService', ActivityService);

  /** @ngInject */
  function ActivityService(
    $filter,
    TARGET,
    DocumentService,
    HelperService,
    StructureService,
    $q,
    AuthService
  ) {

    var TYPE = StructureService.getStructure('ACTIVITY', 'TYPE');

    /**
     * Abstract method to Issue Model.
     *
     * @param  {String} method
     * @return {Function}
     */
    function _onIssue(method) {
      return HelperService.handle('IssueModel', arguments);
    }

    /**
     * Gets activities of an issue.
     */
    function getIssueActivities(issueId, page, options) {
      var queryOptions = angular.extend({}, {
        page: page || 1,
        per_page: 5
      }, options);
      return _onIssue('getActivities', queryOptions, {
        issueId: issueId
      }).then(function (res) {
        var activities = res.data.map(_resolveActivity),
            pagination = HelperService.getPagination(res);

        return {
          activities: activities,
          pagination: pagination
        }
      });
    }

    /**
     * Get activity details object for a given activity type.
     *
     * @param {Enum} activityType
     */
    function _getActivityDetail(activity) {
      var details = {};
      var moreDetailClick = AuthService.isClient() ? 'Para mais detalhes, clique no botão abaixo.' : '';
      var moreDetailClickDocument = AuthService.isClient() ? 'Para ver outros documentos, clique no botão abaixo.' : '';
      var moreDetailClickConversation = AuthService.isClient() ? 'Para visualizá-la, clique no botão abaixo.' : '';

      // ISSUES
      if (activity.target_type == TARGET.ISSUES) {
        var issueId = $filter('numberFixedLen')(activity.target.id, 5);
        details.button = {
          text: 'Ver Detalhes'
        }

        if (activity.type == TYPE.ISSUE_CREATE)
          details.message = 'O chamado #' + issueId + ' foi criado. ' + moreDetailClick;
        else if (activity.type == TYPE.ISSUE_UPDATE)
          details.message = 'Houve uma interação no chamado #' + issueId + '. ' + moreDetailClick;
        else if (activity.type == TYPE.ISSUE_CLOSE)
          details.message = 'O chamado #' + issueId + ' foi encerrado. ' + moreDetailClick;

      // DOCUMENTS
      } else if (activity.target_type == TARGET.DOCUMENTS) {
        var docName = activity.target.document ? activity.target.document.name : 'undefined',
            userName = activity.user.company_fantasy_name || activity.user.name,
            docApproval = activity.target.valid ? 'aprovado' : 'recusado';
        details.button = {
          text: 'Ver Documentos'
        }

        if (activity.type == TYPE.DOCUMENT_CREATE)
          details.message = 'O documento ' + docName + ' foi criado no sistema. ' + moreDetailClick;
        else if (activity.type == TYPE.DOCUMENT_REVIEW)
          details.message = 'O documento ' + docName + ' foi ' + docApproval + '. ' + moreDetailClick;
        else if (activity.type == TYPE.DOCUMENT_UPLOAD)
          details.message = 'O cliente ' + userName + ' fez upload do documento: ' + docName + '.';
        else if (activity.type == TYPE.DOCUMENT_DELETE)
          details.message = 'O documento ' + docName + ' foi excluído no sistema. ' + moreDetailClickDocument;

      // MESSAGES
      } else if (activity.target_type == TARGET.MESSAGE) {
        var userName = activity.user.name,
            userLevel = activity.user.access_level ? $filter('roleName')(activity.user.access_level).toLowerCase() : 'interessado',
            message = activity.target.message;
        if (activity.type == TYPE.MESSAGE_CREATE)
          details.message = 'Uma mensagem foi enviada pelo ' + userLevel + ' ' + userName + ':\n' + message;

      // CONVERSATION
      } else if (activity.target_type == TARGET.CONVERSATION) {
        details.button = {
          text: 'Ver Conversa'
        }
        if (activity.type == TYPE.CONVERSATION_CREATE) {
          details.message = 'Uma conversa foi iniciada no sistema. ' + moreDetailClickConversation;
        } else if (activity.type == TYPE.CONVERSATION_CLOSE) {
          details.message = 'Uma conversa foi encerrada no sistema. ' + moreDetailClickConversation;
        }

      // CLIENTS
      } else if (activity.target_type == TARGET.CLIENTS || activity.target_type == TARGET.CLIENTS_T) {
        var clientName = activity.target.company_fantasy_name || activity.target.name;
        if (activity.type == TYPE.CLIENT_INVITE) {
          details.message = 'Um convite foi enviado para o cliente ' + clientName + '.';
        }
      // OBSERVER
      } else if (activity.target_type == TARGET.OBSERVERS || activity.target_type == TARGET.OBSERVERS_T) {
        var observerName = activity.target.company_fantasy_name || activity.target.name;

        details.message = 'O interessado ' + observerName + ' foi ' + (activity.type == TYPE.OBSERVER_ADDED ? 'adicionado' : 'removido') + '(a) no chamado.';
      }

      if (!AuthService.isClient()) details.button = null;

      return details;
    }

    /**
     * Resolve activity properties for showing.
     *
     * @param {Object} activity
     */
    function _resolveActivity(activity) {

      // Date and time
      activity.date = activity.created_at;
      activity.time = activity.created_at;

      // Document
      if (activity.target_type == TARGET.DOCUMENTS) {
        activity.target = DocumentService.resolveDocument(activity.target);
      }

      // Details
      activity.details = _getActivityDetail(activity);

      // Type
      activity.type = $filter('activityType')(activity.type);

      return activity;
    }

    function getActivitiesForObserver(issues, page, options) {
      var defer = $q.defer(),
          allPromises = null;

      allPromises = issues.map(function(issue) {
        return getIssueActivities(issue.id, page, options)
        .then(function(res) {
          issue.activities = {
            items: [],
            pagination: null
          };
  
          issue.activities.items = res.activities;
          issue.activities.pagination = res.pagination;
        })
      });

      $q.all(allPromises).then(function(resolved) {
        defer.resolve(resolved);
      }, function(err) {
        defer.resolve(err);
      });

      return defer.promise;
    }

    return {
      getIssueActivities: getIssueActivities,
      getActivitiesForObserver: getActivitiesForObserver
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('app.shared.services')
    .factory('ActivateService', ActivateService);

  /** @ngInject */
  function ActivateService(
    HelperService
  ) {
    /**
     * Abstract method to Activate Model.
     *
     * @param  {String} method
     * @return {Function}
     */
    function _onActivate(method) {
      return HelperService.handle('ActivateModel', arguments);
    }

    /**
     * Activate a avatar user
     *
     * @param {Object} params
     */
    function activateAvatarUser(params) {
      return _onActivate('activateUserAvatar', params);
    }

    return {
      activateAvatarUser: activateAvatarUser
    };
  }

})();
  
(function() {
  'use strict';

  angular.module('app.shared.models', []);

})();

(function() {
  'use strict';

  angular
    .module('app.shared.models')
    .factory('ZipcodeModel', ZipcodeModel);

  /** @ngInject */
  function ZipcodeModel(
    $resource, 
    API, 
    HelperService
  ) {

    var HOST = API.HOST,
      METHODS = API.METHODS;

    var Zipcode = $resource('https://viacep.com.br/ws/:first/json', {
      first: '@zipcode'
    }, {

      resolveZipcode: buildRoute(METHODS.GET)
    });

    /**
     * Shorthand method to HelperService.buildRoute.
     *
     * @param {String} method
     * @param {Object} params
     * @param {Object} options
     * @returns {Object}
     */
    function buildRoute(method, params, options) {
      return HelperService.buildRoute(method, params, options);
    }

    return Zipcode;
  }

})();

(function() {
  'use strict';

  angular
    .module('app.shared.models')
    .factory('UserModel', UserModel);

  /** @ngInject */
  function UserModel(
    $resource, 
    API, 
    HelperService
  ) {

    var HOST = API.HOST,
      METHODS = API.METHODS;

    var User = $resource(HOST + '/users/:first', {
      first: '@userId'
    }, {

      createUser: buildRoute(METHODS.POST),
      deleteUser: buildRoute(METHODS.DELETE),
      getUsers: buildRoute(METHODS.GET),
      updateUser: buildRoute(METHODS.PUT)
    });

    /**
     * Shorthand method to HelperService.buildRoute.
     *
     * @param {String} method
     * @param {Object} params
     * @param {Object} options
     * @returns {Object}
     */
    function buildRoute(method, params, options) {
      return HelperService.buildRoute(method, params, options);
    }

    return User;
  }

})();

(function() {
  'use strict';

  angular
    .module('app.shared.models')
    .factory('StructureModel', StructureModel);

  /** @ngInject */
  function StructureModel(
    $resource, 
    API, 
    HelperService
  ) {

    var HOST = API.HOST,
      METHODS = API.METHODS;

    var Structure = $resource(HOST + '/structures', {}, {

      getStructures: buildRoute(METHODS.GET)
    });

    /**
     * Shorthand method to HelperService.buildRoute.
     *
     * @param {String} method
     * @param {Object} params
     * @param {Object} options
     * @returns {Object}
     */
    function buildRoute(method, params, options) {
      return HelperService.buildRoute(method, params, options);
    }

    return Structure;
  }

})();

(function() {
    'use strict';
  
    angular
      .module('app.shared.models')
      .factory('ObserverModel', ObserverModel);
  
    /** @ngInject */
    function ObserverModel(
      $resource, 
      API, 
      HelperService
    ) {
  
      var HOST = API.HOST,
        METHODS = API.METHODS;
  
      var Observer = $resource(HOST + '/observers/:first', {
        first: '@userId'
      }, {
  
        previewObserver: buildRoute(METHODS.GET, {
          first: 'preview'
        }),

        activateObserver: buildRoute(METHODS.POST, {
          first: 'activate'
        }),
        updateObserver: buildRoute(METHODS.PUT),
      });
  
      /**
       * Shorthand method to HelperService.buildRoute.
       *
       * @param {String} method
       * @param {Object} params
       * @param {Object} options
       * @returns {Object}
       */
      function buildRoute(method, params, options) {
        return HelperService.buildRoute(method, params, options);
      }
  
      return Observer;
    }
  
  })();
  
(function() {
  'use strict';

  angular
    .module('app.shared.models')
    .factory('LocationModel', LocationModel);

  /** @ngInject */
  function LocationModel(
    $resource, 
    API, 
    HelperService
  ) {

    var HOST = API.HOST,
      METHODS = API.METHODS;

    var Location = $resource(HOST + '/locations/:first', {}, {

      getStates: buildRoute(METHODS.GET, {
        first: 'states'
      })
    });

    /**
     * Shorthand method to HelperService.buildRoute.
     *
     * @param {String} method
     * @param {Object} params
     * @param {Object} options
     * @returns {Object}
     */
    function buildRoute(method, params, options) {
      return HelperService.buildRoute(method, params, options);
    }

    return Location;
  }

})();

(function() {
  'use strict';

  angular
    .module('app.shared.models')
    .factory('IssueModel', IssueModel);

  /** @ngInject */
  function IssueModel(
    $resource, 
    API, 
    HelperService
  ) {

    var HOST = API.HOST,
      METHODS = API.METHODS;

    var Issue = $resource(HOST + '/issues/:first/:second/:third/:fourth/:fifth', {
      first: '@issueId'
    }, {

      activateDocumentFile: buildRoute(METHODS.POST, {
        second: 'documents',
        third: '@documentId',
        fourth: '@typeDocument',
        fifth: 'activate'
      }),
      getActivities: buildRoute(METHODS.GET, {
        second: 'activities'
      }),
      getDocuments: buildRoute(METHODS.GET, {
        second: 'documents'
      }),
      getIssues: buildRoute(METHODS.GET, {
        complete: true
      }),
      updateIssue: buildRoute(METHODS.PUT),
      getIssuesByObserver: buildRoute(METHODS.GET, {
        first: 'observers',
        second: '@observerId'
      }),
      getIssue: buildRoute(METHODS.GET),
      sendMessage: buildRoute(METHODS.POST, {
        second: 'messages'
      }),
    });

    /**
     * Shorthand method to HelperService.buildRoute.
     *
     * @param {String} method
     * @param {Object} params
     * @param {Object} options
     * @returns {Object}
     */
    function buildRoute(method, params, options) {
      return HelperService.buildRoute(method, params, options);
    }

    return Issue;
  }

})();

(function() {
  'use strict';

  angular
    .module('app.shared.models')
    .factory('ConversationModel', ConversationModel);

  /** @ngInject */
  function ConversationModel(
    $resource, 
    API, 
    HelperService
  ) {

    var HOST = API.HOST,
      METHODS = API.METHODS;

    var Conversation = $resource(HOST + '/conversations/:first/:second', {
      first: '@conversationId'
    }, {

      createConversation: buildRoute(METHODS.POST),
      getConversation: buildRoute(METHODS.GET),
      getConversations: buildRoute(METHODS.GET),
      getMessages: buildRoute(METHODS.GET, {
        second: 'messages'
      }),
      sendMessage: buildRoute(METHODS.POST, {
        second: 'messages'
      })
    });

    /**
     * Shorthand method to HelperService.buildRoute.
     *
     * @param {String} method
     * @param {Object} params
     * @param {Object} options
     * @returns {Object}
     */
    function buildRoute(method, params, options) {
      return HelperService.buildRoute(method, params, options);
    }

    return Conversation;
  }

})();

(function() {
  'use strict';

  angular
    .module('app.shared.models')
    .factory('ClientModel', ClientModel);

  /** @ngInject */
  function ClientModel(
    $resource, 
    API, 
    HelperService
  ) {

    var HOST = API.HOST,
      METHODS = API.METHODS;

    var Client = $resource(HOST + '/clients/:first/:second', {
      first: '@clientId'
    }, {

      activateClient: buildRoute(METHODS.POST, {
        first: 'activate'
      }),
      previewClient: buildRoute(METHODS.GET, {
        first: 'preview'
      }),
      updateClient: buildRoute(METHODS.PUT)
    });

    /**
     * Shorthand method to HelperService.buildRoute.
     *
     * @param {String} method
     * @param {Object} params
     * @param {Object} options
     * @returns {Object}
     */
    function buildRoute(method, params, options) {
      return HelperService.buildRoute(method, params, options);
    }

    return Client;
  }

})();

(function() {
  'use strict';

  angular
    .module('app.shared.models')
    .factory('AuthModel', AuthModel);

  /** @ngInject */
  function AuthModel(
    $resource, 
    API, 
    HelperService
  ) {

    var HOST = API.HOST,
      METHODS = API.METHODS;

    var Auth = $resource(HOST + '/auth/:first', {}, {

      login: buildRoute(METHODS.POST, {
        first: 'login'
      }),
      logout: buildRoute(METHODS.DELETE, {
        first: 'sign_out'
      }),
      requestPasswordReset: buildRoute(METHODS.POST, {
        first: 'recovery-password'
      }),
      resetPassword: buildRoute(METHODS.POST, {
        first: 'reset-password'
      }),
    });

    /**
     * Shorthand method to HelperService.buildRoute.
     *
     * @param {String} method
     * @param {Object} params
     * @param {Object} options
     * @returns {Object}
     */
    function buildRoute(method, params, options) {
      return HelperService.buildRoute(method, params, options);
    }

    return Auth;
  }

})();

(function() {
  'use strict';

  angular
    .module('app.shared.models')
    .factory('ActivateModel', ActivateModel);

  /** @ngInject */
  function ActivateModel(
    $resource, 
    API, 
    HelperService
  ) {

    var HOST = API.HOST,
      METHODS = API.METHODS;

    var Activate = $resource(HOST + '/activate/:first/:second/:third', {
      
    }, {

      activateUserAvatar: buildRoute(METHODS.POST, {
        first: 'avatar',
        second: '@userType',
        third: '@userId'
      })
    });

    /**
     * Shorthand method to HelperService.buildRoute.
     *
     * @param {String} method
     * @param {Object} params
     * @param {Object} options
     * @returns {Object}
     */
    function buildRoute(method, params, options) {
      return HelperService.buildRoute(method, params, options);
    }

    return Activate;
  }

})();

(function() {
  'use strict';

  angular.module('app.shared.directives', []).config(config);

  /** @ngInject */
  function config($translatePartialLoaderProvider) {
    // Translation
    $translatePartialLoaderProvider.addPart('app/shared/directives');
  }

})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxZipcodeInput', mxZipcodeInputDirective);

  /** @ngInject */
  function mxZipcodeInputDirective(
    LocationService
  ) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/shared/directives/mx-zipcode-input/mx-zipcode-input.html',
      scope: {
        model: '=inputModel',
        isDisabled: '=inputDisabled',
        isRequired: '=inputRequired',
        onSearchCallback: '=onSearch',
        onDoneCallback: '=onDone',
        onUnknownCallback: '=onUnknown',
        shouldFocus: '='
      },
      link: function ($scope) {
        // Vars
        $scope.searching = false;
        
        // Methods
        $scope.onUnknownZipcodeClick = onUnknownZipcodeClick;
        $scope.resolveZipcode = resolveZipcode;
        
        ////////
        
        function onUnknownZipcodeClick() {
          $scope.onUnknownCallback && $scope.onUnknownCallback();
        }
        
        function resolveZipcode() {
          if (!$scope.model || $scope.searching)
            return;
            
          var zipcode = angular.copy($scope.model).trim().replace('-', '');
          
          if (zipcode && zipcode.length == 8) {
            $scope.searching = true;
            $scope.onSearchCallback && $scope.onSearchCallback();
            
            LocationService.resolve(zipcode).then(function (res) {
              $scope.onDoneCallback && $scope.onDoneCallback(res);
            }).then(function () {
              $scope.searching = false;
            });
          }
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxTable', mxTableDirective);

  /** @ngInject */
  function mxTableDirective() {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/shared/directives/mx-table/mx-table.html',
      scope: {
        items: '=',
        action: '=',
        callbackDetails: '=',
        hiddenFields: '=',
        query: '='
      },
      link: function ($scope) {
        
        // Vars
            
        // Scope vars
        $scope.ACTIONS = {
          EXPAND: 'expand',
          GO: 'go'
        };
        $scope.query = '';
            
        // Methods
        $scope.isFieldVisible = isFieldVisible;
        $scope.onDetailsClick = onDetailsClick;
        $scope.onItemClick = onItemClick;
        
        ////////
        
        /**
         * Checks if a field should be visible.
         *
         * @param {String} field
         */
        function isFieldVisible(field) {
          if ($scope.hiddenFields && $scope.hiddenFields.indexOf(field) != -1)
            return false;
          
          return true;
        }
        
        /**
         * Item detail click event.
         *
         * @param {Object} item
         */
        function onDetailsClick(item) {
          $scope.callbackDetails && $scope.callbackDetails(item);
        }
        
        /**
         * Item click event.
         *
         * @param {Object} item
         */
        function onItemClick(item) {
          if (!$scope.action)
            return;
            
          var ACTIONS = $scope.ACTIONS;
            
          switch ($scope.action.id) {
            case ACTIONS.EXPAND:
              item.expanded = !item.expanded;
              break;
            case ACTIONS.GO:
              $scope.action.callback && $scope.action.callback(item);
              break;
          }
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxSystemMessage', mxSystemMessageDirective);

  /** @ngInject */
  function mxSystemMessageDirective() {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/shared/directives/mx-system-message/mx-system-message.html',
      scope: {
        endedAt: '=',
        transferred: '=',
        history: '=',
        transferring: '=',
        newUser: '=',
        offline: '=',
      },
      link: function ($scope) {
        
        // Methods
        $scope.getMessage = getMessage;
        
        ////////

        /**
         * Returns the right message for the occasion.
         */
        function getMessage() {
          if ($scope.endedAt) {
            // History
            if ($scope.history) {
              var date = moment($scope.endedAt),
                  verb = $scope.transferred ? 'transferida' : 'encerrada';
              return 'Conversa ' + verb + ' em ' + date.format('DD/MM/YY') + ' às ' + date.format('HH:mm') + '.';

            // Current chat
            } else {
              return 'Esta conversa foi encerrada.';
            }
          } else if ($scope.transferring) {
            return 'Seu atendimento está sendo transferido.';
          } else if ($scope.newUser) {
            return 'Seu novo atendente é ' + $scope.newUser.name + '.';
          } else if ($scope.offline) {
            return 'O atendente está offline no momento.\nSuas mensagens serão respondidas em breve.';
          }
        }
        
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxSendMessage', mxSendMessageDirective);

  /** @ngInject */
  function mxSendMessageDirective() {
    return {
      restrict: 'E',
      replace: true,
      transclude: true,
      templateUrl: 'app/shared/directives/mx-send-message/mx-send-message.html',
      scope: {
        onSend: '=',
        success: '='
      },
      link: function ($scope) {
        // Methods
        $scope.onReplyKeyDown = onReplyKeyDown;
        $scope.onSubmit = onSubmit;
        
        ////////
        
        /**
         * On return key down.
         *
         * @param {Event} evt
         */
        function onReplyKeyDown(evt) {
          if (evt.keyCode == 13 && !evt.shiftKey) {
            evt.preventDefault();
            onSubmit();
          }
        }
        
        /**
         * Message submit event.
         */
        function onSubmit(isInvalid) {
          if (isInvalid)
            return;

          $scope.onSend && $scope.onSend($scope.mxMessageForm.message.$viewValue);
          $scope.mxMessageForm.$setUntouched();
          $scope.mxMessageForm.$setPristine();
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxSectionDivider', mxSectionDividerDirective);

  /** @ngInject */
  function mxSectionDividerDirective() {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/shared/directives/mx-section-divider/mx-section-divider.html',
      scope: {
        sectionTitle: '='
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxSearchInput', mxSearchInputDirective);

  /** @ngInject */
  function mxSearchInputDirective() {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/shared/directives/mx-search-input/mx-search-input.html',
      scope: {
        callback: '=',
        submit: '='
      },
      link: function ($scope) {
        
        // Methods
        $scope.onChange = onChange;
        $scope.onSubmit = onSubmit;
        
        ////////
        
        /**
         * Search change event.
         */
        function onChange() {
          if ($scope.submit || !$scope.callback)
            return;
            
          $scope.callback($scope.searchValue);
        }
        
        /**
         * Search submit event.
         */
        function onSubmit() {
          if (!$scope.submit || !$scope.callback || !$scope.searchValue || !$scope.searchValue.length)
            return;
            
          $scope.callback($scope.searchValue);
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxReadonlyData', mxReadonlyDataDirective);

  /** @ngInject */
  function mxReadonlyDataDirective() {
    return {
      restrict: 'E',
      replace: true,
      transclude: true,
      templateUrl: 'app/shared/directives/mx-readonly-data/mx-readonly-data.html',
      scope: {
        name: '=',
        value: '='
      },
      link: function ($scope) {
        
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxProfilePasswordForm', mxProfilePasswordFormDirective);

  /** @ngInject */
  function mxProfilePasswordFormDirective(msUtils) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/shared/directives/mx-profile-password-form/mx-profile-password-form.html',
      scope: {
        form: '=',
        model: '=',
        progressCallback: '=',
        edit: '='
      },
      link: function ($scope) {
        
        var FIELDS = {
          PASSWORD: 'password',
          PASSWORD_CONFIRMATION: 'password_confirmation'
        };
        
        $scope.confirmationDisabled = $scope.edit ? false : true;
        
        // Methods
        $scope.onBlur = onBlur;
        
        ////////
        
        /**
         * Updates the completion bar progress.
         */
        function _updateCompletionBar() {
          if (!$scope.progressCallback)
            return;
          $scope.progressCallback();
        }
        
        /**
         * On blur event for every field.
         *
         * @param {String} field
         */
        function onBlur(field) {
          var el = $scope.form[field],
              isValid = el ? el.$valid : false,
              isMobile = msUtils.isMobile();
          
          if (field == FIELDS.PASSWORD && isValid) {
            $scope.confirmationDisabled = false;
            if (!$scope.edit)
              $scope.confirmationFocused = true;
          }
          
          _updateCompletionBar();
          $scope.$emit('profile-password-form:on-change', true);
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxProfileInfoForm', mxProfileInfoFormDirective);

  /** @ngInject */
  function mxProfileInfoFormDirective(
    msUtils,
    $timeout,
    CompletionBarService,
    DialogService,
    LocationService
  ) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/shared/directives/mx-profile-info-form/mx-profile-info-form.html',
      scope: {
        form: '=',
        model: '=',
        isClient: '=client',
        progressCallback: '=',
        edit: '=',
        states: '='
      },
      link: function ($scope) {
        
        var FIELDS = {
          GENDER: 'gender',
          BIRTHDAY: 'birthday',
          COMPANY_FANTASY_NAME: 'company_fantasy_name',
          CELLPHONE: 'cellphone',
          PHONE: 'phone',
          POSTAL_CODE: 'postal_code',
          ADDRESS: 'address',
          ADDRESS_NUMBER: 'address_number',
          COMPLEMENT: 'complement',
          DISTRICT: 'district',
          CITY: 'city',
          STATE: 'state',
          TERMS: 'terms',
        };
        
        $scope.zipcodeRequired = $scope.edit ? false : true;
        $scope.loadingStates = true;
        
        // Methods
        $scope.onBlur = onBlur;
        $scope.onTermsClick = onTermsClick;
        $scope.onZipcodeDone = onZipcodeDone;
        $scope.onZipcodeSearch = onZipcodeSearch;
        $scope.onZipcodeUnknown = onZipcodeUnknown;
        $scope.onChange = onChange;
        $scope.onTermsChange = onTermsChange;
        
        _init();
        
        ////////
        
        function _init() {
          if (!$scope.states)
            $scope.states = LocationService.getStates();
          _setupFields();
          $timeout(function() {
            $scope.loadingStates = false;
          }, 800);

          if (!$scope.edit)
            $scope.form.$setValidity('terms', false);
        }
        
        /**
         * Disables a field.
         */
        function _disableField(field) {
          $scope.fields[field].disabled = true;
        }
        
        /**
         * Enables address fields.
         */
        function _enableAddressFields(enable) {
          var fields = [
            FIELDS.ADDRESS, 
            FIELDS.DISTRICT, 
            FIELDS.ADDRESS_NUMBER, 
            FIELDS.COMPLEMENT, 
            FIELDS.CITY, 
            FIELDS.STATE
          ];
          enable && fields.forEach(_enableField);
          !enable && fields.forEach(_disableField);
        }
        
        /**
         * Enables a field.
         */
        function _enableField(field) {
          $scope.fields[field].disabled = false;
        }
        
        /**
         * Setup fields state and weight.
         */
        function _setupFields() {
          $scope.fields = {
            phone: {
              disabled: $scope.edit ? false : true
            },
            postal_code: {
              disabled: $scope.edit ? false : true
            },
            address: {
              disabled: $scope.edit ? false : true
            },
            address_number: {
              disabled: $scope.edit ? false : true
            },
            complement: {
              disabled: $scope.edit ? false : true
            },
            district: {
              disabled: $scope.edit ? false : true
            },
            city: {
              disabled: $scope.edit ? false : true
            },
            state: {
              disabled: $scope.edit ? false : true
            }
          }
        }
        
        /**
         * Updates the completion bar progress.
         */
        function _updateCompletionBar() {
          if (!$scope.progressCallback)
            return;
          $scope.progressCallback();
        }
        
        /**
         * On blur event for every field.
         *
         * @param {String} field
         */
        function onBlur(field) {
          var el = $scope.form[field],
              isValid = el ? el.$valid : false,
              isMobile = msUtils.isMobile();
          
          if (field == FIELDS.CELLPHONE && isValid) {
            _enableField(FIELDS.PHONE);
            _enableField(FIELDS.POSTAL_CODE);
            
            if (!isMobile) $scope.phoneFocused = true;
          }
          
          _updateCompletionBar();
        }

        /**
         * Show terms dialog.
         */
        function onTermsClick($evt) {
          $evt.preventDefault();
          $evt.stopPropagation();
          DialogService.terms();
        }
        
        /**
         * Zipcode search done callback.
         */
        function onZipcodeDone(res) {
          if (!res.erro) {
            $scope.model.address = res.logradouro;
            $scope.model.district = res.bairro;
            $scope.model.city = res.localidade;
            $scope.model.state = LocationService.getStateByCode(res.uf).id;
            _enableAddressFields(true);
            $timeout(function () {
              $scope.addressNumberFocused = true;
            }, 100);
          } else {
            $scope.zipcodeRequired = true;
          }
          $timeout(_updateCompletionBar, 100);
        }
        
        /**
         * Zipcode search start callback.
         */
        function onZipcodeSearch() {
          _enableAddressFields(false);
        }
        
        /**
         * Zipcode is unknown callback.
         */
        function onZipcodeUnknown() {
          _enableAddressFields(true);
          $scope.zipcodeRequired = false;
          _updateCompletionBar();
        }

        /**
         * Get on change on inputs
         */
        function onChange() {
          if ($scope.loadingStates) return;
          $scope.$emit('profile-info-form:on-change', true);
        }

        /**
         * Get on change on inputs
         */
        function onTermsChange() {
          if ($scope.loadingStates) return;
          $scope.form.$setValidity('terms', $scope.model.terms === true);
          $scope.$emit('profile-info-form:on-change', true);
          onBlur(FIELDS.TERMS);
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxPasswordInput', mxPasswordInputDirective);

  /** @ngInject */
  function mxPasswordInputDirective() {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/shared/directives/mx-password-input/mx-password-input.html',
      scope: {
        model: '=inputModel',
        isDisabled: '=inputDisabled',
        isRequired: '=inputRequired',
        name: '=inputName',
        blurCallback: '=',
        confirmation: '=',
        shouldFocus: '=',
        confirmationModel: '=',
        form: '=',
        edit: '='
      },
      link: function ($scope) {
        // Vars
        $scope.showPassword = false;
        
        // Methods
        $scope.getName = getName;
        $scope.getPlaceholder = getPlaceholder;
        $scope.onBlur = onBlur;
        $scope.onTogglePasswordVisibilityClick = onTogglePasswordVisibilityClick;
        
        ////////
        
        /**
         * Resolve the input's name.
         */
        function getName() {
          var name = 'password'; 
          
          if ($scope.name)
            name = $scope.name;
          else if ($scope.confirmation)
            name = 'password_confirmation';
          
          return name;
        }
        
        /**
         * Resolve the input's placeholder.
         */
        function getPlaceholder() {
          var placeholder = 'Senha'; 
          
          if ($scope.confirmation && $scope.edit)
            placeholder = 'Confirmar nova senha';
          else if ($scope.confirmation && !$scope.edit)
            placeholder = 'Confirmação de senha';
          else if ($scope.edit)
            placeholder = 'Nova senha';
          
          return placeholder;
        }
        
        /**
         * Input blut event.
         */
        function onBlur() {
          var field = $scope.confirmation ? 'password_confirmation' : 'password';
          $scope.blurCallback && $scope.blurCallback(field);
        }
        
        /**
         * Toggle password input type.
         */
        function onTogglePasswordVisibilityClick() {
          $scope.showPassword = !$scope.showPassword;
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxPanel', mxPanelDirective);

  /** @ngInject */
  function mxPanelDirective() {
    return {
      restrict: 'E',
      replace: true,
      transclude: true,
      templateUrl: 'app/shared/directives/mx-panel/mx-panel.html',
      scope: {
        tabbed: '=',
        tabBadges: '=',
        translucent: '='
      }, 
      link: function ($scope) {
        
        // Methods
        _init();
        
        ////////
        
        function _init() {
          if ($scope.tabBadges && $scope.tabBadges.length)
            _defineBadgeClasses();
        }
        
        /**
         * Defines all badge classes needed.
         */
        function _defineBadgeClasses() {
          var classes = [];
          $scope.tabBadges.forEach(function (tab) {
            classes.push('mx-panel--tab-badge-' + tab);
          });
          $scope.badgeClasses = classes.join(' ');
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxMessageInput', mxMessageInputDirective);

  /** @ngInject */
  function mxMessageInputDirective() {
    return {
      restrict: 'E',
      replace: true,
      transclude: true,
      templateUrl: 'app/shared/directives/mx-message-input/mx-message-input.html',
      scope: {
        boxed: '=',
        message: '=',
        onSend: '=',
        iconButton: '='
      },
      link: function ($scope) {
        
        // Methods
        $scope.onReplyKeyDown = onReplyKeyDown;
        $scope.onSubmit = onSubmit;
        
        ////////
        
        /**
         * On return key down.
         *
         * @param {Event} evt
         */
        function onReplyKeyDown(evt) {
          if (evt.keyCode == 13 && !evt.shiftKey) {
            evt.preventDefault();
            onSubmit();
          }
        }
        
        /**
         * Message submit event.
         */
        function onSubmit(isInvalid) {
          if (isInvalid)
            return;
            
          $scope.onSend && $scope.onSend($scope.message);
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxLoader', mxLoaderDirective);

  /** @ngInject */
  function mxLoaderDirective(BROADCAST) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/shared/directives/mx-loader/mx-loader.html',
      scope: {
        loaderId: '@',
        startsOn: '=',
        modal: '=',
        local: '=',
        small: '=',
        global: '=',
        opaque: '=',
        login: '='
      },
      link: function($scope, element, attrs, ctrl) {

        attrs.$observe('loaderId', function(val) {
          if (val)
            $scope.key = val;
        });

        $scope.$on(BROADCAST.LOADER.START, function(e, key, configs) {
          if (key === $scope.key) {
            $scope.loader = angular.extend({}, $scope.loader, configs);
            start();
          }
        });

        $scope.$on(BROADCAST.LOADER.STOP, function(e, key) {
          if (key === $scope.key)
            stop();
        });

        if ($scope.startsOn)
          start();

        /**
         * Starts the loader.
         */
        function start() {
          $scope.show = true;
        }

        /**
         * Stops the loader.
         */
        function stop() {
          $scope.show = false;
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxLoadMore', mxLoadMoreDirective);

  /** @ngInject */
  function mxLoadMoreDirective() {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/shared/directives/mx-load-more/mx-load-more.html',
      scope: {
        callback: '=',
        callbackItem: '=',
        text: '='
      },
      link: function ($scope) {
        
        // Methods
        $scope.onClick = onClick;
        
        ////////
        
        /**
         * Load more click event.
         */
        function onClick() {
          if (!$scope.callback)
            return;
          $scope.callback($scope.callbackItem);
        }
        
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxListDocuments', mxListDocumentsDirective);

  /** @ngInject */
  function mxListDocumentsDirective(
    DialogService
  ) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/shared/directives/mx-list-documents/mx-list-documents.html',
      scope: {
        items: '='
      },
      link: function ($scope) {
        
        // Methods
        $scope.onViewDocumentClick = onViewDocumentClick;

        ////////

        /**
         * Shows the uploaded document modal.
         * @param {*} document 
         */
        function onViewDocumentClick(document) {
          console.log('document:', document);
          DialogService.documentPreview(document);
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxList', mxListDirective);

  /** @ngInject */
  function mxListDirective(
    BROADCAST,
    BroadcastService,
    DialogService
  ) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/shared/directives/mx-list/mx-list.html',
      scope: {
        actions: '=',
        compact: '=',
        edit: '=',
        footer: '=',
        header: '=',
        headerSubtitle: '=',
        headerTitle: '=',
        items: '=',
        query: '=',
        readonlyIds: '=',
        selectable: '=',
        selectOnClick: '=',
        showHandles: '=',
        showStatus: '=',
        showThumbnails: '=',
        sortable: '=',
        thumbSize: '='
      },
      link: function($scope, element, attrs, ctrl) {
        
        var listeners = [];
        
        // Methods
        
        $scope.onCheckboxClick = onCheckboxClick;
        $scope.onItemClick = onItemClick;
        $scope.setOrderDesc = setOrderDesc;
        
        _init();
        
        ////////
        
        function _init() {
          listeners.push($scope.$on(BROADCAST.HEADER.DESELECT_ALL, _onHeaderDeselectAll));
          listeners.push($scope.$on(BROADCAST.HEADER.SELECT_ALL, _onHeaderSelectAll));
        }
        
        /**
         * Deselect all items.
         */
        function _deselectAll() {
          $scope.items.forEach(function (item) {
            if (item.selected)
              _setItemSelection(item);
          });
        }
        
        /**
         * Header 'delete all' callback.
         */
        function _onHeaderDeleteAll() {
          console.log('_onHeaderDeleteAll');
        }
        
        /**
         * Header 'deselect all' callback.
         */
        function _onHeaderDeselectAll() {
          _deselectAll();
        }
        
        /**
         * Header 'select all' callback.
         */
        function _onHeaderSelectAll() {
          $scope.items.forEach(function (item) {
            if (!item.selected && canEdit(item))
              _setItemSelection(item);
          });
        }
        
        /**
         * Sets the item selection status and broadcasts it to the header.
         */
        function _setItemSelection(item) {
          if (item.selected === true) { // will become deselected
            !$scope.compact && !$scope.showStatus && BroadcastService.broadcast(BROADCAST.HEADER.POP_ITEM, item);
            item.selected = false;
          } else { // will become selected
            !$scope.compact && !$scope.showStatus && BroadcastService.broadcast(BROADCAST.HEADER.PUSH_ITEM, item);
            item.selected = true;
          }
        }
        
        function canEdit(item) {
          return !$scope.readonlyIds || $scope.readonlyIds.indexOf(item.id) == -1;
        }
        
        function onCheckboxClick(item) {
          if ($scope.selectOnClick)
            return;
          _setItemSelection(item);
        }
        
        function onItemClick(item) {
          if (!$scope.selectOnClick)
            return;
          _setItemSelection(item);
        }
        
        function setOrderDesc(desc) {
          var first = $scope.items[0];
          
          if (!first)
            return;
            
          $scope.orderBy = (first.title) ? 'title' : 'name';
          $scope.orderDesc = desc;
        }
        
        /**
         * Destroy any broadcast listener.
         */
        $scope.$on('$destroy', function () {
          listeners.forEach(function (killListener) {
            killListener();
          });
        });
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxIssue', mxIssueDirective);

  /** @ngInject */
  function mxIssueDirective(
    msUtils,
    $mdSidenav,
    $timeout,
    BROADCAST,
    TARGET,
    ActivityService,
    AuthService,
    BroadcastService,
    ChatService,
    DialogService,
    DocumentService,
    InfoBarService,
    IssueService,
    LoaderService,
    QuickPanelService,
    StateService
  ) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/shared/directives/mx-issue/mx-issue.html',
      scope: {
        issue: '=',
        index: '='
      },
      controller: function ($scope) {
        
        // Vars
        var paramTab = StateService.getParam('tab'),
            listeners = [],
            LOADERS = {
              ACTIVITIES: $scope.issue ? 'activitiesLoader' + $scope.issue.id : 'activitiesLoader',
              DETAILS: 'detailsLoader',
              DOCUMENTS: 'documentsLoader',
              CHATS: 'chatsLoader'
            },
            TABS = {
              ACTIVITIES: 0,
              DETAILS: 1,
              DOCUMENTS: 2,
              CHATS: 3
            },
            startTab = paramTab && $scope.index === 0 ? paramTab : TABS.ACTIVITIES;
        $scope.tabs = {
          current: startTab
        };
        $scope.currentUser = AuthService.getUser();
        $scope.isClient = AuthService.isClient();
        // $scope.tabBadges = [3];
        
        // Mockups
        $scope.tables = {
          activities: {
            items: [],
            action: {
              id: 'expand'
            },
            hiddenFields: ['start-time', 'end-time']
          },
          chats: {
            items: [],
            action: {
              id: 'go',
              callback: onChatClick
            },
            hiddenFields: ['type']
          },
          documents: {
            items: [],
          }
        };
        
        // Methods
        $scope.onChatBackClick = onChatBackClick;
        $scope.onDetailsSubmit = onDetailsSubmit;
        $scope.onActivityDetailsClick = onActivityDetailsClick;
        $scope.onLoadMoreClick = onLoadMoreClick;
        $scope.onNewChatClick = onNewChatClick;
        $scope.onSearch = onSearch;
        $scope.onTabChange = onTabChange;
        
        _init();
        
        ////////
        
        function _init() {
          listeners.push($scope.$on(BROADCAST.IMAGE.UPLOAD_START, _onDocumentUploadStart));
          listeners.push($scope.$on(BROADCAST.CHAT.CLOSED, _onChatClosed));

          _loadActivities();
          _loadDocuments();
          _loadChats();
        }

        /**
         * Uploads a document file.
         */
        function _onDocumentUploadStart(evt, data) {
          if (!data || !data.file)
            return;
          
          // Find the right document.
          var document = $scope.tables.documents.items.filter(function (doc) {
            return doc.id == data.componentId;
          })[0];

          // Upload the document's file.
          DocumentService.uploadDocumentFile($scope.issue.id, data.file, document).then(function (doc) {
            _updateDocument(doc);

            // Show success message.
            InfoBarService.success('Documento "' + doc.document.name + '" enviado com sucesso!');
            BroadcastService.broadcast(BROADCAST.IMAGE.UPLOAD_SUCCESS);

            // Reload activities.
            $scope.tables.activities.items = [];
            _loadActivities();
          }, function (err) {
            console.error('err', err);
            BroadcastService.broadcast(BROADCAST.IMAGE.UPLOAD_ERROR);
            InfoBarService.error(err);
          });
        }

        /**
         * Updates a document from the list.
         * 
         * @param {Object} document 
         */
        function _updateDocument(document) {
          $scope.tables.documents.items = $scope.tables.documents.items.map(function (doc) {
            return document.id == doc.id ? document : doc;
          });
        }

        /**
         * Load the current issue's activities.
         * 
         * @param {Number} page 
         */
        function _loadActivities(page) {
          _showLoader(LOADERS.ACTIVITIES);
          var options = {};

          if ($scope.isClient)
            options.per_page = 20;
          
          ActivityService.getIssueActivities($scope.issue.id, page, options).then(function (res) {
            $scope.tables.activities.items = $scope.tables.activities.items.concat(res.activities);
            _resolveActivitiesPagination(res);
          }, function (err) {
            console.error(err);
            InfoBarService.error(err);
          }).finally(function () {
            _hideLoader(LOADERS.ACTIVITIES);
          });
        }
        
        /**
         * Load the current issue's documents.
         * 
         * @param {Number} page 
         */
        function _loadDocuments(page) {
          _showLoader(LOADERS.DOCUMENTS);
          
          DocumentService.getIssueDocuments($scope.issue.id).then(function (documents) {
            $scope.tables.documents.items = $scope.tables.documents.items.concat(documents);
          }, function (err) {
            console.error(err);
            InfoBarService.error(err);
          }).finally(function () {
            _hideLoader(LOADERS.DOCUMENTS);
          });
        }
        
        /**
         * Load the current issue's chats.
         * 
         * @param {Number} page 
         */
        function _loadChats(page) {
          _showLoader(LOADERS.CHATS);
          
          ChatService.getIssueChats($scope.issue.id).then(function (chats) {
            $scope.tables.chats.items = $scope.tables.chats.items.concat(chats);
          }, function (err) {
            console.error(err);
            InfoBarService.error(err);
          }).finally(function () {
            _hideLoader(LOADERS.CHATS);
          });
        }

        /**
         * Chat closed pusher event.
         * @param {*} evt 
         * @param {*} data 
         */
        function _onChatClosed(evt, chat) {
          $timeout(function () {
            $scope.tables.chats.items.unshift(ChatService.resolveChat(chat));
          });
        }

        /**
         * Updates pagination variables.
         */
        function _resolveActivitiesPagination(res) {
          $scope.tables.activities.pagination = res.pagination;
        }

        /**
         * Scrolls the chat to the bottom.
         */
        function _scrollToBottomOfChat(chatId, speed) {
          var chatDialog = angular.element('#chat-dialog' + chatId);
          console.log('chatDialog:', chatDialog);

          $timeout(function() {
            chatDialog.animate({
              scrollTop: chatDialog[0].scrollHeight
            }, speed);
          }, 10);
        }
        
        /**
         * Scrolls the window to the top.
         */
        function _scrollToTop() {
          var contentEl = document.getElementById('content'),
              issueEl = document.getElementById('issue-' + $scope.issue.id);
          if (contentEl && issueEl)
            content.scrollTop = issueEl.offsetTop;
        }
        
        /**
         * Hides the loader.
         */
        function _hideLoader(loaderId) {
          $scope.loading = false;
          LoaderService.hideGlobal();
          LoaderService.hide(loaderId);
        }
        
        /**
         * Shows the loader.
         */
        function _showLoader(loaderId) {
          $scope.loading = true;
          if (msUtils.isMobile() || !loaderId)
            LoaderService.showGlobal();
          else
            LoaderService.show(loaderId);
        }
        
        /**
         * Chat click callback.
         */
        function onChatClick(chat) {
          DialogService.chatHistory(chat);
        }
        
        /**
         * Returns to the chat list.
         */
        function onChatBackClick() {
          $scope.chatHistory = null;
        }
        
        /**
         * Details form submit event.
         */
        function onDetailsSubmit(contestation) {
          if ($scope.loading)
            return;
            
          var issue = {
            id: $scope.issue.id,
            contestation: contestation
          };
            
          _showLoader(LOADERS.DETAILS);
          
          IssueService.updateIssue(issue).then(function (res) {
            $scope.issue.contestation = contestation;
            InfoBarService.success('Observações adicionais enviadas com sucesso!');
          }, function (err) {
            console.error(err);
          }).finally(function () {
            _hideLoader(LOADERS.DETAILS);
          });
        }

        /**
         * Item details click callback.
         */
        function onActivityDetailsClick(activity) {
          if (activity.target_type == TARGET.ISSUES) {
            $scope.tabs.current = TABS.DETAILS;
            _scrollToTop();
          } else if (activity.target_type == TARGET.DOCUMENTS) {
            $scope.tabs.current = TABS.DOCUMENTS;
            _scrollToTop();
          } else if (activity.target_type == TARGET.CONVERSATION) {
            if (activity.target.active)
              QuickPanelService.open();
            else
              DialogService.chatHistory(null, activity.target.id);
          }
        }
        
        /**
         * Load more callback event.
         */
        function onLoadMoreClick() {
          var nextPage = $scope.tables.activities.pagination.page + 1;
          _loadActivities(nextPage);
        }
        
        /**
         * Click event for opening a new chat.
         */
        function onNewChatClick() {
          QuickPanelService.open($scope.issue.id);
        }
        
        /**
         * Search callback event.
         */
        function onSearch(searchValue) {
          console.log('$scope.tabs.current:', $scope.tabs.current);
          console.log('searchValue:', searchValue);
        }
        
        /**
         * Tab change event.
         */
        function onTabChange(tab) {
          $scope.tabs.current = tab;
          $scope.fixDynamicHeight = true;
          $timeout(function () {
            $scope.fixDynamicHeight = false;
          }, 750);
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxImgOrientation', mxImgOrientationDirective);

  /** @ngInject */
  function mxImgOrientationDirective() {
    return {
      restrict: 'A',
      link: function(scope, element/*, attrs*/) {
        function setTransform(transform) {
          element.css('-ms-transform', transform);
          element.css('-webkit-transform', transform);
          element.css('-moz-transform', transform);
          element.css('transform', transform);
        }
  
        var parent = element.parent();
        $(element).bind('load', function() {
          EXIF.getData(element[0], function() {
            var orientation = EXIF.getTag(element[0], 'Orientation');
            var height = element.height();
            var width = element.width();
            if (orientation && orientation !== 1) {
              switch (orientation) {
                case 2:
                  setTransform('rotateY(180deg)');
                  break;
                case 3:
                  setTransform('rotate(180deg)');
                  break;
                case 4:
                  setTransform('rotateX(180deg)');
                  break;
                case 5:
                  setTransform('rotateZ(90deg) rotateX(180deg)');
                  if (width > height) {
                    parent.css('height', width + 'px');
                    element.css('margin-top', ((width -height) / 2) + 'px');
                  }
                  break;
                case 6:
                  setTransform('rotate(90deg)');
                  if (width > height) {
                    parent.css('height', width + 'px');
                    element.css('margin-top', ((width -height) / 2) + 'px');
                  }
                  break;
                case 7:
                  setTransform('rotateZ(90deg) rotateY(180deg)');
                  if (width > height) {
                    parent.css('height', width + 'px');
                    element.css('margin-top', ((width -height) / 2) + 'px');
                  }
                  break;
                case 8:
                  setTransform('rotate(-90deg)');
                  if (width > height) {
                    parent.css('height', width + 'px');
                    element.css('margin-top', ((width -height) / 2) + 'px');
                  }
                  break;
              }
            }
          });
        });
      }
    }
  }
})();
(function() {
  'use strict';
  angular
    .module('app.shared.directives')
    .directive('mxImageUpload', mxImageUploadDirective);

  function mxImageUploadDirective(
    $timeout,
    BROADCAST,
    BroadcastService,
    DialogService,
    LoaderService,
    InfoBarService
  ) {
    return {
      restrict: 'E',
      scope: {
        componentId: '@',
        image: '=image',
        sectionTitle: '=',
        buttonOnly: '=',
        inline: '=',
        recommended: '=',
        showConfirmation: '=',
        showRequired: '=',
        selectionOnly: '=',
        buttonClasses: '=',
        buttonText: '=',
        disabled: '=',
        isAvatar: '='
      },
      transclude: true,
      templateUrl: 'app/shared/directives/mx-image-upload/mx-image-upload.html',
      link: function($scope) {
        $scope.imageAvatar = null;

        if ($scope.componentId)
          $scope.loaderId = 'mxImageUploadLoader' + $scope.componentId;
        else
          $scope.loaderId = 'mxImageUploadLoader';

        // Data
        $scope.ngFlow = {
          // ng-flow will be injected into here through its directive
          flow: {}
        };
        $scope.ngFlowOptions = {
          // You can configure the ngFlow from here
          /*target                   : 'api/media/image',
           chunkSize                : 15 * 1024 * 1024,
           maxChunkRetries          : 1,
           simultaneousUploads      : 1,
           testChunks               : false,
           progressCallbacksInterval: 1000*/
        };
        $scope.dropping = false;

        // Methods
        $scope.onFileAdded = onFileAdded;
        $scope.getCurrentImage = getCurrentImage;

        ////////

        $scope.$on(BROADCAST.IMAGE.UPLOAD_AVATAR_SUCCESS, _onUploadSuccess);
        $scope.$on(BROADCAST.IMAGE.UPLOAD_ERROR, _onUploadError);

        /**
         * Hides the loader.
         */
        function _hideLoader() {
          $scope.updating = false;
          LoaderService.hide($scope.loaderId);
        }

        /**
         * Shows the loader.
         */
        function _showLoader() {
          $scope.updating = true;
          LoaderService.show($scope.loaderId);
        }

        /**
         * Transform flow file into base64 image.
         */
        function _loadBase64Image(flowFile) {
          _showLoader();
          var fileReader = new FileReader();
          fileReader.onload = function(event) {
            $scope.base64Image = event.target.result;
            $scope.$apply();
            
            var params = {};
            if ($scope.componentId) {
              params = {
                componentId: $scope.componentId,
                file: $scope.flowFile.file
              }
            } else {
              params = $scope.flowFile.file;
            }
            
            BroadcastService.broadcast(BROADCAST.IMAGE.UPLOAD_START, params);
            if ($scope.selectionOnly)
              _onUploadSuccess(null, { componentId: $scope.componentId });
          };
          fileReader.readAsDataURL(flowFile.file);
        }

        /**
         * Image upload error callback.
         */
        function _onUploadError(evt, params) {
          if ($scope.componentId && params && params.componentId != $scope.componentId)
            return;
          $scope.base64Image = null;
          _hideLoader();
        }

        /**
         * Image upload success callback.
         */
        function _onUploadSuccess(evt, params) {
          if ($scope.componentId && params && params.componentId != $scope.componentId)
            return;
          
          if ($scope.isAvatar) $scope.imageAvatar = params.avatar_url + '#' + new Date();
          _hideLoader();
        }

        /**
         * Returns image uploaded by user. Default image, otherwise.
         */
        function getCurrentImage() {
          if ($scope.imageAvatar)
           return $scope.imageAvatar
          else if ($scope.base64Image && !$scope.isAvatar)
            return $scope.base64Image;
          else if ($scope.image)
            return ($scope.image.path) ? $scope.image.url + $scope.image.path : $scope.image;
          return 'assets/images/etc/upload-fallback.jpg';
        }

        /**
         * File added callback.
         * Triggers when files added to the uploader.
         *
         * @param flowFile
         */
        function onFileAdded(flowFile) {
          if ($scope.updating)
            return;

          if (!flowFile)
            return;

          var isValid = false,
              allowedTypes = ['jpg', 'jpeg', 'png', 'pdf'];

          allowedTypes.forEach(function (type) {
            if (flowFile.file.type.indexOf(type) != -1)
              isValid = true;
          });

          if (!isValid) {
            $timeout(function () {
              InfoBarService.show('Formato inválido. Selecione apenas imagens (.jpg, .jpeg, .png) e arquivos em PDF.');
            }, 10);
            return;
          }
            
          if ($scope.showConfirmation) {
            DialogService.uploadConfirmation().then(function (res) {
              _loadBase64Image(flowFile);
              $scope.flowFile = flowFile;
            }, function (err) {});
          } else {
            _loadBase64Image(flowFile);
            $scope.flowFile = flowFile;
          }
        }
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxHeader', mxHeaderDirective);

  /** @ngInject */
  function mxHeaderDirective(
    BROADCAST,
    BroadcastService,
    DialogService,
    StateService
  ) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/shared/directives/mx-header/mx-header.html',
      scope: {
        backButton: '=',
        icon: '=',
        image: '=',
        imageSize: '=',
        saveCallback: '=',
        subtitle: '=',
        text: '='
      },
      link: function($scope, element, attrs, ctrl) {

        // Data
        $scope.selectedItems = [];
        
        // Methods
        $scope.onBackClick = onBackClick;
        $scope.onDeleteSelectedItemsClick = onDeleteSelectedItemsClick;
        $scope.onDeselectAllItems = onDeselectAllItems;
        $scope.onSelectAllItems = onSelectAllItems;

        _init();
        
        ////////
        
        function _init() {
          $scope.$on(BROADCAST.HEADER.POP_ITEM, _onItemPop);
          $scope.$on(BROADCAST.HEADER.PUSH_ITEM, _onItemPush);
          $scope.$on(BROADCAST.HEADER.RESET, _resetHeader);
        }
          
        /**
         * Item popped event callback.
         *
         * @param {Object} evt
         * @param {Object} item
         */
        function _onItemPop(evt, item) {
          $scope.selectedItems = $scope.selectedItems.filter(function (aItem) {
            return aItem != item;
          });
        }

        /**
         * Item pushed event callback.
         *
         * @param {Object} evt
         * @param {Object} item
         */
        function _onItemPush(evt, item) {
          $scope.selectedItems.push(item);
        }

        /**
         * Reset header items.
         */
        function _resetHeader() {
          $scope.selectedItems = [];
        }

        
        /**
         * Back button click event.
         */
        function onBackClick() {
          StateService.back();
        }
        
        /**
         * Confirm deletion of selected items.
         */
        function onDeleteSelectedItemsClick() {
          DialogService.confirm({
            title: 'Excluir itens selecionados',
            message: 'Tem certeza que deseja excluir os itens selecionados? ' + $scope.selectedItems.length + ' item(ns) serão deletados.'
          }).then(function () {
            BroadcastService.broadcast(BROADCAST.HEADER.DELETE_ALL, $scope.selectedItems);
            $scope.selectedItems = [];
          }, function () {});
        }

        /**
         * Deselect all items click event.
         */
        function onDeselectAllItems() {
          BroadcastService.broadcast(BROADCAST.HEADER.DESELECT_ALL);
        }

        /**
         * Select all items click event.
         */
        function onSelectAllItems() {
          BroadcastService.broadcast(BROADCAST.HEADER.SELECT_ALL);
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxFooter', mxFooterDirective);

  /** @ngInject */
  function mxFooterDirective(
    DialogService,
    $timeout
  ) {
    return {
      restrict: 'E',
      replace: true,
      transclude: true,
      templateUrl: 'app/shared/directives/mx-footer/mx-footer.html',
      scope: {
        external: '=',
      },
      link: function ($scope) {
        $scope.currentYear = new Date().getFullYear();

        // Methods
        $scope.onTermsClick = onTermsClick;
        
        ////////
        
        /**
         * Opens the Terms modal.
         */
        function onTermsClick() {
          DialogService.terms();
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxFocus', mxFocusDirective);

  /** @ngInject */
  function mxFocusDirective(
    $parse,
    $timeout
  ) {
    return {
      restrict: 'A',
      link: function ($scope, element, attrs) {
        var model = $parse(attrs.mxFocus);
        
        $scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
            });
          }
        });
        
        element.bind('blur', function () {
          if (model && model.assign)
            $scope.$apply(model.assign($scope, false));
        });
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxFab', mxFabDirective);

  /** @ngInject */
  function mxFabDirective(
    $rootScope,
    $timeout,
    BROADCAST,
    AuthService,
    BroadcastService,
    QuickPanelService
  ) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/shared/directives/mx-fab/mx-fab.html',
      scope: {},
      controller: function ($scope) {
        // Vars
        var listeners = [],
            SHOW_DELAY = 100;
            
        // Scope vars
        $scope.mobile = false;
        $scope.show = false;
        
        // Methods
        $scope.onFabClick = onFabClick;
        
        _init();
        
        ////////
        
        /**
         * Load more click event.
         */
        function _init() {
          listeners.push($scope.$on(BROADCAST.FAB.HIDE, _hideFab));
          listeners.push($scope.$on(BROADCAST.FAB.SHOW, _showFab));
          listeners.push($scope.$on(BROADCAST.CHAT.NEW_MESSAGE, _onNewMessageReceived));
          listeners.push($scope.$on(BROADCAST.QUICK_PANEL.OPEN, _onQuickPanelOpen));
          
          $rootScope.$on('$stateChangeStart', _hideFab);
        }
        
        /**
         * Hides the button.
         */
        function _hideFab() {
          $scope.show = false;
        }

        /**
         * New message received callback.
         */
        function _onNewMessageReceived(evt, data) {
          if (QuickPanelService.isOpen())
            return;

          $timeout(function () {
            $scope.showBadge = true;
          }, 1);
        }

        /**
         * Quick panel open callback.
         */
        function _onQuickPanelOpen() {
          $scope.showBadge = false;
        }
        
        /**
         * Shows the button.
         *
         * @param {Object} evt
         * @param {Object} options
         */
        function _showFab(evt, options) {
          if (!AuthService.isClient())
            return;

          if (options) {
            $scope.mobile = options.mobile;
            $scope.icon = options.icon;
          } else {
            $scope.mobile = false;
            $scope.icon = null;
          }
          $timeout(function () {
            $scope.show = true;
          }, SHOW_DELAY);
        }
        
        /**
         * Click event for the FAB button.
         */
        function onFabClick() {
          BroadcastService.broadcast(BROADCAST.FAB.CLICK);
        }
        
        /**
         * Destroy any listeners.
         */
        $scope.$on('$destroy', function () {
          listeners.forEach(function (killListener) {
            killListener();
          });
        });
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxEmpty', mxEmptyDirective);

  /** @ngInject */
  function mxEmptyDirective() {
    return {
      restrict: 'E',
      replace: true,
      transclude: true,
      templateUrl: 'app/shared/directives/mx-empty/mx-empty.html',
      scope: {
        icon: '='
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxDetails', mxDetailsDirective);

  /** @ngInject */
  function mxDetailsDirective(
    $timeout,
    AuthService,
    LocationService
  ) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/shared/directives/mx-details/mx-details.html',
      scope: {
        issue: '=',
        onSubmit: '='
      },
      link: function ($scope) {
        $scope.isClient = AuthService.isClient();
        
        // Methods
        $scope.getClientState = getClientState;
        $scope.getCityState = getCityState;
        $scope.onDetailsSubmit = onDetailsSubmit;
        
        ////////
        
        /**
         * Builds the city / state string.
         */
        function getCityState() {
          if (!$scope.issue || !$scope.issue.accident)
            return;
            
          var accident = $scope.issue.accident,
              city = accident.city,
              state = accident.state_id ? LocationService.getStateById(accident.state_id) : null;
          
          if (city && state)
            return city + ' - ' + state.code;
          else if (!city && state)
            return state.code;
          else if (city && !state)
            return city;
        }
        
        /**
         * Builds the state string for client details.
         */
        function getClientState() {
          if (!$scope.issue || !$scope.issue.client)
            return;
          var state = $scope.issue.client.state ? LocationService.getStateById($scope.issue.client.state) : {};
          return state ? state.code + ' - ' + state.name : '-';
        }
        
        /**
         * Details form submit event.
         */
        function onDetailsSubmit(isInvalid) {
          if (isInvalid)
            return;
            
          $scope.onSubmit && $scope.onSubmit($scope.contestation);
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxContainer', mxContainerDirective);

  /** @ngInject */
  function mxContainerDirective() {
    return {
      restrict: 'E',
      replace: true,
      transclude: true,
      templateUrl: 'app/shared/directives/mx-container/mx-container.html',
      scope: {
        vPadding: '=',
        small: '='
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxConfirmPassword', mxConfirmPasswordDirective);

  /**
   * Directive for Password confirmation
   *
   * Usage:     <input type="password" 
   *                   ng-model="user.confirmPassword" 
   *                   confirm-password="{{user.password}}" >
   */
  /** @ngInject */
  function mxConfirmPasswordDirective() {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: function(scope, elem, attrs, ngModel) {
        if (!ngModel)
          return;

        // watch own value and re-validate on change
        scope.$watch(attrs.ngModel, function() {
          validate();
        });

        // observe the other value and re-validate on change
        attrs.$observe('mxConfirmPassword', function(val) {
          validate();
        });

        var validate = function() {
          if (!attrs.mxConfirmPassword)
            return;
            
          var val1 = ngModel.$viewValue || '';
          var val2 = attrs.mxConfirmPassword || '';
          // set validity
          ngModel.$setValidity('mxConfirmPassword', val1 === val2);
        };
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('app.shared.directives').directive('mxConfirmOnExit', mxConfirmOnExitDirective);

  function mxConfirmOnExitDirective(
    $rootScope,
    DialogService,
    StateService,
    i18n
  ) {
    return {
      restrict: 'A',
      scope: {
        mxConfirmOnExit: '='
      },
      link: function($scope, elem, attrs) {

        $scope.message = i18n.t('APP.UNSAVED_CHANGES');

        // Window close listener.
        window.onbeforeunload = function() {
          if ($scope.mxConfirmOnExit) {
            return $scope.message;
          }
        }

        // Route change listener.
        var killListener = $scope.$on('$stateChangeStart', function(evt, next, current) {
          if ($scope.mxConfirmOnExit) {
            var stateName = next.name;

            DialogService.unsavedChanges().then(function() {
              killListener();
              StateService.go(next.name);
            }, function() {
              $rootScope.loadingProgress = false;
            });

            evt.preventDefault();
            return false;
          }
        });

        // On destroy event.
        $scope.$on('$destroy', function() {
          window.onbeforeunload = null;
          killListener();
        });
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxCompletionBar', mxCompletionBarDirective);

  /** @ngInject */
  function mxCompletionBarDirective(
    BROADCAST
  ) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/shared/directives/mx-completion-bar/mx-completion-bar.html',
      link: function ($scope) {
        
        _init();
        
        //////////

        function _init() {
          _setupEvents();
        }
        
        /**
         * Callback on progress update.
         */
        function _onProgressUpdate(evt, data) {
          $scope.progress = data.progress;
        }

        /**
         * Setup directive events.
         */
        function _setupEvents() {
          $scope.$on(BROADCAST.COMPLETION_BAR.UPDATE, _onProgressUpdate);
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxChatUser', mxChatUserDirective);

  /** @ngInject */
  function mxChatUserDirective() {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/shared/directives/mx-chat-user/mx-chat-user.html',
      scope: {
        user: '=',
        type: '='
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxChatMessage', mxChatMessageDirective);

  /** @ngInject */
  function mxChatMessageDirective() {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/shared/directives/mx-chat-message/mx-chat-message.html',
      scope: {
        message: '=',
        welcome: '='
      },
      link: function ($scope) {
        
        // Methods
        $scope.emojiOnly = emojiOnly;
        $scope.getTime = getTime;
        
        ////////
        
        function getTime(timeString) {
          var time = moment(timeString);
          if (!time)
            return timeString;
          
          var diff = moment().diff(time, 'minutes'),
              isYesterday = moment().subtract(1, 'days').isSame(time, 'day'),
              isToday = moment().isSame(time, 'day');

          if (isYesterday) {
            return 'Ontem - ' + time.format('HH:mm');
          } else if (isToday) {
            return (diff >= 1) ? time.format('HH:mm') : 'agora';
          } else {
            return time.format('DD/MM/YY - HH:mm');
          }
        }

        /**
         * Check if message has emojis only.
         * @param {*} message 
         */
        function emojiOnly(message) {
          if (!message)
            return false;
          var regex = new RegExp('([\uD800-\uDBFF][\uDC00-\uDFFF]|[\u2000-\u3300]|[\u00A9-\u00AE]|[\uFE0F])', 'gm'),
              hasEmojis = message.match(regex),
              cleanMessage = message.replace(regex, ''),
              enlarge = hasEmojis && hasEmojis.length && cleanMessage.length == 0;
          return enlarge;
        }
        
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxChat', mxChatDirective);

  /** @ngInject */
  function mxChatDirective(
    $interval,
    $timeout,
    BROADCAST,
    ChatService,
    InfoBarService,
    PusherService
  ) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/shared/directives/mx-chat/mx-chat.html',
      scope: {
        focusTextarea: '=',
        history: '=',
        messages: '=',
        new: '=',
        showUsers: '=',
        chat: '=',
        pagination: '='
      },
      link: function ($scope) {
        // Vars
        var listeners = [],
            workingHoursInterval = null;
        $scope.replyMessage = '';
        $scope.staffOnline = true;
        $scope.outsideWorkingHours = false;

        // Methods
        $scope.onLoadMoreClick = onLoadMoreClick;
        $scope.onMessageSend = onMessageSend;
        
        _init();
        
        ////////
        
        function _init() {
          if (!$scope.history) {
            listeners.push($scope.$on(BROADCAST.QUICK_PANEL.OPEN, _onQuickPanelOpen));
            listeners.push($scope.$on(BROADCAST.CHAT.USERS_CHANGED, _onUsersChanged));
            listeners.push($scope.$on(BROADCAST.PUSHER.ONLINE, _onUsersChanged));
            workingHoursInterval = $interval(_checkWorkingHours, 1000);
          }
          $scope.replyMessage = '';
          
          $scope.$watch('messages', function (newVal, oldVal) {
            if (newVal) {
              var prevMessage = null;
              $scope.messages.map(function (message) {
                var authorType = message.author_type.toLowerCase();

                if (authorType == 'clients')
                  authorType = 'client';

                if (prevMessage) {
                  if (message.author_type != prevMessage.author_type) {
                    message.user = $scope.chat[authorType];
                  }
                } else {
                  message.user = $scope.chat[authorType];
                }
                
                prevMessage = message;
              });
            }
          });
        }

        /**
         * Check if current time is outside working hours.
         */
        function _checkWorkingHours() {
          var now = moment(),
              outsideHours = now.isBefore(moment({ hour: 9, minute: 0 })) || now.isAfter(moment({ hour: 18, minute: 0 })),
              isWeekend = now.weekday() == 0 || now.weekday() == 6;
          $scope.outsideWorkingHours = isWeekend || outsideHours;
        }

        /**
         * Returns a random ID for the temp message.
         */
        function _getRandomId() {
          return Math.random() + '_id_' + $scope.messages.length;
        }

        /**
         * Update message on error.
         */
        function _messageError(messageObject) {
          $scope.messages = $scope.messages.map(function (message) {
            if (message.id == messageObject.id) {
              message.error = true;
              message.pending = false;
            }
            return message;
          });
        }

        /**
         * Sends the message. 
         */
        function _sendMessage(messageObject) {
          if (!$scope.chat) {
            InfoBarService.error('Sua mensagem não pôde ser enviada. Tente abrir a conversa novamente.');
            return;
          }

          ChatService.sendMessage($scope.chat.id, messageObject.message).then(function (res) {
            _updateMessage(messageObject, res);
          }, function (err) {
            console.error('err', err);
            InfoBarService.error(err);
            _messageError(messageObject);
          });
        }

        /**
         * Update message on success.
         */
        function _updateMessage(messageObject, actualMessage) {
          $scope.messages = $scope.messages.map(function (message) {
            if (message.id != messageObject.id)
              return message;
            else {
              actualMessage.pending = false;
              return angular.extend({}, message, actualMessage);
            }
          });
        }
        
        /**
         * Quick panel open event.
         */
        function _onQuickPanelOpen(evt, data) {
          _scrollToBottomOfChat(0);
        }

        /**
         * User's presence channel change event.
         */
        function _onUsersChanged(evt, data) {
          var onlineStaffIds = PusherService.getStaffIds();
          $scope.staffOnline = onlineStaffIds && onlineStaffIds.length;
        }

        /**
         * Scrolls the chat to the bottom.
         */
        function _scrollToBottomOfChat(speed) {
          var chatDialog = angular.element('#chat-dialog');

          $timeout(function() {
            chatDialog.animate({
              scrollTop: chatDialog[0].scrollHeight
            }, speed);
          }, 10);
        }

        /**
         * Load more callback.
         */
        function onLoadMoreClick() {
          if ($scope.loadingMore)
            return;
          $scope.loadingMore = true;

          ChatService.getMessages($scope.chat.id, $scope.pagination.page + 1).then(function (res) {
            $scope.messages = res.messages.concat($scope.messages);
            $scope.pagination = res.pagination;
          }, function (err) {
            console.error('err', err);
            InfoBarService.error(err);
          }).finally(function () {
            $scope.loadingMore = false;
          });
        }
        
        /**
         * Message submit callback.
         */
        function onMessageSend(message) {
          if (message === '') {
            return;
          }

          if (!$scope.messages) {
            $scope.messages = [];
          }

          var messageObject = {
            id: _getRandomId(),
            author_type: 'Clients',
            message: message,
            created_at: new Date(),
            pending: true
          };

          $scope.messages.push(messageObject);

          $scope.replyMessage = '';
          _scrollToBottomOfChat(400);
          _sendMessage(messageObject);
        }
        
        /**
         * Destroy any broadcast listener.
         */
        $scope.$on('$destroy', function () {
          listeners.forEach(function (killListener) {
            killListener();
          });
          if (workingHoursInterval)
            clearInterval(workingHoursInterval);
        });
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxBreadcrumb', mxBreadcrumbDirective);

  /** @ngInject */
  function mxBreadcrumbDirective() {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/shared/directives/mx-breadcrumb/mx-breadcrumb.html',
      scope: {
        crumbs: '='
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('app.shared.directives').directive('mxBkg', mxBkgDirective);

  function mxBkgDirective(
    $mdMedia,
    $rootScope,
    BROADCAST,
    BroadcastService
  ) {
    return {
      restrict: 'AE',
      scope: {
        color: '=bkgColor',
        size: '=bkgSize',
        image: '=bkgImage',
        position: '=bkgPosition',
        repeat: '=bkgRepeat',
        fallback: '=bkgFallback'
      },
      link: function($scope, element, $attrs) {

        var prev = null;

        function set() {
          var image = angular.copy($scope.image);

          if (!image)
            image = '';
          else if (image.url && image.path)
            image = image.url + image.path;
          else if (image.url && image.t_120)
            image = image.url + image.t_120;

          if (image == '' && $scope.fallback)
            image = $scope.fallback;

          element.css({
            'background-color': $scope.color || '#F9F9F9',
            'background-image': 'url(' + image + ')',
            'background-size': $scope.size || 'cover',
            'background-position': $scope.position || 'center',
            'background-repeat': $scope.repeat || 'no-repeat'
          });
        }

        $scope.$watch('image', function(n, o) {
          if (n != undefined)
            set();
        });

        set();
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxAvatar', mxAvatarDirective);

  /** @ngInject */
  function mxAvatarDirective(
    $http,
    AuthService,
    BROADCAST
  ) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/shared/directives/mx-avatar/mx-avatar.html',
      scope: {
        url: '=',
        icon: '=',
        callback: '='
      },
      link: function ($scope) {
        var currentUser = AuthService.getUser(),
            tempUrl = $scope.url || currentUser.avatar_url;
        
        if (tempUrl) {
          // Load the avatar image.
          $http.get(tempUrl).then(function(data) {
            $scope.avatar = tempUrl;
          });
        }

        // Methods
        $scope.onAvatarClick = onAvatarClick;
        
        ////////
        
        function onAvatarClick() {
          $scope.callback && $scope.callback();
        }

        var onUploadSuccess = $scope.$on(BROADCAST.IMAGE.UPLOAD_AVATAR_SUCCESS, function(event, picture) {
          $scope.avatar = picture.avatar_url + '#' + new Date();
        });

        $scope.$on('$destroy', function() {
          onUploadSuccess();
        })
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.shared.directives')
    .directive('mxActivities', mxActivitiesDirective);

  /** @ngInject */
  function mxActivitiesDirective(
    AuthService
  ) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/shared/directives/mx-activities/mx-activities.html',
      scope: {
        issue: '=',
        activities: '=',
        action: '=',
        hiddenFields: '=',
        lastAccess: '=',
        callbackDetails: '=',
        callbackMore: '=',
        callbackSearch: '=',
        callbackItem: '=',
        isIssue: '=',
        pagination: '='
      },
      link: function($scope) {
        $scope.isClient = AuthService.isClient();
        $scope.fixDynamicHeight = true;

        // Methods
        $scope.onSearch = onSearch;

        ////////

        /**
         * Search callback.
         * 
         * @param {String} searchValue 
         */
        function onSearch(searchValue) {
          $scope.query = searchValue;
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('app.shared.filters', []);

})();

(function() {
  'use strict';

  angular
    .module('app.shared.filters')
    .filter('yesNo', yesNo);

  /** @ngInject */
  function yesNo() {
    return yesNoFilter;
    
    function yesNoFilter(booleanValue) {
      return booleanValue ? 'Sim' : 'Não';
    }
  }
  
})();

(function() {
  'use strict';

  angular
    .module('app.shared.filters')
    .filter('roleName', roleName);

  /** @ngInject */
  function roleName() {
    return roleNameFilter;
    
    function roleNameFilter(role) {
      switch (role) {
        case 'ADMIN': return 'Administrador';
        case 'admins': return 'Administradores';
        case 'ATTENDANT': return 'Atendente';
        case 'attendants': return 'Atendentes';
        case 'client': return 'Cliente';
        case 'clients': return 'Clientes';
        case 'observer': return 'Interessado';
        case 'observers': return 'Interessados';
        case 'staff': return 'Equipe';
        case 'user': return 'Usuário';
        case 'users': return 'Usuários';
        default: return 'Administrador';
      }
    }
  }
  
})();

(function() {
  'use strict';

  angular
    .module('app.shared.filters')
    .filter('numberFixedLen', numberFixedLen);

  /** @ngInject */
  function numberFixedLen() {
    return numberFixedLenFilter;
    
    function numberFixedLenFilter(n, len) {
      var num = parseInt(n, 10);
      len = parseInt(len, 10);

      if (isNaN(num) || isNaN(len))
        return n;

      num = '' + num;
      while (num.length < len) {
        num = '0' + num;
      }
      return num;
    }
  }
  
})();

(function() {
  'use strict';

  angular
    .module('app.shared.filters')
    .filter('issueStatus', issueStatus);

  /** @ngInject */
  function issueStatus() {
    return issueStatusFilter;
    
    function issueStatusFilter(role) {
      switch (role) {
        case 'PENDING': return 'Em andamento';
        case 'FINISHED': return 'Encerrado';
        default: return 'Em andamento';
      }
    }
  }
  
})();

(function() {
  'use strict';

  angular
    .module('app.shared.filters')
    .filter('docStatus', docStatus);

  /** @ngInject */
  function docStatus() {
    return docStatusFilter;
    
    function docStatusFilter(role) {
      switch (role) {
        case 'approved': return 'Aprovado';
        case 'pending_review': return 'Aguardando revisão';
        case 'pending_upload': return 'Aguardando envio';
        case 'rejected': return 'Reprovado';
        default: return 'Aguardando envio';
      }
    }
  }
  
})();

(function() {
  'use strict';

  angular
    .module('app.shared.filters')
    .filter('activityType', activityType);

  /** @ngInject */
  function activityType() {
    return activityTypeFilter;
    
    function activityTypeFilter(role) {
      switch (role) {
        case 0:
        case 'ISSUE_CREATE':
          return 'Abertura do Chamado';
        case 1:
        case 'ISSUE_UPDATE':
          return 'Atualização do Chamado';
        case 2:
        case 'ISSUE_CLOSE':
          return 'Encerramento do Chamado';
        case 3:
        case 'DOCUMENT_CREATE':
          return 'Criação de Documento';
        case 4:
        case 'DOCUMENT_REVIEW':
          return 'Revisão de Documento';
        case 5:
        case 'DOCUMENT_UPLOAD':
          return 'Upload de Documento';
        case 6:
        case 'CONVERSATION_CREATE':
          return 'Nova Conversa';
        case 7:
        case 'MESSAGE_CREATE':
          return 'Mensagem';
        case 8:
        case 'CLIENT_INVITE':
          return 'Convite';
        case 9:
        case 'DOCUMENT_DELETE':
          return 'Exclusão de Documento';
        case 10:
        case 'CONVERSATION_CLOSE':
          return 'Conversa Encerrada';
        case 11:
        case 'OBSERVER_ADDED':
          return 'Interessado Adicionado';
        case 12:
        case 'OBSERVER_REMOVED':
          return 'Interessado Removido';
        default: return 'Atividade';
      }
    }
  }
  
})();

(function() {
  'use strict';

  angular.module('app.partials.dialogs', []).controller('DialogController', DialogController);

  function DialogController(DialogService, locals) {

    var vm = this;

    // Data
    vm.dialog = locals;

    // Methods
    vm.cancel = closeDialog;
    vm.closeDialog = closeDialog;
    vm.hide = hide;

    //////////

    /**
     * Close (negative).
     */
    function cancel(data) {
      DialogService.cancel(data);
    }

    /**
     * Close dialog.
     */
    function closeDialog() {
      DialogService.cancel();
    }

    /**
     * Close (positive).
     */
    function hide(data) {
      DialogService.hide(data);
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.pages.home', [])
    .config(config);

  /** @ngInject */
  function config(
    ACCESS,
    $stateProvider, 
    $translatePartialLoaderProvider, 
    msNavigationServiceProvider
  ) {
    // State
    $stateProvider.state('app.pages_home', {
      url: '/home?tab',
      views: {
        'content@app': {
          templateUrl: 'app/main/pages/home/home.html',
          controller: 'HomeController as vm'
        }
      },
      bodyClass: 'home',
      access: ACCESS.ONLINE.PUBLIC,
      params: {
        tab: null
      }
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('app.pages.home')
    .controller('ProfileController', ProfileController);

  /** @ngInject */
  function ProfileController(
    msUtils,
    AuthService,
    BROADCAST,
    BroadcastService,
    ClientService,
    InfoBarService,
    LoaderService,
    LocationService,
    StructureService,
    ObserverService,
    $scope,
    Upload,
    API,
    ActivateService,
    $timeout,
    $rootScope
  ) {
    // Data
    var vm = this,
        ENTITY_TYPE = StructureService.getStructure('CLIENT', 'ENTITY_TYPE'),
        FIELDS = {
          CELLPHONE: 'cellphone',
          PHONE: 'phone',
          POSTAL_CODE: 'postal_code',
          ADDRESS: 'address',
          ADDRESS_NUMBER: 'address_number',
          COMPLEMENT: 'complement',
          DISTRICT: 'district',
          CITY: 'city',
          STATE: 'state',
          PASSWORD: 'password',
          PASSWORD_CONFIRMATION: 'password_confirmation' 
        },
        LOADERS = {
          INFO: 'infoFormLoader',
          PASSWORD: 'passwordFormLoader'
        };
    vm.formEdited = false;
    vm.breadcrumbs = [
      {
        label: 'Home',
        state: 'app.pages_home'
      },
      {
        label: 'Meus Dados'
      }
    ];
    vm.currentUser = AuthService.getUser();
    
    // Mockup
    
    // Methods
    vm.onInfoSubmit = onInfoSubmit;
    vm.onPasswordSubmit = onPasswordSubmit;
    
    _init();
    
    ////////
    
    function _init() {
      // _showLoader();
      BroadcastService.broadcast(BROADCAST.FAB.SHOW, null, true);
      
      vm.isClient = AuthService.isClient();
      vm.states = LocationService.getStates();
      vm.user = angular.copy(vm.currentUser);
      
      if (vm.isClient) {
        vm.clientDocName = (vm.user.entity_type == ENTITY_TYPE.NATURAL_PERSON) ? 'CPF' : 'CNPJ';
      }

      var user = AuthService.getUser();
      vm.userAvatar = user && user.avatar_url ? user.avatar_url : 'assets/images/avatars/profile.jpg';
    }
  
    /**
     * Clear the password form.
     */
    function _clearPasswordForm() {
      delete vm.user.current_password;
      delete vm.user.password;
      delete vm.user.password_confirmation;
      vm.passwordForm.$setPristine();
      vm.passwordForm.$setUntouched();
    }
    
    /**
     * Enables address fields.
     */
    function _enableAddressFields(enable) {
      var fields = [
        FIELDS.ADDRESS, 
        FIELDS.DISTRICT, 
        FIELDS.ADDRESS_NUMBER, 
        FIELDS.COMPLEMENT, 
        FIELDS.CITY, 
        FIELDS.STATE
      ];
      enable && fields.forEach(_enableField);
      !enable && fields.forEach(_disableField);
    }
    
    /**
     * Hides the loader.
     */
    function _hideLoader(loaderId) {
      vm.loading = false;
      LoaderService.hideGlobal();
      LoaderService.hide(loaderId);
    }
    
    /**
     * Shows the loader.
     */
    function _showLoader(loaderId) {
      vm.loading = true;
      if (msUtils.isMobile() || (!msUtils.isMobile() && !loaderId))
        LoaderService.showGlobal();
      else
        LoaderService.show(loaderId);
    }
    
    /**
     * Info form submit event.
     */
    function onInfoSubmit(isInvalid) {
      if (isInvalid || vm.loading)
        return;
      
      if (vm.isClient) {
        _showLoader(LOADERS.INFO);
        ClientService.updateClient(vm.user).then(function (client) {
          InfoBarService.success('Dados atualizados com sucesso!');
          vm.user = angular.extend({}, vm.user, client);
        }, function (err) {
          console.error(err);
          InfoBarService.error(err);
        }).finally(function () {
          _hideLoader(LOADERS.INFO);
        });
      } else {
        _showLoader();
        var observer = angular.copy(vm.user);
        ObserverService.updateObserver(observer).then(function (updatedObserver) {
          InfoBarService.success('Dados atualizados com sucesso!');
          vm.user = angular.extend({}, vm.user, updatedObserver);
        }, function (err) {
          InfoBarService.error(err);
        })
        .finally(function () {
          _hideLoader();
        });
      }
    }
    
    /**
     * Password form submit event.
     */
    function onPasswordSubmit(isInvalid) {
      if (isInvalid || vm.loading)
        return;
        
      _showLoader(LOADERS.PASSWORD);
      
      if (vm.isClient) {
        ClientService.updateClient(vm.user).then(function (client) {
          vm.user = angular.extend({}, vm.user, client);
          _clearPasswordForm();
        }, function (err) {
          console.error(err);
          InfoBarService.error(err);
        }).finally(function () {
          _hideLoader(LOADERS.PASSWORD);
        });
      }
    }

    function handleFormEdit() {
      vm.formEdited = true;
    }

    function _handleErrorUploadAvatar(err) {
      $timeout(function() {
        $scope.$broadcast(BROADCAST.IMAGE.UPLOAD_ERROR);
      }, 500);
      InfoBarService.error(err);
    }

    function _handleUploadAvatar() {
      var user = AuthService.getUser();
      ActivateService.activateAvatarUser({
        userType: user.user_type.toLowerCase()+'s',
        userId: user.id
      })
      .then(function(resp) {
        var updatedUser = angular.extend({}, user, resp.data);

        AuthService.setUser(updatedUser);
        $timeout(function() {
          $rootScope.$broadcast(BROADCAST.IMAGE.UPLOAD_AVATAR_SUCCESS, resp.data);
        }, 500);

        return resp;
      }, _handleErrorUploadAvatar)
    }

    function uploadAvatar($event, file) {
      var currentUser = AuthService.getUser();
      var url = currentUser.refresh_url || currentUser.avatar_url;
      return Upload.http({
        url: url,
        data: file,
        method: API.METHODS.PUT,
        headers: { 'Content-Type': file.type }
      }).then(_handleUploadAvatar, _handleErrorUploadAvatar);
    }

    var onUploadInit = $scope.$on(BROADCAST.IMAGE.UPLOAD_START, uploadAvatar);
    
    var onPasswordChange = $scope.$on('profile-password-form:on-change', handleFormEdit);
    var onInfoFormChange = $scope.$on('profile-info-form:on-change', handleFormEdit);

    $scope.$on('$destroy', function() {
      onPasswordChange();
      onInfoFormChange();
      onUploadInit();
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('app.pages.init', [])
    .config(config);

  /** @ngInject */
  function config(
    ACCESS,
    $stateProvider
  ) {
    // State
    $stateProvider.state('app.pages_init', {
      url: '/',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.pages_init': {
          templateUrl: 'app/main/pages/init/init.html',
          controller: 'InitController as vm'
        }
      },
      bodyClass: 'init',
      animationClass: 'animate-fade',
      access: ACCESS.OFFLINE
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('app.pages.init')
    .controller('InitController', InitController);

  /** @ngInject */
  function InitController(
    StateService
  ) {
    var vm = this;
    
    // Methods
    vm.goLogin = goLogin;

    function goLogin() {
      StateService.go('app.pages_auth_login')
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.pages.home')
    .controller('HomeController', HomeController);

  /** @ngInject */
  function HomeController(
    msUtils,
    AuthService,
    BROADCAST,
    BroadcastService,
    InfoBarService,
    IssueService,
    LoaderService,
    QuickPanelService,
    StateService,
    ActivityService,
    StructureService
  ) {
    // Data
    var vm = this,
        issues = [];
    vm.currentUser = AuthService.getUser();
    vm.issues = [];
    vm.isClient = AuthService.isClient();
    vm.pagination = null;
    vm.issueStatus = [];

    // Methods
    
    vm.onAvatarClick = onAvatarClick;
    vm.onNewChatClick = onNewChatClick;
    vm.onMyDataClick = onMyDataClick;
    vm.onChangeFilterStatus = onChangeFilterStatus;
    vm.onClickIssue = onClickIssue;
    vm.onLoadMoreIssuesClick = onLoadMoreIssuesClick;
    vm.onLoadMoreActivitiesIssue = onLoadMoreActivitiesIssue;
    
    _init();
    
    ////////
    
    function _init() {
      BroadcastService.broadcast(BROADCAST.FAB.SHOW, null, true);
      
      // Load most recent issue only. Next paginations: 3 per page.
      _loadIssues(1, {
        per_page: 1
      });
    }
    
    /**
     * Hides the loader.
     */
    function _hideLoader(loaderId) {
      vm.loading = false;
      LoaderService.hideGlobal();
      LoaderService.hide(loaderId);
    }
    
    /**
     * Shows the loader.
     */
    function _showLoader(loaderId) {
      vm.loading = true;
      if (msUtils.isMobile() || !loaderId)
        LoaderService.showGlobal();
      else
        LoaderService.show(loaderId);
    }

    /**
     * Load filters by status
     */
    function _loadFilters() {
      vm.issueStatus = [];
      Object.keys(StructureService.getStructure('ISSUE', 'STATUS')).forEach(function(item, index) {
        vm.issueStatus.push({
          id: index,
          label: item
        })
      })
    }
    
    /**
     * Load the user's issues.
     */
    function _loadIssues(page, options) {
      _showLoader();
      
      if (vm.isClient) {
        IssueService.getClientIssues(vm.currentUser.id, page, options).then(function (res) {
          _addIssues(res.issues);
          _resolvePagination(res);
        }, function (err) {
          console.error(err);
          InfoBarService.error(err);
        }).finally(_hideLoader);
      } else {
        _loadFilters();
        IssueService.getObserverIssues(vm.currentUser.id, page, options)
        .then(function(res) {
          _addIssues(res.issues);
          _resolvePagination(res);

          return _loadActivities(vm.issues)
        }, function(err) {
          console.error(err);
          InfoBarService.error(err);
        })
        .finally(_hideLoader);
      }
    }

    /**
     * Load the current issue's activities for observer user.
     * 
     * @param {Number} page 
     */
    function _loadActivities(issues, page) {
      return ActivityService.getActivitiesForObserver(issues, page, {});
    }

    /**
     * Add paginated issues to existing issues.
     */
    function _addIssues(items) {
      var existingIds = vm.issues.map(function (issue) {
        return issue.id;
      });

      items.forEach(function (issue) {
        if (existingIds.indexOf(issue.id) == -1)
          vm.issues.push(issue);
      });
      
      issues = vm.issues;
    }

    /**
     * Updates pagination variables.
     */
    function _resolvePagination(res) {
      vm.pagination = res.pagination;
    }

    /**
     * Click on issue
     */
    function onClickIssue(issue) {
      StateService.go('app.pages_issues_issue', {
        id: issue.id
      });
    }

    /**
     * On change filter by status 
     */
    function onChangeFilterStatus() {
      if (!vm.filterByStatus) {
        vm.issues = issues;
        return
      }

      vm.issues = issues.filter(function(issue) {
        return issue.status == vm.filterByStatus;
      })
    }

    /**
     * Click event for opening my data view.
     */
    function onMyDataClick() {
      StateService.go('app.pages_profile');
    }
    
    /**
     * Avatar click callback event.
     */
    function onAvatarClick() {
      StateService.go('app.pages_profile');
    }

    /**
     * Load more issues click event.
     * First pagination only increases per page to 3. Next paginations actually navigate pages.
     */
    function onLoadMoreIssuesClick() {
      var nextPage = (vm.pagination.per_page == 1) ? vm.pagination.page : vm.pagination.page + 1;
      _loadIssues(nextPage);
    }

    /**
     * Load more activities click event
     */
    function onLoadMoreActivitiesIssue(issue) {
      var pagination = issue.activities && issue.activities.pagination || {};
      var nextPage = (pagination.per_page == 1) ? pagination.page : pagination.page + 1;

      ActivityService.getIssueActivities(issue.id, nextPage, {})
      .then(function(res) {
        issue.activities.items = issue.activities.items.concat(res.activities);
        issue.activities.pagination = res.pagination;
      }, function(err) {
        InfoBarService.error(err);
      })
    }

    /**
     * Click event for opening a new chat.
     */
    function onNewChatClick() {
      QuickPanelService.open();
    }
  }
})();

(function() {
  'use strict';

  angular.module('app.core.services', []);

})();

(function() {
  'use strict';

  angular
    .module('app.core.services')
    .factory('msUtils', msUtils);

  /** @ngInject */
  function msUtils($window) {
    // Private variables
    var mobileDetect = new MobileDetect($window.navigator.userAgent),
      browserInfo = null;

    var service = {
      exists: exists,
      detectBrowser: detectBrowser,
      guidGenerator: guidGenerator,
      isMobile: isMobile,
      toggleInArray: toggleInArray
    };

    return service;

    //////////

    /**
     * Check if item exists in a list
     *
     * @param item
     * @param list
     * @returns {boolean}
     */
    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    /**
     * Returns browser information
     * from user agent data
     *
     * Found at http://www.quirksmode.org/js/detect.html
     * but modified and updated to fit for our needs
     */
    function detectBrowser() {
      // If we already tested, do not test again
      if (browserInfo) {
        return browserInfo;
      }

      var browserData = [{
          string: $window.navigator.userAgent,
          subString: 'Edge',
          versionSearch: 'Edge',
          identity: 'Edge'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Chrome',
          identity: 'Chrome'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'OmniWeb',
          versionSearch: 'OmniWeb/',
          identity: 'OmniWeb'
        },
        {
          string: $window.navigator.vendor,
          subString: 'Apple',
          versionSearch: 'Version',
          identity: 'Safari'
        },
        {
          prop: $window.opera,
          identity: 'Opera'
        },
        {
          string: $window.navigator.vendor,
          subString: 'iCab',
          identity: 'iCab'
        },
        {
          string: $window.navigator.vendor,
          subString: 'KDE',
          identity: 'Konqueror'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Firefox',
          identity: 'Firefox'
        },
        {
          string: $window.navigator.vendor,
          subString: 'Camino',
          identity: 'Camino'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Netscape',
          identity: 'Netscape'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'MSIE',
          identity: 'Explorer',
          versionSearch: 'MSIE'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Trident/7',
          identity: 'Explorer',
          versionSearch: 'rv'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Gecko',
          identity: 'Mozilla',
          versionSearch: 'rv'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Mozilla',
          identity: 'Netscape',
          versionSearch: 'Mozilla'
        }
      ];

      var osData = [{
          string: $window.navigator.platform,
          subString: 'Win',
          identity: 'Windows'
        },
        {
          string: $window.navigator.platform,
          subString: 'Mac',
          identity: 'Mac'
        },
        {
          string: $window.navigator.platform,
          subString: 'Linux',
          identity: 'Linux'
        },
        {
          string: $window.navigator.platform,
          subString: 'iPhone',
          identity: 'iPhone'
        },
        {
          string: $window.navigator.platform,
          subString: 'iPod',
          identity: 'iPod'
        },
        {
          string: $window.navigator.platform,
          subString: 'iPad',
          identity: 'iPad'
        },
        {
          string: $window.navigator.platform,
          subString: 'Android',
          identity: 'Android'
        }
      ];

      var versionSearchString = '';

      function searchString(data) {
        for (var i = 0; i < data.length; i++) {
          var dataString = data[i].string;
          var dataProp = data[i].prop;

          versionSearchString = data[i].versionSearch || data[i].identity;

          if (dataString) {
            if (dataString.indexOf(data[i].subString) !== -1) {
              return data[i].identity;

            }
          } else if (dataProp) {
            return data[i].identity;
          }
        }
      }

      function searchVersion(dataString) {
        var index = dataString.indexOf(versionSearchString);

        if (index === -1) {
          return;
        }

        return parseInt(dataString.substring(index + versionSearchString.length + 1));
      }

      var browser = searchString(browserData) || 'unknown-browser';
      var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
      var os = searchString(osData) || 'unknown-os';

      // Prepare and store the object
      browser = browser.toLowerCase();
      version = browser + '-' + version;
      os = os.toLowerCase();

      browserInfo = {
        browser: browser,
        version: version,
        os: os
      };

      return browserInfo;
    }

    /**
     * Generates a globally unique id
     *
     * @returns {*}
     */
    function guidGenerator() {
      var S4 = function() {
        return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
      };
      return (S4() + S4() + S4() + S4() + S4() + S4());
    }

    /**
     * Return if current device is a
     * mobile device or not
     */
    function isMobile() {
      mobileDetect = new MobileDetect($window.navigator.userAgent);
      return mobileDetect.mobile();
    }

    /**
     * Toggle in array (push or splice)
     *
     * @param item
     * @param array
     */
    function toggleInArray(item, array) {
      if (array.indexOf(item) === -1) {
        array.push(item);
      } else {
        array.splice(array.indexOf(item), 1);
      }
    }
  }
}());

(function() {
  'use strict';

  angular.module('app.core.interceptors', []);

})();

(function() {
  'use strict';

  angular
    .module('app.core.interceptors')
    .factory('AuthInterceptor', AuthInterceptor);

  /** @ngInject */
  function AuthInterceptor(localStorageService) {
        
    /**
     * Intercept $http requests.
     */
    function request(req) {          
      var token = localStorageService.get('access-token'),
          url = req.url;
          
      if (token && url.indexOf('viacep.com.br') == -1 && url.indexOf('amazonaws.com') == -1)
        req.headers['Authorization'] = 'Bearer ' + token; 
        
      return req;
    }
    
    /**
     * Intercept $http responses.
     */
    function response(res) {    
      var url = res.config.url,
          headers = res.headers(),
          token = headers['access-token'];
          
      if (url.indexOf('login') != -1 && token) {
        localStorageService.set('access-token', token);
      } else if (url.indexOf('logout') != -1) {
        localStorageService.set('access-token', null);
        localStorageService.set('user', null);
      }
      
      return res;
    }
    
    // function responseError(res) {
    //   return response(res);
    // }

    return {
      request: request,
      response: response
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('app.core', [
      'ngAnimate',
      'ngAria',
      'ngCookies',
      'ngMessages',
      'ngResource',
      'ngSanitize',
      'ngMaterial',
      'pascalprecht.translate',
      'ui.router',
      'flow',
      'textAngular',
      'LocalStorageModule',
      'ngFileUpload',
      'ngRetina',
      'ngMask',
      // 'pusher-angular',
      
      // Constants
      'app.core.constants',
      
      // Interceptors
      'app.core.interceptors',
      
      // Services
      'app.core.services'
    ]);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function() {
  'use strict';

  angular
    .module('app.core')
    .directive('msSplashScreen', msSplashScreenDirective);

  /** @ngInject */
  function msSplashScreenDirective($animate) {
    return {
      restrict: 'E',
      link: function(scope, iElement) {
        var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function() {
          $animate.leave(iElement).then(function() {
            // De-register scope event
            splashScreenRemoveEvent();

            // Null-ify everything else
            scope = iElement = null;
          });
        });
      }
    };
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Chat',
                        'icon'       : 'icon-hangouts',
                        'state'      : 'app.chat',
                        'badge'      : {
                            'content': 13,
                            'color'  : '#09d261'
                        },
                        'weight'     : 5,
                        'children'   : [],
                        '_id'        : 'chat',
                        '_path'      : 'apps.chat',
                        'uisref'     : 'app.chat',
                        'hasShortcut': true
                    }, {
                        'title'      : 'Contacts',
                        'icon'       : 'icon-account-box',
                        'state'      : 'app.contacts',
                        'weight'     : 10,
                        'children'   : [],
                        '_id'        : 'contacts',
                        '_path'      : 'apps.contacts',
                        'uisref'     : 'app.contacts',
                        'hasShortcut': true
                    }, {
                        'title'      : 'Notes',
                        'icon'       : 'icon-lightbulb',
                        'state'      : 'app.notes',
                        'weight'     : 11,
                        'children'   : [],
                        '_id'        : 'notes',
                        '_path'      : 'apps.notes',
                        'uisref'     : 'app.notes',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function() {
  'use strict';

  angular.module('app.core.constants', []);

})();

(function() {
  'use strict';

  angular
    .module('app.core.constants')
    .constant('TARGET', {
      CLIENTS: 'ClientsT',
      CLIENTS_T: 'Clients',
      CONVERSATION: 'Conversation',
      DOCUMENTS: 'IssueDocuments',
      ISSUES: 'Issues',
      MESSAGE: 'Message',
      OBSERVERS: 'Observers',
      OBSERVERS_T: 'ObserversT',
    });

})();

(function() {
  'use strict';

  angular
    .module('app.core.constants')
    .constant('OPERATION', {
      CREATE: 100,
      UPDATE: 200,
      READ_ONLY: 300
    });

})();

(function() {
  'use strict';

  angular
    .module('app.core.constants')
    .constant('BROADCAST', {
      AUTH: {
        LOGIN: 'auth:login',
        LOGOUT: 'auth:logout',
        UPDATED: 'auth:updated'
      },
      CHAT: {
        ASSIGNED: 'chat:assigned',
        CLOSED: 'chat:closed',
        CREATED: 'chat:created',
        DEASSIGNED: 'chat:deassigned',
        NEW_MESSAGE: 'chat:new-message',
        USERS_CHANGED: 'chat:users-changed'
      },
      COMPLETION_BAR: {
        HIDE: 'completion-bar:hide',
        SHOW: 'completion-bar:show',
        UPDATE: 'completion-bar:update'
      },
      FAB: {
        CLICK: 'fab:click',
        HIDE: 'fab:hide',
        SHOW: 'fab:show'
      },
      HEADER: {
        BACK: 'header:back',
        DELETE_ALL: 'header:delete-all',
        DESELECT_ALL: 'header:deselect-all',
        SELECT_ALL: 'header:select-all',
        POP_ITEM: 'header:pop-item',
        PUSH_ITEM: 'header:push-item',
        RESET: 'header:reset'
      },
      IMAGE: {
        UPLOAD_START: 'image:upload-start',
        UPLOAD_SUCCESS: 'image:upload-success',
        UPLOAD_ERROR: 'image:upload-error',
        IMAGE_DELETED: 'image:image-deleted',
        UPLOAD_AVATAR_SUCCESS: 'image:upload-avatar-success'
      },
      INFOBAR: {
        HIDE: 'infobar:hide',
        SHOW: 'infobar:show'
      },
      LOADER: {
        START: 'loader:start',
        STOP: 'loader:stop'
      },
      PUSHER: {
        ONLINE: 'pusher:online'
      },
      QUICK_PANEL: {
        CLEAR: 'quick-panel:clear',
        CLOSE: 'quick-panel:close',
        OPEN: 'quick-panel:open'
      }
    });

})();

(function() {
  'use strict';

  angular
    .module('app.core.constants')
    .constant('APP', {
      // CLIENTS_URL: 'http://localhost:3001', // DEV
      // CLIENTS_URL: 'https://app-hml.segurocomseguro.com.br', // HML
      CLIENTS_URL: 'https://app.segurocomseguro.com.br', // PRD
      PUSHER: {

        // DEV
        // APP_ID: '540220',
        // KEY: 'be73f29cd2df254b1990',
        // SECRET: '4b1705a0648b17e27792',
        // CLUSTER: 'us2',
        
        // HML
        // APP_ID: '540221',
        // KEY: '60574277e03434711ff1',
        // SECRET: '6fd514fdd030e71c8c0c',
        // CLUSTER: 'us2',
        
        // PRD
        APP_ID: '540222',
        KEY: '097aa833add3023b6afd',
        SECRET: 'fb4f8fd13feddce17def',
        CLUSTER: 'us2',

        EVENTS: {
          CONNECTED: 'connected',
          MEMBER_ADDED: 'pusher:member_added',
          MEMBER_REMOVED: 'pusher:member_removed',
          NEW_MESSAGE: 'new_message',
          STATE_CHANGED: 'state_changed',
          SUBSCRIPTION_ERROR: 'pusher:subscription_error',
          SUBSCRIPTION_SUCCEEDED: 'pusher:subscription_succeeded',
          CONVERSATION_UPDATE: 'conversation_update'
        }
      }
    });

})();

(function() {
  'use strict';

  angular
    .module('app.core.constants')
    .constant('API', {
      // HOST: 'http://localhost:3000', // DEV
      // HOST: 'https://api-hml.segurocomseguro.com.br', // HML
      HOST: 'https://api.segurocomseguro.com.br', // PRD
      METHODS: {
        DELETE: 'delete',
        GET: 'get',
        POST: 'post',
        PUT: 'put',
        PATCH: 'patch'
      }
    });

})();

(function() {
  'use strict';

  angular
    .module('app.core.constants')
    .constant('ACCESS', {
      UNRESTRICTED: -1,
      OFFLINE: 0,
      ONLINE: {
        PUBLIC: 100,
        ADMIN: 200
      }
    });

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('app.core')
    .config(config);

  /** @ngInject */
  function config($mdThemingProvider, agsPalettes, agsThemes) {
    // Inject Cookies Service
    var $cookies;
    angular.injector(['ngCookies']).invoke([
      '$cookies',
      function(_$cookies) {
        $cookies = _$cookies;
      }
    ]);

    // Check if custom theme exist in cookies
    var customTheme = $cookies.getObject('customTheme');
    if (customTheme) {
      agsThemes['custom'] = customTheme;
    }

    $mdThemingProvider.alwaysWatchTheme(true);

    // Define custom palettes
    angular.forEach(agsPalettes, function(palette) {
      $mdThemingProvider.definePalette(palette.name, palette.options);
    });

    // Register custom themes
    angular.forEach(agsThemes, function(theme, themeName) {
      $mdThemingProvider.theme(themeName)
        .primaryPalette(theme.primary.name, theme.primary.hues)
        .accentPalette(theme.accent.name, theme.accent.hues)
        .warnPalette(theme.warn.name, theme.warn.hues)
        .backgroundPalette(theme.background.name, theme.background.hues);
    });
  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function() {
  'use strict';

  var agsThemes = {
    default: {
      primary: {
        name: 'ags-dark-blue',
        hues: {
          'default': '700',
          'hue-1': '500',
          'hue-2': '600',
          'hue-3': '400'
        }
      },
      accent: {
        name: 'ags-light-blue',
        hues: {
          'default': '600',
          'hue-1': '400',
          'hue-2': '700',
          'hue-3': 'A100'
        }
      },
      warn: {
        name: 'red'
      },
      background: {
        name: 'grey',
        hues: {
          'default': 'A100',
          'hue-1': '50',
          'hue-2': '100',
          'hue-3': '200'
        }
      }
    },
    'whiteTheme': {
      primary: {
        name: 'white'
      },
      accent: {
        name: 'white'
      },
      warn: {
        name: 'white'
      },
      background: {
        name: 'white'
      }
    }
  };

  angular
    .module('app.core')
    .constant('agsThemes', agsThemes);
})();

(function() {
  'use strict';
  
  var agsPalettes = [{
      name: 'ags-light-blue',
      options: {
        '50': '#02BDDC',
        '100': '#D8D8D8',
        '200': '#02BDDC',
        '300': '#02BDDC',
        '400': '#02CEED',
        '500': '#02BDDC',
        '600': '#02BDDC',
        '700': '#02ACCB',
        '800': '#02ACCB',
        '900': '#029BBA',
        'A100': '#02BDDC',
        'A200': '#02BDDC',
        'A400': '#02BDDC',
        'A700': '#02BDDC',
        'contrastDefaultColor': 'light',
        'contrastDarkColors': '50 100 200 A100',
        'contrastStrongLightColors': '300 400'
      }
    },
    {
      name: 'ags-dark-blue',
      options: {
        '50': '#005282',
        '100': '#005282',
        '200': '#005282',
        '300': '#005282',
        '400': '#005282',
        '500': '#005282',
        '600': '#005282',
        '700': '#005282',
        '800': '#005282',
        '900': '#005282',
        'A100': '#005282',
        'A200': '#005282',
        'A400': '#005282',
        'A700': '#005282',
        'contrastDefaultColor': 'light',
        'contrastDarkColors': '50 100 200 A100',
        'contrastStrongLightColors': '300 400'
      }
    },
    {
      name: 'white',
      options: {
        '50': '#FFFFFF',
        '100': '#FFFFFF',
        '200': '#FFFFFF',
        '300': '#FFFFFF',
        '400': '#FFFFFF',
        '500': '#FFFFFF',
        '600': '#FFFFFF',
        '700': '#FFFFFF',
        '800': '#FFFFFF',
        '900': '#FFFFFF',
        'A100': '#FFFFFF',
        'A200': '#FFFFFF',
        'A400': '#FFFFFF',
        'A700': '#FFFFFF',
        'contrastDefaultColor': 'dark',
        'contrastDarkColors': '50 100 200 A100',
        'contrastStrongLightColors': '300 400'
      }
    }
  ];

  angular
    .module('app.core')
    .constant('agsPalettes', agsPalettes);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function() {
  'use strict';

  angular
    .module('app.toolbar')
    .controller('ToolbarController', ToolbarController);

  /** @ngInject */
  function ToolbarController(
    $mdSidenav, 
    $rootScope,
    $scope,
    $timeout,
    $window,
    AuthService,
    BROADCAST,
    PusherService,
    QuickPanelService,
    StateService,
    msNavigationService
  ) {
    var vm = this,
        listeners = [],
        titleInterval = null;

    // Data
    vm.bodyEl = angular.element('body');
    vm.currentUser = AuthService.getUser();
    vm.simpleHeader = StateService.current().simpleHeader;
    vm.isClient = AuthService.isClient();

    vm.notifications = [];

    // Methods
    vm.onLogoutClick = onLogoutClick;
    vm.onMyProfileClick = onMyProfileClick;
    vm.onNotificationMenuOpen = onNotificationMenuOpen;
    vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
    vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
    vm.toggleSidenav = toggleSidenav;
    vm.openNotification = openNotification;

    _init();

    //////////

    /**
     * Initialize
     */
    function _init() {
      listeners.push($scope.$on(BROADCAST.AUTH.UPDATED, _onCurrentUserUpdate));
      listeners.push($scope.$on(BROADCAST.FAB.CLICK, _onFabClick));
      listeners.push($scope.$on(BROADCAST.CHAT.NEW_MESSAGE, _onNewMessageReceived));
      listeners.push($scope.$on(BROADCAST.QUICK_PANEL.OPEN, _onQuickPanelOpen));

      $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
        vm.simpleHeader = toState.simpleHeader;
      });
      
      // vm.notifications = [
      // {
      //   id: 1,
      //   type: 1,
      //   description: 'Você tem pendências em upload de documentos',
      //   icon: 'paperclip'
      // },
      // {
      //   id: 2,
      //   type: 2,
      //   description: 'Roberto Melody enviou uma mensagem',
      //   image: 'assets/images/avatars/profile.jpg'
      // }]; 
    }

    /**
     * Hides the notification badge.
     */
    function _hideBadge() {
      vm.showBadge = false;
    }
    
    /**
     * Hides the badge when opening the quick panel.
     */
    function _onQuickPanelOpen() {
      _hideBadge();
    }

    /**
     * Hides the badge when opening the notification menu.
     */
    function onNotificationMenuOpen() {
      _hideBadge();
    }

    /**
     * Handle notification 
     * @param  {Object} notification
     * @return {}
     */
    function openNotification(notification) {
      if (!QuickPanelService.isOpen())
        _onFabClick();
    }
    
    /**
     * Update the current user on the toolbar if was updated somewhere else.
     */
    function _onCurrentUserUpdate(evt, user) {
      vm.isClient = AuthService.isClient();
      vm.currentUser = user;
    }
    
    /**
     * FAB click event.
     */
    function _onFabClick(evt) {
      QuickPanelService.open();
    }

    /**
     * New message received callback.
     */
    function _onNewMessageReceived(evt, data) {
      var defaultTitle = 'Seguro com Seguro';

      // Browser tab is active
      if (!document.hidden) {
        if (QuickPanelService.isOpen())
          return;

        $timeout(function () {
          vm.notifications = [{
            id: vm.notifications.length + 1,
            type: 1,
            description: data.author_name ? data.author_name + ' enviou uma mensagem' : 'Você recebeu uma mensagem',
            image: 'assets/images/avatars/profile.jpg'
          }];
          vm.showBadge = true;
        }, 1);

      // Browser tab is inactive
      } else {
        // Blink tab title.
        if (!titleInterval) {
          titleInterval = setInterval(function () {
            if (document.title == defaultTitle)
              document.title = 'Nova mensagem - ' + defaultTitle;
            else
              document.title = defaultTitle;
          }, 1000);
        }

        // Clear interval on focus.
        $window.onfocus = function () {
          if (!titleInterval)
            return;
          clearInterval(titleInterval);
          titleInterval = null;
          document.title = defaultTitle;
        };
      }

      // Send notification
      PusherService.sendNotification(data.author_name, data.message, data);
    }

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      return $mdSidenav(sidenavId).toggle();
    }

    /**
     * Logout Function
     */
    function onLogoutClick() {
      AuthService.logout();
    }
    
    /**
     * Opens user profile modal to edit current logged user profile.
     *
     */
    function onMyProfileClick() {
      StateService.go('app.pages_profile');
    }

    /**
     * Toggle horizontal mobile menu
     */
    function toggleHorizontalMobileMenu() {
      vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
    }

    /**
     * Toggle msNavigation folded
     */
    function toggleMsNavigationFolded() {
      msNavigationService.toggleFolded();
    }
    
    /**
     * Destroy any broadcast listener.
     */
    $scope.$on('$destroy', function () {
      listeners.forEach(function (killListener) {
        killListener();
      });
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('app.quick-panel', []);
   
})();

(function() {
  'use strict';

  angular
    .module('app.quick-panel')
    .controller('QuickPanelController', QuickPanelController);

  /** @ngInject */
  function QuickPanelController(
    $mdSidenav,
    $scope,
    $timeout,
    BROADCAST,
    AuthService,
    ChatService,
    DialogService,
    InfoBarService,
    LoaderService,
    PusherService,
    QuickPanelService
  ) {
    var vm = this,
        listeners = [];

    // Data
    vm.date = new Date();
    vm.settings = {
      notify: true,
      cloud: false,
      retro: true
    };
    vm.chat = {};
    vm.chatActive = false;
    vm.currentUser = AuthService.getUser();
    vm.newChat = false;

    // Methods
    // vm.toggleChat = toggleChat;
    vm.onCloseClick = onCloseClick;
    vm.onViewPreviousChatClick = onViewPreviousChatClick;
    
    _init();

    //////////

    function _init() {
      listeners.push($scope.$on(BROADCAST.QUICK_PANEL.CLEAR, _onQuickPanelClear));
      listeners.push($scope.$on(BROADCAST.QUICK_PANEL.OPEN, _onQuickPanelOpen));
      listeners.push($scope.$on(BROADCAST.CHAT.NEW_MESSAGE, _onNewMessageReceived));
      listeners.push($scope.$on(BROADCAST.CHAT.USERS_CHANGED, _onUsersChanged));
      listeners.push($scope.$on(BROADCAST.CHAT.ASSIGNED, _onChatAssigned));
      listeners.push($scope.$on(BROADCAST.CHAT.CLOSED, _onChatClosed));
      listeners.push($scope.$on(BROADCAST.CHAT.DEASSIGNED, _onChatDeassigned));

      // Show loader when closing.
      $scope.$watch(
        function() { return $mdSidenav('quick-panel').isOpen(); },
        function(isOpen) {
          if (!isOpen) {
            _showLoader();
          }
        }
      );
    }
    
    /**
     * Hides the loader.
     */
    function _hideLoader() {
      vm.loading = false;
      LoaderService.hide('quickPanelLoader');
    }
    
    /**
     * Starts the loader.
     */
    function _showLoader() {
      vm.loading = true;
      LoaderService.show('quickPanelLoader');
    }

    /**
     * Scrolls the chat to the bottom.
     */
    function _scrollToBottomOfChat(speed) {
      var chatDialog = angular.element('#chat-dialog');

      if (!chatDialog || !chatDialog[0])
        return;

      $timeout(function() {
        chatDialog.animate({
          scrollTop: chatDialog[0].scrollHeight
        }, speed || 0);
      }, 10);
    }

    /**
     * Chat assigned pusher event.
     * @param {*} evt 
     * @param {*} data 
     */
    function _onChatAssigned(evt, chat) {
      $timeout(function () {
        // vm.chat = angular.extend({}, vm.chat, ChatService.resolveChat(chat));
        vm.chat = ChatService.resolveChat(chat);
        if (vm.chat.previous_conversation_id)
          vm.messages = [];
        vm.newChat = false;
        vm.transferChat = false;
      });
    }

    /**
     * Chat closed pusher event.
     * @param {*} evt 
     * @param {*} data 
     */
    function _onChatClosed(evt, chat) {
      $timeout(function () {
        vm.chat = ChatService.resolveChat(chat);
        vm.newChat = false;
        vm.transferChat = false;
      });
    }
    
    /**
     * Chat deassigned pusher event.
     * @param {*} evt 
     * @param {*} data 
     */
    function _onChatDeassigned(evt, chat) {
      $timeout(function () {
        // vm.chat = angular.extend({}, vm.chat, ChatService.resolveChat(chat));
        vm.chat = ChatService.resolveChat(chat);
        vm.newChat = false;
        vm.transferChat = true;
      });
    }

    /**
     * New message received event.
     * @param {*} evt 
     * @param {*} data 
     */
    function _onNewMessageReceived(evt, data) {
      if (vm.chat && vm.messages) {
        $timeout(function () {
          vm.messages.push(data);
          _scrollToBottomOfChat();
        }, 1);
      }
    }
    
    /**
     * Quick panel clear event.
     */
    function _onQuickPanelClear(evt) {
      _showLoader();
      vm.chat = {};
    }
    
    /**
     * Quick panel open event.
     */
    function _onQuickPanelOpen(evt, data) {
      _showLoader();
      vm.currentUser = AuthService.getUser();

      // Get / create chat.
      ChatService.createChat(vm.currentUser.id, data.issueId).then(function (chat) {
        vm.chat = chat;

        if (!vm.chat.staff_id && vm.chat.previous_conversation_id) {
          // Transfer chat:
          vm.newChat = false;
          vm.transferChat = true;
        } else if (!vm.chat.staff_id) {
          // New chat:
          vm.newChat = true; 
          vm.transferChat = true; 
          vm.chat.user = {
            name: 'Equipe Seguro com Seguro'
          };
        } else {
          vm.newChat = false; 
          vm.transferChat = false; 
        }

        // Get messages.
        ChatService.getMessages(vm.chat.id).then(function (res) {
          $timeout(function () {
            vm.messages = res.messages;
            vm.pagination = res.pagination;
            vm.focusTextarea = true;
            _scrollToBottomOfChat();
            _hideLoader();
          }, 1);
        }, _finishError);
      }, _finishError);

      function _finishError(err) {
        console.error(err);
        InfoBarService.error(err);
        _hideLoader();
        onCloseClick();
      }
    }

    /**
     * Presence channel users change.
     */
    function _onUsersChanged() {
      $timeout(function () {
        var updatedChat = ChatService.resolveChat(vm.chat);
        vm.chat.status = updatedChat.status;
        vm.chat.icon = updatedChat.icon;
      }, 1);
    }

    /**
     * Closes the panel.
     */
    function onCloseClick() {
      QuickPanelService.close();
    }

    /**
     * Closes the panel.
     */
    function onViewPreviousChatClick() {
      DialogService.chatHistory(null, vm.chat.previous_conversation_id);
    }
    
    /**
     * Destroy any broadcast listener.
     */
    $scope.$on('$destroy', function () {
      listeners.forEach(function (killListener) {
        killListener();
      });
    });
  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function() {
  'use strict';

  angular
    .module('app.navigation')
    .controller('NavigationController', NavigationController);

  /** @ngInject */
  function NavigationController($scope) {
    var vm = this;

    // Data
    vm.bodyEl = angular.element('body');
    vm.folded = false;
    vm.msScrollOptions = {
      suppressScrollX: true
    };

    // Methods
    vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

    //////////

    /**
     * Toggle folded status
     */
    function toggleMsNavigationFolded() {
      vm.folded = !vm.folded;
    }

    // Close the mobile menu on $stateChangeSuccess
    $scope.$on('$stateChangeSuccess', function() {
      vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
    });
  }

})();

(function() {
  'use strict';

  /**
   * Main module of the Fuse
   */
  angular
    .module('fuse', [

      // Core
      'app.core',

      // Navigation
      'app.navigation',

      // Toolbar
      'app.toolbar',
      
      // Quick Panel
      'app.quick-panel',

      // Shared
      'app.shared',
      
      // Pages
      'app.pages',
      
      // Partials
      'app.partials'
    ]).config(config);
    
    function config($translatePartialLoaderProvider) {
      // Translation
      $translatePartialLoaderProvider.addPart('app');
    }
})();

(function() {
  'use strict';

  angular
    .module('fuse')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($scope, $rootScope) {
    // Data

    //////////

    // Remove the splash screen
    $scope.$on('$viewContentAnimationEnded', function(event) {
      if (event.targetScope.$id === $scope.$id) {
        $rootScope.$broadcast('msSplashScreen::remove');
      }
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('app.core')
    .run(runBlock);

  /** @ngInject */
  function runBlock(
    ACCESS,
    $rootScope, 
    AuthService,
    StateService,
    fuseConfig, 
    fuseGenerator, 
    localStorageService,
    msUtils,
    PusherService
  ) {
    PusherService.requestNotificationPermission();
    
    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
      var access = toState.access,
          UNRESTRICTED = ACCESS.UNRESTRICTED,
          ONLINE = ACCESS.ONLINE,
          OFFLINE = ACCESS.OFFLINE,
          PUBLIC = ONLINE.PUBLIC,
          ADMIN = ONLINE.ADMIN;
          
      localStorageService.setStorageType('localStorage');

      PusherService.init();

      var isLogged = AuthService.isLogged();

      if (access == UNRESTRICTED)
        return;
        
      if (isLogged && access == OFFLINE) {
        var url = StateService.getQueryParam('url');
        if (url)
          StateService.goTo(url);
        else
          return redirectToIndex(event);
      }
       
      if (!isLogged && access != OFFLINE) {
        return redirectToLogin(event);
      }
      
      if (!Array.isArray(access)) {
        access = [access];
      }
      
      if (isLogged) {
        var anyAccess = false;
        access.forEach(function (singleAccess) {
          if (
            singleAccess == ADMIN && AuthService.is(ADMIN) || 
            singleAccess == PUBLIC && AuthService.is(PUBLIC)
          ) {
            anyAccess = true;
          }
        });
        if (!anyAccess)        
          redirectToIndex(event);

        PusherService.requestNotificationPermission();
      }
    });    
    
    /**
     * Redirect user to index state.
     */
    function redirectToIndex(event) {
      event.preventDefault();
      return StateService.index();
    }
    
    /**
     * Redirect user to login state.
     */
    function redirectToLogin(event) {
      event.preventDefault();
      return StateService.go('app.pages_auth_login');
    }
    
    /**
     * Generate extra classes based on registered themes so we
     * can use same colors with non-angular-material elements
     */
    fuseGenerator.generate();

    /**
     * Disable md-ink-ripple effects on mobile
     * if 'disableMdInkRippleOnMobile' config enabled
     */
    if (fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile()) {
      var bodyEl = angular.element('body');
      bodyEl.attr('md-no-ink', true);
    }

    /**
     * Put isMobile() to the html as a class
     */
    if (msUtils.isMobile()) {
      angular.element('html').addClass('is-mobile');
    }

    /**
     * Put browser information to the html as a class
     */
    var browserInfo = msUtils.detectBrowser();
    if (browserInfo) {
      var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
      angular.element('html').addClass(htmlClass);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.core')
    .config(config);

  /** @ngInject */
  function config(
    $ariaProvider, 
    $logProvider, 
    msScrollConfigProvider, 
    fuseConfigProvider,
    localStorageServiceProvider,
    $httpProvider,
    $mdDateLocaleProvider
  ) {
    // Enable debug logging
    $logProvider.debugEnabled(true);

    /*eslint-disable */

    // ng-aria configuration
    $ariaProvider.config({
      tabindex: false
    });

    // Fuse theme configurations
    fuseConfigProvider.config({
      'disableCustomScrollbars': false,
      'disableCustomScrollbarsOnMobile': true,
      'disableMdInkRippleOnMobile': true
    });

    // msScroll configuration
    msScrollConfigProvider.config({
      wheelPropagation: true
    });

    localStorageServiceProvider
      .setPrefix('ags')
      .setStorageType('localStorage')
      .setNotify(true, true);

    $httpProvider.interceptors.push('AuthInterceptor');

    /*eslint-enable */

    // Datepicker locale configuration.

    $mdDateLocaleProvider.formatDate = function(date) {
      if (!date)
        return '';

      var d = date.getDate(),
          m = date.getMonth() + 1,
          year = date.getFullYear(),
          day = (d < 10) ? '0' + d : d,
          month = (m < 10) ? '0' + m : m;

      return day + '/' + month + '/' + year;
    };

    $mdDateLocaleProvider.parseDate = function(dateString) {
      dateString = dateString.split('/');
      var day = dateString[0],
          month = dateString[1],
          year = dateString[2],
          date = new Date(year + '-' + month + '-' + day);
      return date;
    };

    // PT-BR i18n.
    $mdDateLocaleProvider.months = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
    $mdDateLocaleProvider.shortMonths = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
    $mdDateLocaleProvider.days = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
    $mdDateLocaleProvider.shortDays = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'];
  }
})();

(function() {
  'use strict';

  angular
    .module('fuse')
    .run(runBlock);

  /** @ngInject */
  function runBlock($rootScope, $timeout, $state) {

    // Activate loading indicator
    var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function() {
      $rootScope.loadingProgress = true;
    });

    // De-activate loading indicator
    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function() {
      $timeout(function() {
        $rootScope.loadingProgress = false;
      });
    });

    // Store state in the root scope for easy access
    $rootScope.state = $state;

    // Cleanup
    $rootScope.$on('$destroy', function() {
      stateChangeStartEvent();
      stateChangeSuccessEvent();
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('fuse')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    $locationProvider.html5Mode(true);

    $urlRouterProvider.otherwise('/');

    /**
     * Layout Style Switcher
     *
     * This code is here for demonstration purposes.
     * If you don't need to switch between the layout
     * styles like in the demo, you can set one manually by
     * typing the template urls into the `State definitions`
     * area and remove this code
     */
    // Inject $cookies
    var $cookies;

    angular.injector(['ngCookies']).invoke([
      '$cookies',
      function(_$cookies) {
        $cookies = _$cookies;
      }
    ]);

    // Get active layout
    var layoutStyle = $cookies.get('layoutStyle') || 'contentWithToolbar';

    var layouts = {
      verticalNavigation: {
        main: 'app/core/layouts/vertical-navigation.html',
        toolbar: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
        navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
      },
      verticalNavigationFullwidthToolbar: {
        main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
        toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
        navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
      },
      verticalNavigationFullwidthToolbar2: {
        main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
        toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
        navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
      },
      horizontalNavigation: {
        main: 'app/core/layouts/horizontal-navigation.html',
        toolbar: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
        navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
      },
      contentOnly: {
        main: 'app/core/layouts/content-only.html',
        toolbar: '',
        navigation: ''
      },
      contentWithToolbar: {
        main: 'app/core/layouts/content-with-toolbar.html',
        toolbar: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
        navigation: ''
      }
    };
    // END - Layout Style Switcher

    // State definitions
    $stateProvider
      .state('app', {
        abstract: true,
        views: {
          'main@': {
            templateUrl: layouts[layoutStyle].main,
            controller: 'MainController as vm'
          },
          'toolbar@app': {
            templateUrl: layouts[layoutStyle].toolbar,
            controller: 'ToolbarController as vm'
          },
          'navigation@app': {
            templateUrl: layouts[layoutStyle].navigation,
            controller: 'NavigationController as vm'
          },
          'quickPanel@app': {
            templateUrl: 'app/quick-panel/quick-panel.html',
            controller: 'QuickPanelController as vm'
          }
        }
      });
  }

})();

(function() {
  'use strict';

  angular
    .module('fuse')
    .controller('IndexController', IndexController);

  /** @ngInject */
  function IndexController(
    BROADCAST, 
    $scope, 
    fuseTheming
    ) {
      var vm = this;

      // Data
      vm.infoBarMessage = '';
      vm.displayCompletionBar = false;
      vm.displayInfoBar = false;
      vm.themes = fuseTheming.themes;

      //////////

      function _init() {
        _setupEvents();
      }

      /**
       * Setup controller events.
       */
      function _setupEvents() {
        $scope.$on(BROADCAST.INFOBAR.SHOW, _showInfoBar);
        $scope.$on(BROADCAST.INFOBAR.HIDE, _hideInfoBar);
        $scope.$on(BROADCAST.COMPLETION_BAR.SHOW, _showCompletionBar);
        $scope.$on(BROADCAST.COMPLETION_BAR.HIDE, _hideCompletionBar);
      }

      /**
       * Hides the completion bar.
       */
      function _hideCompletionBar() {
        vm.displayCompletionBar = false;
      }

      /**
       * Shows the completion bar.
       */
      function _showCompletionBar() {
        vm.displayCompletionBar = true;
      }
      
      /**
       * Hides the infobar.
       */
      function _hideInfoBar() {
        vm.displayInfoBar = false;
        vm.infoBarMessage = '';
      }

      /**
       * Shows the infobar.
       */
      function _showInfoBar(evt, data) {
        var message = data.message[0];
        vm.infoBarSuccess = data.success || false;
        vm.infoBarMessage = data.message[0];
        vm.displayInfoBar = true;
      }

      _init();
  }
})();

(function() {
  'use strict';

  angular
    .module('fuse');
})();

(function() {
  'use strict';

  angular
    .module('fuse')
    .config(config);

  /** @ngInject */
  function config($translateProvider, $provide) {
    // Put your common app configurations here

    // angular-translate configuration
    $translateProvider.useLoader('$translatePartialLoader', {
      urlTemplate: '{part}/i18n/{lang}.json'
    });
    $translateProvider.preferredLanguage('pt');
    $translateProvider.useSanitizeValueStrategy('sanitize');

    // Text Angular options
    $provide.decorator('taOptions', [
      '$delegate',
      function(taOptions) {
        taOptions.toolbar = [
          ['bold', 'italics', 'underline', 'ul', 'ol', 'quote']
        ];

        taOptions.classes = {
          focussed: 'focussed',
          toolbar: 'ta-toolbar',
          toolbarGroup: 'ta-group',
          toolbarButton: 'md-button',
          toolbarButtonActive: 'active',
          disabled: '',
          textEditor: 'form-control',
          htmlEditor: 'form-control'
        };

        return taOptions;
      }
    ]);

    // Text Angular tools
    $provide.decorator('taTools', [
      '$delegate',
      function(taTools) {
        taTools.quote.iconclass = 'icon-format-quote';
        taTools.bold.iconclass = 'icon-format-bold';
        taTools.italics.iconclass = 'icon-format-italic';
        taTools.underline.iconclass = 'icon-format-underline';
        taTools.strikeThrough.iconclass = 'icon-format-strikethrough';
        taTools.ul.iconclass = 'icon-format-list-bulleted';
        taTools.ol.iconclass = 'icon-format-list-numbers';
        taTools.redo.iconclass = 'icon-redo';
        taTools.undo.iconclass = 'icon-undo';
        taTools.clear.iconclass = 'icon-close-circle-outline';
        taTools.justifyLeft.iconclass = 'icon-format-align-left';
        taTools.justifyCenter.iconclass = 'icon-format-align-center';
        taTools.justifyRight.iconclass = 'icon-format-align-right';
        taTools.justifyFull.iconclass = 'icon-format-align-justify';
        taTools.indent.iconclass = 'icon-format-indent-increase';
        taTools.outdent.iconclass = 'icon-format-indent-decrease';
        taTools.html.iconclass = 'icon-code-tags';
        taTools.insertImage.iconclass = 'icon-file-image-box';
        taTools.insertLink.iconclass = 'icon-link';
        taTools.insertVideo.iconclass = 'icon-filmstrip';

        return taTools;
      }
    ]);
  }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        /**
         * Here you can find all the definitions that the Demo Project requires
         *
         * If you wish to use this method, you can create your API definitions
         * in a similar way.
         */

        /*
         api.dashboard = {
         project  : $resource(api.baseUrl + 'dashboard/project/data.json'),
         server   : $resource(api.baseUrl + 'dashboard/server/data.json'),
         analytics: $resource(api.baseUrl + 'dashboard/analytics/data.json')
         };

         api.cards = $resource(api.baseUrl + 'cards/cards.json');

         api.fileManager = {
         documents: $resource(api.baseUrl + 'file-manager/documents.json')
         };

         api.ganttChart = {
         tasks: $resource(api.baseUrl + 'gantt-chart/tasks.json'),
         timespans : $resource(api.baseUrl + 'gantt-chart/timespans.json')
         };

         api.icons = $resource('assets/icons/selection.json');

         api.invoice = $resource(api.baseUrl + 'invoice/invoice.json');

         api.mail = {
         inbox: $resource(api.baseUrl + 'mail/inbox.json')
         };

         api.profile = {
         timeline    : $resource(api.baseUrl + 'profile/timeline.json'),
         about       : $resource(api.baseUrl + 'profile/about.json'),
         photosVideos: $resource(api.baseUrl + 'profile/photos-videos.json')
         };

         api.quickPanel = {
         activities: $resource(api.baseUrl + 'quick-panel/activities.json'),
         contacts  : $resource(api.baseUrl + 'quick-panel/contacts.json'),
         events    : $resource(api.baseUrl + 'quick-panel/events.json'),
         notes     : $resource(api.baseUrl + 'quick-panel/notes.json')
         };

         api.search = {
         classic : $resource(api.baseUrl + 'search/classic.json'),
         mails   : $resource(api.baseUrl + 'search/mails.json'),
         users   : $resource(api.baseUrl + 'search/users.json'),
         contacts: $resource(api.baseUrl + 'search/contacts.json')
         };

         api.scrumboard = {
         boardList: $resource(api.baseUrl + 'scrumboard/boardList.json'),
         board    : $resource(api.baseUrl + 'scrumboard/boards/:id.json')
         };

         api.tables = {
         employees   : $resource(api.baseUrl + 'tables/employees.json'),
         employees100: $resource(api.baseUrl + 'tables/employees100.json')
         };

         api.timeline = {
         page1: $resource(api.baseUrl + 'timeline/page-1.json'),
         page2: $resource(api.baseUrl + 'timeline/page-2.json'),
         page3: $resource(api.baseUrl + 'timeline/page-3.json')
         };

         api.todo = {
         tasks: $resource(api.baseUrl + 'todo/tasks.json'),
         tags : $resource(api.baseUrl + 'todo/tags.json')
         };
         */

        return api;
    }

})();
(function() {
  'use strict';

  angular
    .module('app.pages.profile', [])
    .config(config);

  /** @ngInject */
  function config(
    ACCESS,
    $stateProvider, 
    $translatePartialLoaderProvider, 
    msNavigationServiceProvider
  ) {
    // State
    $stateProvider.state('app.pages_profile', {
      url: '/meus-dados',
      views: {
        'content@app': {
          templateUrl: 'app/main/pages/profile/profile.html',
          controller: 'ProfileController as vm'
        }
      },
      bodyClass: 'profile',
      access: ACCESS.ONLINE.PUBLIC
    });
  }

})();

(function() {
  'use strict';

  angular.module('app.partials', [
    
    // Dialogs
    'app.partials.dialogs',
    'app.partials.dialogs.user-profile',
    'app.partials.dialogs.chat-history',
    'app.partials.dialogs.document-preview'
  ]).config(config);
  
  /** @ngInject */
  function config($translatePartialLoaderProvider) {
    // Translation
    $translatePartialLoaderProvider.addPart('app/main/partials');
  }

})();

(function() {
  'use strict';

  angular
    .module('app.pages', [
      'app.pages.init',
      'app.pages.auth.login',
      'app.pages.auth.forgot-password',
      'app.pages.auth.register',
      'app.pages.auth.reset-password',
      'app.pages.home',
      'app.pages.profile',
      'app.pages.issues.issue'
    ]);
   
})();

(function() {
  'use strict';

  angular.module('app.shared', [
  
    // Models
    'app.shared.models',
    
    // Services
    'app.shared.services',
    
    // Filters
    'app.shared.filters',
    
    // Directives
    'app.shared.directives'
  ]);

})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content class=\"chat-panel scrollable\" ms-scroll><mx-loader loader-id=\"quickPanelLoader\" starts-on=\"true\" \nlocal=\"true\"></mx-loader><div class=\"chat animate-slide-right\" layout=\"column\"><md-toolbar \nclass=\"chat-header md-primary\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"new-chat\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.newChat\"><md-icon class=\"s16 mr-10\" \nmd-font-icon=\"icon-message-text\"></md-icon><span>Nova conversa</span></div><div class=\"contact\" layout=\"row\" \nlayout-align=\"start center\" ng-if=\"!vm.newChat\" flex><img ng-src=\"{{vm.chat.user.avatar_url}}\" \nsrc=\"assets/images/avatars/profile.jpg\" class=\"avatar mr-10\" noretina mx-img-orientation \nng-if=\"vm.chat.user.avatar_url\"> <img src=\"assets/images/avatars/profile.jpg\" class=\"avatar mr-10\" mx-img-orientation \nng-if=\"!vm.chat.user.avatar_url\"><div layout=\"column\" flex><span class=\"name text-truncate\">\n{{vm.chat.user.name || (vm.transferChat ? \'Em transferência...\' : \'Carregando...\')}}</span><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"status\" \nmd-colors=\"{\'backgroundColor\': vm.chat.status == \'online\' ? \'green-500\' : \'grey-500\'}\" ng-if=\"!vm.transferChat\"></span>\n <span class=\"role\" ng-if=\"vm.chat.user.name || vm.transferChat\">\n{{vm.transferChat ? \'Por favor, aguarde.\' : \'Atendente\'}}</span></div></div></div><md-button \nclass=\"prev-chat-button md-icon-button\" ng-if=\"vm.chat.previous_conversation_id && !vm.newChat\"><md-tooltip \nmd-direction=\"bottom\">Ver anterior</md-tooltip><md-icon md-font-icon=\"icon-history\" \nng-click=\"vm.onViewPreviousChatClick()\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.onCloseClick()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div \nclass=\"staff-contact\" layout=\"row\" layout-align=\"start start\" ng-if=\"vm.newChat\"><img \nsrc=\"assets/images/avatars/profile.jpg\" class=\"avatar big mh-10\" noretina><div class=\"mt-16\" layout=\"column\"><span \nclass=\"name\">{{vm.chat.user.name || \'Carregando...\'}}</span> <span class=\"role\" ng-if=\"vm.chat.user\">Atendente</span>\n</div></div><mx-chat new=\"vm.newChat\" chat=\"vm.chat\" contact=\"vm.chat.user\" user=\"vm.currentUser\" \nmessages=\"vm.messages\" focus-textarea=\"vm.focusTextarea\" pagination=\"vm.pagination\"></mx-chat></div></md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar\" ui-view=\"toolbar\" md-colors=\"{background: \'primary-500\'}\"></md-toolbar><md-content \nid=\"content\" class=\"animate-slide-up md-hue-1\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n<mx-fab></mx-fab><mx-loader loader-id=\"globalLoader\" global=\"true\"></mx-loader></div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/home/home.html","<div id=\"home\" layout-fill><div class=\"main scrollable\" ms-scroll flex><mx-container class=\"content\"><mx-panel \nclass=\"mb-30\"><div layout=\"column\" layout-align=\"space-between center\"><mx-avatar class=\"mt-20 mb-15\" icon=\"true\" \ncallback=\"vm.onAvatarClick\"></mx-avatar><h1 class=\"mb-5\">\nOlá, {{vm.currentUser.company_fantasy_name || vm.currentUser.name}}</h1><hr class=\"mb-10\"><md-button \nng-if=\"vm.isClient\" class=\"md-accent md-raised md-sm\" ng-click=\"vm.onNewChatClick()\">Nova Conversa</md-button>\n<md-button ng-if=\"!vm.isClient\" class=\"md-accent md-outline md-raised md-sm md-no-border\" \nng-click=\"vm.onMyDataClick()\">Meus Dados</md-button></div></mx-panel><div class=\"client\" ng-if=\"vm.isClient\">\n<mx-section-divider section-title=\"\'Meus Chamados\'\"></mx-section-divider><mx-issue issue=\"issue\" \nng-repeat=\"issue in vm.issues\" index=\"$index\"></mx-issue><div class=\"mb-50\" layout=\"column\" \nlayout-align=\"center center\" ng-if=\"vm.pagination && vm.pagination.page != vm.pagination.total_pages\"><md-button \ntype=\"submit\" class=\"md-accent md-raised\" ng-click=\"vm.onLoadMoreIssuesClick()\">Outros chamados</md-button></div>\n<mx-empty icon=\"\'icon-clipboard-text\'\" ng-if=\"!vm.loading && (!vm.issues || !vm.issues.length)\">\nNenhum chamado encontrado.</mx-empty></div><div class=\"observer\" ng-if=\"!vm.isClient\"><mx-section-divider \nsection-title=\"\'Chamados\'\"></mx-section-divider><div layout=\"row\" layout-align=\"center center\"><md-select \nclass=\"filter-by-status\" placeholder=\"Filtrar por status\" ng-model=\"vm.filterByStatus\" \nng-change=\"vm.onChangeFilterStatus()\"><md-option value=\"\">Filtrar por status</md-option><md-option \nng-repeat=\"status in vm.issueStatus\" value=\"{{status.label}}\">{{status.label | issueStatus}}</md-option></md-select>\n</div><ng-include src=\"\'app/main/pages/home/issues/issue.html\'\"></ng-include><mx-load-more \nng-if=\"vm.pagination && vm.pagination.page != vm.pagination.total_pages\" callback=\"vm.onLoadMoreIssuesClick\" \ntext=\"\'Outros chamados\'\"></mx-load-more><mx-empty icon=\"\'icon-clipboard-text\'\" \nng-if=\"!vm.loading && (!vm.issues || !vm.issues.length)\">Nenhum chamado encontrado.</mx-empty></div></mx-container>\n</div><mx-footer></mx-footer></div>");
$templateCache.put("app/main/pages/init/init.html","<div id=\"init\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><iframe \nsrc=\"https://player.vimeo.com/video/298261885\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen \nallowfullscreen></iframe><md-button class=\"md-raised md-accent btn\" ng-click=\"vm.goLogin()\">Acessar Plataforma\n</md-button></div><mx-footer external=\"true\"></mx-footer>");
$templateCache.put("app/main/pages/profile/profile.html","<div id=\"profile\" layout-fill><div class=\"main scrollable\" ms-scroll flex><mx-container class=\"content\"><mx-breadcrumb \ncrumbs=\"vm.breadcrumbs\"></mx-breadcrumb><mx-section-divider section-title=\"\'Meus Dados\'\"></mx-section-divider><mx-panel\n class=\"mb-40\"><div class=\"steps base\"><h1>{{vm.user.name}}</h1><hr><mx-readonly-data name=\"\'E-mail\'\" \nvalue=\"vm.user.email\"></mx-readonly-data><mx-readonly-data name=\"vm.clientDocName\" value=\"vm.user.document\" \nng-if=\"vm.isClient\"></mx-readonly-data><hr><div layout=\"row\" layout-align=\"center center\"><mx-image-upload \nimage=\"vm.userAvatar\" is-avatar=\"true\"></mx-image-upload></div></div></mx-panel><mx-panel class=\"mb-40\"><div \nclass=\"steps info\"><mx-loader loader-id=\"infoFormLoader\" local=\"true\"></mx-loader><form name=\"vm.infoForm\"><h3>\nAlterar meus dados</h3><p>Os dados abaixo podem ser alterados, caso necessário</p><mx-profile-info-form \nform=\"vm.infoForm\" model=\"vm.user\" client=\"vm.isClient\" edit=\"true\" states=\"vm.states\" ng-if=\"vm.isClient !== null\">\n</mx-profile-info-form><div ng-if=\"vm.isClient\" class=\"actions\" layout=\"column\" layout-align=\"stretch center\">\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"vm.onInfoSubmit(vm.infoForm.$invalid)\">Salvar alterações\n</md-button></div></form></div></mx-panel><mx-panel class=\"mb-40\"><div class=\"steps password\"><mx-loader \nloader-id=\"passwordFormLoader\" local=\"true\"></mx-loader><form name=\"vm.passwordForm\"><h3>Alterar senha</h3><p>\nVocê pode alterar sua senha de acesso</p><mx-profile-password-form form=\"vm.passwordForm\" model=\"vm.user\" edit=\"true\" \nng-if=\"vm.isClient !== null\"></mx-profile-password-form><div ng-if=\"vm.isClient\" class=\"actions\" layout=\"column\" \nlayout-align=\"stretch center\"><md-button type=\"submit\" class=\"md-accent md-raised\" \nng-click=\"vm.onPasswordSubmit(vm.passwordForm.$invalid)\">Salvar alterações</md-button></div></form></div></mx-panel>\n<div ng-if=\"!vm.isClient\" class=\"actions\" layout=\"column\" layout-align=\"center center\"><md-button \nng-disabled=\"!vm.formEdited\" type=\"submit\" class=\"md-accent md-raised\" \nng-click=\"vm.onInfoSubmit(vm.infoForm.$invalid)\">Salvar alterações</md-button></div></mx-container></div><mx-footer>\n</mx-footer></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/shared/directives/mx-activities/mx-activities.html","<div class=\"mx-activities\"><mx-loader loader-id=\"activitiesLoader{{issue.id}}\" local=\"true\"></mx-loader><div \nclass=\"status-access-container\" layout=\"column\" layout-align=\"center center\" ng-if=\"!isIssue\"><div class=\"status\" \nng-if=\"isClient\">Status: <span class=\"{{issue.readable_status.classes}}\">{{issue.readable_status.value}}</span></div>\n<div class=\"status status--info\" ng-if=\"!isClient\">Atividades no chamado</div><div class=\"access\">Última atualização: \n<span>{{issue.updated_at | date:\'dd/MM/yyyy - HH:mm:ss\'}}</span></div></div><div class=\"status-access-container\" \nlayout=\"column\" layout-align=\"center center\" ng-if=\"isIssue\"><h1 class=\"mb-5\">\n{{issue.client.company_fantasy_name || issue.client.name}}</h1><h5 class=\"mb-5\">nº {{issue.id | numberFixedLen:5}}</h5>\n<hr class=\"mb-10\"><div class=\"status\">Status: <span class=\"{{issue.readable_status.classes}}\">\n{{issue.readable_status.value}}</span></div><hr class=\"mb-10\"><div class=\"last-activity\">\nÚltimas atividades registradas:</div></div><mx-search-input ng-show=\"!isIssue && activities && activities.length\" \ncallback=\"onSearch\"></mx-search-input><mx-table ng-show=\"activities && activities.length\" items=\"activities\" \naction=\"action\" callback-details=\"callbackDetails\" hidden-fields=\"hiddenFields\" query=\"query\"></mx-table><mx-empty \nicon=\"\'icon-view-list\'\" ng-if=\"!loading && (!activities || !activities.length)\">Nenhuma atividade encontrada.\n</mx-empty><mx-load-more ng-if=\"callbackMore && pagination && pagination.page < pagination.total_pages\" \ncallback=\"callbackMore\" callback-item=\"callbackItem\"></mx-load-more><div flex layout=\"row\" \nlayout-align=\"center center\" ng-if=\"isIssue\"><md-button class=\"md-accent md-raised md-sm btn-see-issue\" \nng-click=\"callbackDetails(issue)\">Ver chamado</md-button></div><div ng-show=\"fixDynamicHeight\">&nbsp;</div></div>");
$templateCache.put("app/shared/directives/mx-avatar/mx-avatar.html","<div class=\"mx-avatar\" ng-click=\"onAvatarClick()\"><img ng-src=\"{{avatar}}\" src=\"assets/images/avatars/profile.jpg\" \nnoretina mx-img-orientation ng-if=\"avatar\" class=\"avatar huge mr-0\"> <img src=\"assets/images/avatars/profile.jpg\" \nnoretina ng-if=\"!avatar\" class=\"avatar huge mr-0\"><div class=\"icon-badge md-accent-bg md-hue-1\" ng-if=\"icon\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s16\"></md-icon></div><div class=\"mt-10\" ng-if=\"!icon\"><a \nstyle=\"opacity: 0.3; color: gray; cursor: default\">Alterar imagem</a></div></div>");
$templateCache.put("app/shared/directives/mx-breadcrumb/mx-breadcrumb.html","<div class=\"mx-breadcrumb\" layout=\"row\" layout-align=\"start center\"><div ng-repeat=\"crumb in crumbs\"><span \nng-class=\"{\'link\': crumb.state}\" ui-sref=\"{{crumb.state ? crumb.state : \'.\'}}\">{{crumb.label}}</span><span \nng-if=\"$index < crumbs.length - 1\">&nbsp;/&nbsp;</span></div></div>");
$templateCache.put("app/shared/directives/mx-chat/mx-chat.html","<div class=\"mx-chat\" layout=\"column\" flex><md-content id=\"chat-dialog{{history ? chat.id : \'\'}}\" flex layout-padding \nms-scroll ng-class=\"{\'chat-dialog--history\': history}\"><div class=\"load-more\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"pagination && pagination.page < pagination.total_pages\"><a href=\"\" \nng-click=\"onLoadMoreClick()\">{{loadingMore ? \'Carregando...\' : \'Carregar mais...\'}}</a></div><mx-system-message \nnew-user=\"chat.user\" \nng-if=\"!chat.ended_at && chat.previous_conversation_id && chat.staff_id && (!pagination || pagination.page >= pagination.total_pages)\" \nhistory=\"history\"></mx-system-message><mx-chat-message welcome=\"true\" ng-if=\"new && (!messages || !messages.length)\">\n</mx-chat-message><div ng-repeat=\"message in messages track by message.id\"><mx-chat-user user=\"message.user\" \ntype=\"message.author_type\" ng-if=\"showUsers && message.user\"></mx-chat-user><mx-chat-message message=\"message\">\n</mx-chat-message></div><mx-system-message transferred=\"chat.transferred\" ended-at=\"chat.ended_at\" \nng-if=\"chat.ended_at\" history=\"history\"></mx-system-message><mx-system-message transferring=\"true\" \nng-if=\"chat.previous_conversation_id && !chat.staff_id\" history=\"history\"></mx-system-message><mx-system-message \noffline=\"true\" \nng-if=\"staffOnline && !chat.ended_at && !history && chat.active && chat.staff_id && chat.status === \'offline\'\">\n</mx-system-message><div class=\"pv-100\" layout=\"row\" layout-align=\"center center\" \nng-if=\"history && (!messages || !messages.length)\"><span class=\"grey-400-fg\">Nenhuma mensagem encontrada.</span></div>\n</md-content><div class=\"presence-hours-warning\" layout=\"row\" layout-align=\"center center\" \nng-if=\"outsideWorkingHours || !staffOnline\"><md-icon \nmd-font-icon=\"{{outsideWorkingHours ? \'icon-clock\' : \'icon-account\'}}\" class=\"mr-10 s32 grey-400-fg\"></md-icon><div \nlayout=\"column\"><b class=\"grey-600-fg mb-5\">Nenhum atendente online</b> <span class=\"grey-600-fg\">\n{{outsideWorkingHours ? \'Olá! No momento nossos atendentes estão offline. Deixe sua mensagem e retornaremos assim que possível. Atendemos em horário comercial, de segunda à sexta, das 9h às 18h.\' : \'Olá! No momento nossos atendentes estão offline. Deixe sua mensagem e retornaremos assim que possível.\'}}\n</span></div></div><mx-message-input message=\"replyMessage\" on-send=\"onMessageSend\" boxed=\"true\" \nng-hide=\"history || chat.ended_at || (chat.previous_conversation_id && !chat.staff_id)\"></mx-message-input></div>");
$templateCache.put("app/shared/directives/mx-chat-message/mx-chat-message.html","<div class=\"mx-chat-message\" layout=\"row\" \nlayout-align=\"{{message.author_type == \'Clients\' ? \'end center\' : \'start center\'}}\" \nng-class=\"{\'Clients\': message.author_type == \'Clients\', \'Staff\': message.author_type != \'Clients\',\'pending\': message.pending, \'error\': message.error}\">\n<div flex=\"10\" ng-if=\"message.author_type == \'Clients\' && !welcome\"></div><div class=\"bubble\" \nng-class=\"{\'welcome\': welcome}\"><div class=\"message\" ng-if=\"!welcome\" \nng-class=\"{\'font-size-30\': emojiOnly(message.message)}\">{{message.message}}</div><div class=\"message\" ng-if=\"welcome\">\nBem-vindo(a) ao nosso chat!</div><div class=\"message\" ng-if=\"welcome\">\nEscreva uma mensagem para iniciar a nova conversa.</div><div class=\"time secondary-text\" ng-if=\"!welcome\">\n{{getTime(message.created_at)}}</div></div><div flex=\"10\" ng-if=\"message.author_type == \'Staff\' || welcome\"></div>\n</div>");
$templateCache.put("app/shared/directives/mx-chat-user/mx-chat-user.html","<div class=\"mx-chat-user mb-5\" layout=\"row\" layout-align=\"{{type == \'Clients\' ? \'end center\' : \'start center\'}}\"><img \nng-src=\"{{user.avatar_url}}\" src=\"assets/images/avatars/profile.jpg\" mx-img-orientation class=\"avatar small\"> <span \nclass=\"font-size-12 grey-500-fg\">{{user.name}}</span></div>");
$templateCache.put("app/shared/directives/mx-completion-bar/mx-completion-bar.html","<div class=\"mx-completion-bar\" layout=\"row\" layout-align=\"center center\" flex><mx-container class=\"container\" \nv-padding=\"false\"><div layout=\"column\" layout-align=\"space-between center\"><md-progress-linear class=\"md-accent\" \nmd-mode=\"buffer\" value=\"{{progress}}\"></md-progress-linear><span class=\"progress-label\">{{progress}}% <span \ntranslate=\"DIRECTIVES.COMPLETION_BAR.COMPLETE\">Completo</span><span></span></span></div></mx-container></div>");
$templateCache.put("app/shared/directives/mx-container/mx-container.html","<div class=\"mx-container\" ng-class=\"{\'no-vertical\': vPadding === false, \'small\': small}\"><ng-transclude>\n</ng-transclude></div>");
$templateCache.put("app/shared/directives/mx-details/mx-details.html","<div class=\"mx-details tabs details\" layout=\"column\"><mx-loader loader-id=\"detailsLoader\" local=\"true\"></mx-loader>\n<form name=\"detailsForm\" ng-submit=\"onDetailsSubmit(detailsForm.$invalid)\"><div ng-if=\"!isClient\"><h3>Dados do Cliente\n</h3><p ng-if=\"!isClient\">Dados não editáveis, para simples conferência</p><div class=\"form-box\" layout=\"column\" \nlayout-align=\"start stretch\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"md-muted\" flex=\"100\" \nflex-gt-xs=\"60\"><input type=\"text\" ng-value=\"issue.client.company_fantasy_name || issue.client.name\" \nplaceholder=\"Nome\" readonly=\"readonly\"></md-input-container><md-input-container class=\"md-muted\" flex=\"100\" \nflex-gt-xs=\"40\"><input type=\"text\" ng-value=\"issue.client.nameReturn | yesNo\" placeholder=\"Nome diferente do retorno\" \nreadonly=\"readonly\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nclass=\"md-muted\" flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" ng-value=\"issue.client.email\" placeholder=\"Email\" \nreadonly=\"readonly\"></md-input-container><md-input-container class=\"md-muted\" flex=\"100\" flex-gt-xs=\"50\"><input \ntype=\"text\" ng-value=\"issue.client.mainDocument || issue.client.document\" placeholder=\"CPF / CNPJ\" readonly=\"readonly\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"md-muted\" flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" ng-value=\"issue.client.mobile || issue.client.cellphone\" \nplaceholder=\"Telefone celular\" readonly=\"readonly\"></md-input-container><md-input-container class=\"md-muted\" \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" ng-value=\"issue.client.phone\" placeholder=\"Telefone fixo\" \nreadonly=\"readonly\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nclass=\"md-muted\" flex=\"100\" flex-gt-xs=\"60\"><input type=\"text\" ng-value=\"issue.client.address\" \nplaceholder=\"Endereço / local do acidente\" readonly=\"readonly\"></md-input-container><md-input-container \nclass=\"md-muted\" flex=\"100\" flex-gt-xs=\"40\"><input type=\"text\" \nng-value=\"issue.client.number || issue.client.address_number\" placeholder=\"Número\" readonly=\"readonly\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"md-muted\" flex=\"100\" \nflex-gt-xs=\"33\"><input type=\"text\" ng-value=\"issue.client.complement\" placeholder=\"Complemento\" readonly=\"readonly\">\n</md-input-container><md-input-container class=\"md-muted\" flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" \nng-value=\"issue.client.neighborhood || issue.client.district\" placeholder=\"Bairro\" readonly=\"readonly\">\n</md-input-container><md-input-container class=\"md-muted\" flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" \nng-value=\"issue.client.zipcode || issue.client.postal_code\" placeholder=\"CEP\" readonly=\"readonly\"></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"md-muted\" flex=\"100\" flex-gt-xs=\"50\"><input \ntype=\"text\" ng-value=\"issue.client.city\" placeholder=\"Cidade\" readonly=\"readonly\"></md-input-container>\n<md-input-container class=\"md-muted\" flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" ng-value=\"getClientState()\" \nplaceholder=\"Estado\" readonly=\"readonly\"></md-input-container></div></div><hr></div><h3>Descrição</h3><div \nclass=\"form-box\" layout=\"column\" layout-align=\"start stretch\"><div layout=\"row\"><md-input-container class=\"md-muted\" \nflex><textarea md-no-resize ng-value=\"issue.description\" placeholder=\"Descrição do chamado\" readonly=\"readonly\">\n</textarea></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"md-muted\" \nflex=\"100\" flex-gt-xs=\"50\" ng-if=\"isClient\"><input type=\"text\" ng-value=\"issue.id | numberFixedLen: 5\" \nplaceholder=\"Número do chamado\" readonly=\"readonly\"></md-input-container><md-input-container class=\"md-muted\" \nflex=\"100\" flex-gt-xs=\"isClient ? 50 : 100\"><input type=\"text\" \nng-value=\"issue.created_at | date:\'dd/MM/yyyy - HH:mm:ss\'\" placeholder=\"Data do chamado\" readonly=\"readonly\">\n</md-input-container></div></div><div ng-show=\"issue.accident_id\"><hr><h3>Dados do acidente</h3><p>\nDados inseridos pela seguradora, para simples conferência</p><div class=\"form-box\" layout=\"column\" \nlayout-align=\"start stretch\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container class=\"md-muted\" flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" ng-value=\"issue.accident.happened_at_date | date:\'dd/MM/yyyy\'\" \nplaceholder=\"Data do acidente\" readonly=\"readonly\"></md-input-container><md-input-container class=\"md-muted\" \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" ng-value=\"issue.accident.happened_at_time | date:\'HH:mm\'\" \nplaceholder=\"Hora do acidente\" readonly=\"readonly\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container class=\"md-muted\" flex=\"100\" flex-gt-xs=\"60\"><input type=\"text\" ng-value=\"issue.accident.location\" \nplaceholder=\"Endereço / local do acidente\" readonly=\"readonly\"></md-input-container><md-input-container \nclass=\"md-muted\" flex=\"100\" flex-gt-xs=\"40\"><input type=\"text\" ng-value=\"issue.accident.complement\" \nplaceholder=\"Número / complemento\" readonly=\"readonly\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container class=\"md-muted\" flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nng-value=\"issue.accident.district\" placeholder=\"Bairro\" readonly=\"readonly\"></md-input-container><md-input-container \nclass=\"md-muted\" flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" ng-value=\"getCityState()\" placeholder=\"Cidade / Estado\" \nreadonly=\"readonly\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nclass=\"md-muted\" flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nng-value=\"issue.accident.has_police_intervention | yesNo\" placeholder=\"Houve intervenção policial?\" \nreadonly=\"readonly\"></md-input-container><md-input-container class=\"md-muted\" flex=\"100\" flex-gt-xs=\"50\"><input \ntype=\"text\" ng-value=\"issue.accident.accident_report_number || \'n/a\'\" placeholder=\"Nº boletim de ocorrência\" \nreadonly=\"readonly\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nclass=\"md-muted\" flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" ng-value=\"issue.accident.has_victims | yesNo\" \nplaceholder=\"Houve vítimas?\" readonly=\"readonly\"></md-input-container><md-input-container class=\"md-muted\" flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" ng-value=\"issue.accident.cause\" placeholder=\"Causa\" readonly=\"readonly\">\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"md-muted\" flex><textarea md-no-resize \nng-value=\"issue.accident.description\" placeholder=\"Descrição do chamado\" readonly=\"readonly\"></textarea>\n</md-input-container></div></div></div><div ng-show=\"issue.accident_id\"><hr><h3>Informações adicionais</h3><p \nng-if=\"isClient\">Adicione ou edite a descrição dos danos sofridos no acidente</p><p ng-if=\"!isClient\">\nDados não editáveis, para simples conferência</p><div class=\"form-box\" layout=\"column\" layout-align=\"start stretch\">\n<div layout=\"row\"><md-input-container class=\"md-muted\" flex><textarea md-no-resize \nng-value=\"issue.accident.damages_description\" placeholder=\"Descrição dos danos\" readonly=\"readonly\"></textarea>\n</md-input-container></div></div></div><div ng-show=\"issue.accident_id\"><div layout=\"column\" \nlayout-align=\"start stretch\"><div layout=\"column\"><hr class=\"gray mb-30\" ng-if=\"!issue.contestation && isClient\">\n<md-input-container class=\"contestation-input md-accent\" flex ng-show=\"!issue.contestation && isClient\"><label>\nObservações adicionais</label><textarea md-no-resize ng-model=\"contestation\" \nplaceholder=\"Acrescente observações ou informações importantes ao processo...\" max-rows=\"5\" required></textarea>\n</md-input-container><md-input-container class=\"md-muted\" flex ng-if=\"issue.contestation\"><textarea md-no-resize \nng-value=\"issue.contestation\" placeholder=\"Observações adicionais\" readonly=\"readonly\"></textarea></md-input-container>\n</div><div class=\"additional-info-submit-btn pb-20\" layout=\"row\" layout-align=\"center center\" \nng-show=\"!issue.contestation && isClient\"><md-button type=\"submit\" class=\"md-accent md-raised md-sm\">Salvar alterações\n</md-button></div></div></div></form></div>");
$templateCache.put("app/shared/directives/mx-empty/mx-empty.html","<div class=\"mx-empty pt-50 pb-70\" layout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"{{icon}}\" \nclass=\"s50 mb-10 grey-300-fg\"></md-icon><span class=\"grey-400-fg\" ng-transclude></span></div>");
$templateCache.put("app/shared/directives/mx-fab/mx-fab.html","<div class=\"mx-fab\" ng-show=\"show\" ng-click=\"onFabClick()\"><md-button type=\"button\" class=\"md-fab md-primary\"><div \nclass=\"badge\" ng-if=\"showBadge\"></div><md-icon md-font-icon=\"{{icon ? icon : \'icon-message-text\'}}\"></md-icon>\n</md-button></div>");
$templateCache.put("app/shared/directives/mx-footer/mx-footer.html","<footer class=\"mx-footer\" ng-class=\"{\'external\': external}\"><div layout=\"row\" layout-align=\"space-between center\" \nlayout-fill><div class=\"copyright\"><span>Seguro<span class=\"with\">com</span>Seguro ©</span> {{currentYear}} <a href=\"\" \nclass=\"terms-link white under text-center\" ng-click=\"onTermsClick()\">Termos de Uso e Privacidade</a></div><div \nclass=\"ever\"><a href=\"https://www.ever.com.br\" target=\"_blank\"><img ng-src=\"assets/images/logos/ever.png\" width=\"36\" \nheight=\"9\"></a></div></div></footer>");
$templateCache.put("app/shared/directives/mx-header/mx-header.html","<div class=\"mx-header\" layout=\"row\" layout-align=\"space-between center\" \nng-class=\"{\'mx-header--tall\': backButton || image}\"><div layout=\"row\" layout-align=\"space-between center\" flex><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\" flex><span class=\"logo-icon\" ng-if=\"!backButton\"><md-icon \nmd-font-icon=\"icon-{{icon}}\" class=\"s28\"></md-icon></span><md-button class=\"back-btn md-icon-button\" \nng-if=\"backButton\" ng-click=\"onBackClick()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nclass=\"page-image\" ng-if=\"image\" mx-bkg bkg-image=\"image\" bkg-size=\"imageSize\" hide-xs></div><div class=\"page-image\" \nng-if=\"image == \'\'\" hide-xs></div><span class=\"logo-text\" ng-if=\"!subtitle\">{{text | translate}}</span> <span \nclass=\"logo-text\" ng-if=\"subtitle\">{{text | translate}}<md-icon md-font-icon=\"icon-chevron-right\" class=\"s14\">\n</md-icon>{{subtitle | translate}}</span></div><md-button class=\"save-btn md-raised\" ng-if=\"saveCallback\" \nng-click=\"saveCallback()\">Salvar</md-button></div><div ng-show=\"selectedItems.length > 0\" \nclass=\"selected-bar header animate-slide-down md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"close-button-wrapper\" ng-click=\"onDeselectAllItems()\"><md-button layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-arrow-left\" class=\"back-icon mr-8\"></md-icon><span class=\"back-text\" \ntranslate=\"APP.CUSTOM_HEADER.BACK\">Voltar</span></md-button></div><div flex layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"selected-contacts-count font-size-16\"><span>{{selectedItems.length}}</span> <span \ntranslate=\"APP.CUSTOM_HEADER.SELECTED\">selecionado(s)</span></span><md-menu class=\"select-menu\" ng-if=\"!currentThread\">\n<md-button class=\"select-menu-btn md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-menu-down\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"onSelectAllItems()\" translate=\"APP.CUSTOM_HEADER.SELECT_ALL\">Selecionar todos</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"onDeselectAllItems()\" translate=\"APP.CUSTOM_HEADER.SELECT_NONE\">Deselecionar todos\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"multi-select-actions\" \nng-if=\"delete !== false\"><md-button class=\"md-icon-button\" ng-click=\"onDeleteSelectedItemsClick($event)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></div></div></div></div>");
$templateCache.put("app/shared/directives/mx-image-upload/mx-image-upload.html","<div class=\"mx-image-upload\" flow-init=\"ngFlowOptions\" flow-name=\"ngFlow.flow\" flow-file-added=\"onFileAdded($file)\" \nflow-drop flow-drag-enter=\"dropping=true\" flow-drag-leave=\"dropping=false\" ng-class=\"{\'dropping\':dropping}\" \nlayout=\"column\"><div ng-if=\"!isAvatar\"><mx-loader loader-id=\"mxImageUploadLoader\" ng-if=\"!buttonOnly\"></mx-loader><div \nclass=\"drop-text hint-text\" layout=\"row\" layout-align=\"center center\" ng-if=\"!buttonOnly\"><span \ntranslate=\"DIRECTIVES.IMAGE_UPLOAD.DROP_TO_UPLOAD\">Drop to upload</span></div><label class=\"mx-label\" \nng-if=\"!buttonOnly\"><span translate=\"{{sectionTitle}}\">{{sectionTitle}}</span> <small \ntranslate=\"DIRECTIVES.IMAGE_UPLOAD.REQUIRED\" ng-if=\"showRequired\">(obrigatória)</small></label><div layout=\"column\" \nlayout-align=\"center center\"><md-button flow-btn class=\"{{buttonClasses}}\" \nng-class=\"{\'upload-btn md-raised md-accent\': !buttonClasses}\" ng-disabled=\"disabled || updating\"><span \nng-if=\"!buttonOnly || (buttonOnly && !updating)\">{{buttonText || \'DIRECTIVES.IMAGE_UPLOAD.BUTTON_TEXT\' | translate}}\n</span><div layout=\"row\" layout-align=\"space-around\" ng-if=\"buttonOnly && updating\"><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"16\"></md-progress-circular></div></md-button><span \nclass=\"md-caption md-margin md-padding text-center\" md-colors=\"{color: \'grey-500\'}\" ng-if=\"!buttonOnly\">\n{{\'DIRECTIVES.IMAGE_UPLOAD.INSTRUCTIONS\' | translate}}<br><span translate=\"{{recommended}}\">{{recommended}}</span> \n</span><img class=\"new-image-upload\" ng-src=\"{{getCurrentImage()}}\" ng-if=\"!buttonOnly\"></div></div><div \nng-if=\"isAvatar\" class=\"mx-avatar\" flow-btn><mx-loader loader-id=\"mxImageUploadLoader\" ng-if=\"!buttonOnly\"></mx-loader>\n<img ng-src=\"{{getCurrentImage()}}\" noretina class=\"avatar huge mr-0\" mx-img-orientation><div \nclass=\"icon-badge md-accent-bg md-hue-1\" ng-if=\"icon\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon></div>\n<div class=\"mt-10\" ng-if=\"!icon\"><span class=\"btn-upload\">Alterar imagem</span></div></div></div>");
$templateCache.put("app/shared/directives/mx-issue/mx-issue.html","<div id=\"issue-{{issue.id}}\" class=\"mx-issue\"><hr class=\"gray mb-10\"><div layout=\"row\" layout-align=\"center center\">\n<h3>nº {{issue.id | numberFixedLen:5}}</h3></div><mx-panel tabbed=\"true\" tab-badges=\"tabBadges\"><md-tabs \nmd-dynamic-height md-stretch-tabs=\"always\" md-selected=\"tabs.current\"><md-tab label=\"Atividades\" \nmd-on-select=\"onTabChange(0)\"><md-tab-body><ng-include src=\"\'app/main/pages/home/tabs/activities.html\'\"></ng-include>\n</md-tab-body></md-tab><md-tab label=\"Detalhes\" md-on-select=\"onTabChange(1)\"><md-tab-body><ng-include \nsrc=\"\'app/main/pages/home/tabs/details.html\'\"></ng-include></md-tab-body></md-tab><md-tab label=\"Documentos\" \nmd-on-select=\"onTabChange(2)\"><md-tab-body><ng-include src=\"\'app/main/pages/home/tabs/documents.html\'\"></ng-include>\n</md-tab-body></md-tab><md-tab label=\"Conversas\" md-on-select=\"onTabChange(3)\"><md-tab-body><ng-include \nsrc=\"\'app/main/pages/home/tabs/chats.html\'\" ng-if=\"!chatHistory\"></ng-include><ng-include \nsrc=\"\'app/main/pages/home/tabs/chat-history.html\'\" ng-if=\"chatHistory\"></ng-include></md-tab-body></md-tab></md-tabs>\n</mx-panel></div>");
$templateCache.put("app/shared/directives/mx-list/mx-list.html","<md-content class=\"mx-list\" \nng-class=\"{\'mx-list--left-padding\': showHandles, \'mx-list--compact\': compact, \'md-whiteframe-2dp\': !compact}\"><div \nclass=\"mx-list-item sortable-header\" ng-if=\"sortable\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"list-title\" layout=\"row\" layout-align=\"start center\"><span class=\"secondary-text pl-10 font-weight-500\">\n{{sortable.text}} ({{items.length}})</span></div><md-menu><md-button class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-sort-alphabetical\" ng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content>\n<md-menu-item><md-button class=\"text-center\" ng-click=\"setOrderDesc(false)\" \nng-style=\"!orderDesc && {\'font-weight\':\'500\'}\"><span>A - Z</span></md-button></md-menu-item><md-menu-item><md-button \nclass=\"text-center\" ng-click=\"setOrderDesc(true)\" ng-style=\"orderDesc && {\'font-weight\':\'500\'}\"><span>Z - A</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"mx-list-item header\" \nng-if=\"header || (headerTitle && headerSubtitle)\" layout=\"column\" layout-align=\"space-between start\"><label \nclass=\"mx-label\">{{header.title || headerTitle}}</label><span class=\"grey-500-fg font-size-14\">\n{{header.subtitle || headerSubtitle}}</span></div><div class=\"mx-list-item\" \nlayout=\"{{showThumbnails ? \'column\' : \'row\'}}\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\" \nng-repeat=\"item in items | filter:query | orderBy: orderBy: orderDesc as results track by item.id\" \nng-click=\"onItemClick(item)\" md-ink-ripple=\"{{selectOnClick ? true : false}}\" \nng-class=\"{\'pointer\': selectOnClick, \'readonly\': readonlyIds && readonlyIds.indexOf(item.id) != -1}\"><div \nclass=\"handle\" ng-if=\"showHandles\" layout=\"row\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-drag-vertical\"></md-icon></div><div layout=\"row\" layout-align=\"space-between center\" \nlayout-align-gt-xs=\"start center\"><div class=\"item-selection\" ng-if=\"selectable\"><md-checkbox class=\"m-0\" \nng-checked=\"item.selected\" ng-disabled=\"readonlyIds && readonlyIds.indexOf(item.id) != -1\" \nng-click=\"onCheckboxClick(item)\"></md-checkbox></div><div class=\"status mr-20\" ng-if=\"showStatus\" layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-eye\" ng-if=\"item.active\"></md-icon><md-icon \nmd-font-icon=\"icon-eye-off\" ng-if=\"!item.active\" class=\"grey-300-fg\"></md-icon><span class=\"grey-500-fg\">\n{{item.active ? \'DIRECTIVES.LIST.ACTIVE\' : \'DIRECTIVES.LIST.INACTIVE\' | translate}}</span></div><div class=\"thumbnail\" \nng-if=\"showThumbnails && item.img\" mx-bkg bkg-image=\"item.img\" bkg-color=\"\'white\'\" bkg-size=\"thumbSize\"></div></div>\n<div layout=\"row\" layout-align=\"start center\" flex><div class=\"info mv-10\" layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"center start\" layout-align-gt-sm=\"center center\" flex><div class=\"title\" flex><span \nclass=\"font-weight-500 grey-700-fg\" ng-class=\"{\'font-size-16\': !compact, \'font-size-14\': compact}\">\n{{item.title || item.name}} <small class=\"grey-500-fg\" ng-if=\"item.content\">{{item.content}}</small></span></div><div \nclass=\"description\" flex-gt-sm=\"70\" ng-if=\"(item.description || item.email) && !compact\"><span \nclass=\"grey-500-fg font-size-14\">{{item.description || item.email}}</span></div></div><div class=\"actions\" \nlayout=\"row\" layout-align=\"start center\" ng-if=\"actions\"><md-button class=\"md-icon-button\" \nng-repeat=\"action in actions\" ng-click=\"action.callback(item)\" \nng-disabled=\"readonlyIds && readonlyIds.indexOf(item.id) != -1\"><md-icon md-font-icon=\"{{action.icon}}\"></md-icon>\n</md-button></div></div></div><div class=\"mx-list-item no-results\" ng-if=\"query && results.length == 0\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"p-20 grey-400-fg font-weight-400 font-size-14\"><span \ntranslate=\"DIRECTIVES.LIST.NO_RESULTS\">Nenhum resultado encontrado para</span> \"{{query}}\".</div></div><div \nclass=\"mx-list-item footer\" ng-if=\"footer\" layout=\"column\" layout-gt-xs=\"row\" layout-align=\"space-between center\" \nlayout-align-gt-xs=\"space-between center\"><span class=\"grey-500-fg pv-10\" ng-if=\"items.length == 0\">\n{{edit ? \'DIRECTIVES.LIST.NO_ITEMS_EDIT\' : \'DIRECTIVES.LIST.NO_ITEMS\' | translate}}</span> <span \nclass=\"grey-500-fg pv-10\" ng-if=\"items.length == 1\">\n1 {{edit ? \'DIRECTIVES.LIST.ITEM_EDIT\' : \'DIRECTIVES.LIST.ITEM\' | translate}}</span> <span class=\"grey-500-fg pv-10\" \nng-if=\"items.length > 1\">{{items.length}} {{edit ? \'DIRECTIVES.LIST.ITEMS_EDIT\' : \'DIRECTIVES.LIST.ITEMS\' | translate}}\n</span><md-button class=\"add-new-btn md-raised md-accent\" ng-click=\"footer.callback(footer.params)\">\n{{!edit ? \'DIRECTIVES.LIST.ADD_NEW\' : items && items.length > 0 ? \'DIRECTIVES.LIST.EDIT\' : \'DIRECTIVES.LIST.ADD\' | translate}}\n</md-button></div></md-content>");
$templateCache.put("app/shared/directives/mx-list-documents/mx-list-documents.html","<md-list flex class=\"mx-list-documents\"><md-list-item ng-repeat=\"item in items track by item.id\" \nclass=\"{{item.result == \'refused\' ? \'doc-refused\' : \'\'}}\" layout-xs=\"column\"><div layout=\"column\" flex><p \nclass=\"list-title\">{{item.document.name}}</p><div flex layout=\"row\" layout-wrap class=\"documents-infos\"><p flex \nclass=\"doc-status\" show-sm show-gt-sm hide-xs>Status: <span \nng-class=\"{\'doc-status--approved\': item.valid, \'doc-status--refused\': item.reviewed_at && !item.valid, \'doc-status--pending\': item.uploaded_at && !item.reviewed_at}\">\n{{item.status | docStatus}} <span ng-if=\"item.reviewed_at && !item.valid\">– Envie novamente</span></span></p><p \nflex=\"100\" class=\"doc-status\" hide-sm show-xs hide-gt-sm>Status: <span \nng-class=\"{\'doc-status--approved\': item.valid, \'doc-status--refused\': item.reviewed_at && !item.valid, \'doc-status--pending\': item.uploaded_at && !item.reviewed_at}\">\n{{item.status | docStatus}} <span ng-if=\"item.reviewed_at && !item.valid\">– Envie novamente</span></span></p><p \nflex=\"100\" flex-gt-xs=\"40\" class=\"doc-date\" ng-if=\"item.uploaded_at\">\nEnvio em: {{item.uploaded_at | date:\'dd/MM/yyyy - HH:mm\'}}</p></div></div><button \nclass=\"md-button md-outline md-accent md-xs\" ng-click=\"onViewDocumentClick(item)\" \nng-if=\"item.uploaded_at && !(item.reviewed_at && !item.valid) && item.type != \'pdf\'\">Ver</button> <a \nhref=\"{{item.uploaded_document.url}}\" target=\"_blank\" class=\"md-button md-outline md-accent md-xs\" \nng-if=\"item.uploaded_at && !(item.reviewed_at && !item.valid) && item.type == \'pdf\'\">Ver</a><mx-image-upload \ncomponent-id=\"{{item.id}}\" button-only=\"true\" button-text=\"\'Enviar\'\" \nbutton-classes=\"\'send-btn md-outline md-accent md-xs\'\" ng-if=\"!item.uploaded_at || (item.reviewed_at && !item.valid)\">\n</mx-image-upload></md-list-item></md-list>");
$templateCache.put("app/shared/directives/mx-load-more/mx-load-more.html","<div class=\"mx-load-more\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-outline md-xs\" \nng-click=\"onClick()\">{{text || \'Carregar mais\'}}</md-button></div>");
$templateCache.put("app/shared/directives/mx-loader/mx-loader.html","<div layout-fill layout=\"row\" layout-align=\"center center\" class=\"mx-loader\" \nng-class=\"{\'mx-loader--modal\': modal, \'mx-loader--local\': local, \'mx-loader--global\': global, \'mx-loader--opaque\': opaque, \'mx-loader--login\': login}\" \nng-show=\"show\"><div layout=\"column\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"{{small ? 50 : 80}}\"></md-progress-circular></div></div>");
$templateCache.put("app/shared/directives/mx-message-input/mx-message-input.html","<form id=\"mxMessageForm\" class=\"mx-message-input\" ng-class=\"{\'mx-message-input--boxed\': boxed}\" name=\"mxMessageForm\" \nng-submit=\"onSubmit(mxMessageForm.$invalid)\"><div layout=\"row\" layout-align=\"center center\"><md-input-container \nclass=\"input-container md-accent\" flex md-no-float><textarea type=\"text\" name=\"message\" ng-model=\"message\" \nmax-rows=\"5\" ng-keydown=\"onReplyKeyDown($event)\" placeholder=\"Escreva sua mensagem...\"></textarea></md-input-container>\n<md-button type=\"submit\" class=\"send-btn-icon md-icon-button md-accent\" ng-show=\"iconButton\" \nng-disabled=\"!message || !message.length\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button><md-button \ntype=\"submit\" class=\"send-btn md-raised md-accent\" ng-show=\"!iconButton\" ng-disabled=\"!message|| !message.length\">\nEnviar</md-button></div></form>");
$templateCache.put("app/shared/directives/mx-panel/mx-panel.html","<div class=\"mx-panel p-16 {{badgeClasses}}\" \nng-class=\"{\'mx-panel--tabbed\': tabbed, \'mx-panel--translucent\': translucent}\"><ng-transclude></ng-transclude></div>");
$templateCache.put("app/shared/directives/mx-password-input/mx-password-input.html","<div class=\"mx-password-input\" layout=\"row\"><md-input-container class=\"md-accent\" ng-class=\"{\'disabled\': isDisabled}\" \nflex><input type=\"{{showPassword ? \'text\' : \'password\'}}\" name=\"{{getName()}}\" ng-model=\"model\" \nplaceholder=\"{{getPlaceholder()}}\" ng-required=\"isRequired\" ng-disabled=\"isDisabled\" ng-blur=\"onBlur()\" \nng-attr-mx-confirm-password=\"{{confirmation ? form.password.$viewValue : null}}\" mx-focus=\"shouldFocus || false\" \nminlength=\"8\"><div class=\"secondary\" layout=\"row\" layout-align=\"center center\"><a class=\"toggle-visibility-btn\" \nng-click=\"onTogglePasswordVisibilityClick()\">{{showPassword ? \'Esconder\' : \'Mostrar\'}}</a></div><div \nng-messages=\"form.password.$error\" ng-if=\"!confirmation && form.password.$touched\" role=\"alert\"><div \nng-message=\"minlength\">Senha deve ter no minímo 8 caracteres</div></div><div \nng-messages=\"form.password_confirmation.$error\" ng-if=\"confirmation && form.password_confirmation.$touched\" \nrole=\"alert\"><div ng-message=\"minlength\">Confirmação deve ter no minímo 8 caracteres</div><div \nng-message=\"mxConfirmPassword\">A confirmação está diferente da nova senha</div></div></md-input-container></div>");
$templateCache.put("app/shared/directives/mx-profile-info-form/mx-profile-info-form.html","<div class=\"mx-profile-info-form form-box\" layout=\"column\" layout-align=\"start stretch\"><div layout=\"column\" \nlayout-gt-xs=\"row\" ng-if=\"isClient && model.entity_type == \'NATURAL_PERSON\'\"><md-input-container class=\"md-accent\" \nflex=\"100\" flex-gt-xs=\"50\" ng-class=\"{\'disabled\': fields.gender.disabled}\"><label>Gênero</label><md-select \nng-change=\"onChange()\" name=\"gender\" class=\"md-accent\" ng-model=\"model.gender\" required=\"true\" \nng-disabled=\"fields.gender.disabled\" ng-blur=\"onBlur(\'gender\')\"><md-option value=\"FEMALE\">Feminino</md-option>\n<md-option value=\"MALE\">Masculino</md-option></md-select></md-input-container><md-input-container class=\"md-accent\" \nflex=\"100\" flex-gt-xs=\"50\" ng-class=\"{\'disabled\': fields.birthday.disabled}\"><label>Data de nascimento</label>\n<md-datepicker required=\"true\" md-hide-icons=\"calendar\" md-open-on-focus name=\"birthday\" ng-model=\"model.birthday\" \nng-change=\"vm.onChange()\" flex></md-datepicker></md-input-container></div><md-input-container class=\"md-accent\" \nng-class=\"{\'disabled\': fields.company_fantasy_name.disabled}\" ng-if=\"isClient && model.entity_type == \'LEGAL_PERSON\'\">\n<input ng-change=\"onChange()\" type=\"text\" name=\"company_fantasy_name\" ng-model=\"model.company_fantasy_name\" \nplaceholder=\"Nome Fantasia\" required=\"true\" ng-disabled=\"fields.company_fantasy_name.disabled\" \nng-blur=\"onBlur(\'company_fantasy_name\')\"></md-input-container><md-input-container class=\"md-accent\"><input \nng-change=\"onChange()\" type=\"text\" name=\"cellphone\" ng-model=\"model.cellphone\" placeholder=\"Telefone Celular\" \nrequired=\"true\" ng-blur=\"onBlur(\'cellphone\')\" mask=\"(99) 9?9999-9999\"></md-input-container><md-input-container \nclass=\"md-accent\" ng-class=\"{\'disabled\': fields.phone.disabled}\"><input ng-change=\"onChange()\" type=\"text\" \nname=\"phone\" ng-model=\"model.phone\" placeholder=\"Telefone Fixo\" ng-disabled=\"fields.phone.disabled\" \nmask=\"(99) 9999-9999\" ng-blur=\"onBlur(\'phone\')\" mx-focus=\"phoneFocused\"></md-input-container><mx-zipcode-input \ninput-model=\"model.postal_code\" input-required=\"zipcodeRequired\" input-disabled=\"fields.postal_code.disabled\" \non-search=\"onZipcodeSearch\" on-done=\"onZipcodeDone\" on-unknown=\"onZipcodeUnknown\" should-focus=\"zipcodeFocused\" \nng-if=\"isClient\"></mx-zipcode-input><md-input-container class=\"md-accent\" \nng-class=\"{\'disabled\': fields.address.disabled}\" ng-if=\"isClient\"><input ng-change=\"onChange()\" type=\"text\" \nname=\"address\" ng-model=\"model.address\" placeholder=\"Endereço\" required=\"true\" ng-disabled=\"fields.address.disabled\" \nng-blur=\"onBlur(\'address\')\"></md-input-container><div layout=\"column\" layout-gt-xs=\"row\" ng-if=\"isClient\">\n<md-input-container class=\"md-accent\" flex=\"100\" flex-gt-xs=\"50\" \nng-class=\"{\'disabled\': fields.address_number.disabled}\"><input ng-change=\"onChange()\" type=\"text\" \nname=\"address_number\" ng-model=\"model.address_number\" placeholder=\"Número\" required=\"true\" \nng-disabled=\"fields.address_number.disabled\" ng-blur=\"onBlur(\'address_number\')\" mx-focus=\"addressNumberFocused\">\n</md-input-container><md-input-container class=\"md-accent\" flex=\"100\" flex-gt-xs=\"50\" \nng-class=\"{\'disabled\': fields.complement.disabled}\"><input ng-change=\"onChange()\" type=\"text\" name=\"complement\" \nng-model=\"model.complement\" placeholder=\"Complemento\" ng-disabled=\"fields.complement.disabled\" \nng-blur=\"onBlur(\'complement\')\"></md-input-container></div><md-input-container class=\"md-accent\" \nng-class=\"{\'disabled\': fields.district.disabled}\" ng-if=\"isClient\"><input ng-change=\"onChange()\" type=\"text\" \nname=\"district\" ng-model=\"model.district\" placeholder=\"Bairro\" required=\"true\" ng-disabled=\"fields.district.disabled\" \nng-blur=\"onBlur(\'district\')\"></md-input-container><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nclass=\"md-accent\" flex=\"100\" flex-gt-xs=\"50\" ng-class=\"{\'disabled\': fields.city.disabled}\"><input \nng-change=\"onChange()\" type=\"text\" name=\"city\" ng-model=\"model.city\" placeholder=\"Cidade\" required=\"true\" \nng-disabled=\"fields.city.disabled\" ng-blur=\"onBlur(\'city\')\"></md-input-container><md-input-container class=\"md-accent\" \nflex=\"100\" flex-gt-xs=\"50\" ng-class=\"{\'disabled\': fields.state.disabled}\"><label>Estado</label><md-select \nng-change=\"onChange()\" name=\"state\" class=\"md-accent\" ng-model=\"model.state\" required=\"true\" \nng-disabled=\"fields.state.disabled\" ng-blur=\"onBlur(\'state\')\"><md-option ng-value=\"state.id\" \nng-repeat=\"state in states\">{{state.name}}</md-option></md-select></md-input-container></div><md-input-container \nclass=\"md-accent\" ng-class=\"{\'disabled\': fields.terms.disabled}\" ng-if=\"!edit\"><p><md-checkbox name=\"terms\" \nng-model=\"model.terms\" ng-change=\"onTermsChange()\" class=\"m-0\" ng-checked=\"model.terms\" ng-blur=\"onBlur(\'terms\')\">\nEu concordo com os <a href=\"\" ng-click=\"onTermsClick($event)\">Termos de Uso e Privacidade</a></md-checkbox></p><div \nclass=\"terms-error\" ng-if=\"form.$submitted && model.terms !== true\" role=\"alert\">\nVocê deve concordar com os Termos de Uso e Privacidade</div></md-input-container></div>");
$templateCache.put("app/shared/directives/mx-profile-password-form/mx-profile-password-form.html","<div class=\"mx-profile-password-form form-box\" layout=\"column\" layout-align=\"start stretch\"><mx-password-input \ninput-model=\"model.password\" input-required=\"true\" edit=\"edit\" form=\"form\" blur-callback=\"onBlur\"></mx-password-input>\n<mx-password-input input-model=\"model.password_confirmation\" input-required=\"true\" edit=\"edit\" \ninput-disabled=\"confirmationDisabled\" confirmation=\"true\" form=\"form\" should-focus=\"confirmationFocused\" \nblur-callback=\"onBlur\"></mx-password-input></div>");
$templateCache.put("app/shared/directives/mx-readonly-data/mx-readonly-data.html","<div class=\"mx-readonly-data\" layout=\"column\" layout-align=\"stretch center\"><span class=\"name\">{{name}}</span> <span \nclass=\"value\">{{value}}</span></div>");
$templateCache.put("app/shared/directives/mx-search-input/mx-search-input.html","<form name=\"mxSearchForm\" class=\"mx-search-input\" layout=\"row\" ng-submit=\"onSubmit()\"><md-input-container \nclass=\"md-accent\" md-no-float flex><input type=\"text\" name=\"search\" ng-model=\"searchValue\" placeholder=\"Pesquisar...\" \nng-change=\"onChange()\"></md-input-container><md-button type=\"submit\" class=\"search-icon md-icon-button\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></md-button></form>");
$templateCache.put("app/shared/directives/mx-section-divider/mx-section-divider.html","<div class=\"mx-section-divider\" layout=\"row\" layout-align=\"space-between center\"><div class=\"div-line\" flex></div><div \nclass=\"section-title\">{{sectionTitle | translate}}</div><div class=\"div-line\" flex></div></div>");
$templateCache.put("app/shared/directives/mx-send-message/mx-send-message.html","<form id=\"mxSendMessage\" class=\"mx-send-message\" name=\"mxMessageForm\" ng-submit=\"onSubmit(mxMessageForm.$invalid)\" \nlayout=\"column\" layout-align=\"start stretch\"><div class=\"pt-30\" layout=\"column\" ng-if=\"!success\"><md-input-container \nclass=\"md-accent\" flex><label>Mensagem</label><textarea type=\"text\" name=\"message\" ng-model=\"message\" max-rows=\"5\" \nng-keydown=\"onReplyKeyDown($event)\" \nplaceholder=\"Escreva uma mensagem ou observação para as partes envolvidas no chamado…\" required></textarea>\n</md-input-container></div><div class=\"md-padding\" layout=\"column\" layout-align=\"center center\" ng-if=\"success\"><img \nsrc=\"assets/images/etc/ic-success.png\"></div><div class=\"pb-30\" layout=\"row\" layout-align=\"center center\"><md-button \nng-if=\"!success\" ng-disabled=\"mxMessageForm.$invalid || mxMessageForm.$pristine\" type=\"submit\" \nclass=\"md-accent md-raised md-sm\"><span>Enviar mensagem</span></md-button><md-button ng-if=\"success\" type=\"submit\" \nclass=\"md-accent md-raised md-sm\"><span>Enviar nova</span></md-button></div></form>");
$templateCache.put("app/shared/directives/mx-system-message/mx-system-message.html","<div class=\"mx-system-message\" layout=\"row\" layout-align=\"center center\"><div class=\"bubble\" \nng-class=\"{\'welcome\': welcome}\"><div class=\"message\">{{getMessage()}}</div></div></div>");
$templateCache.put("app/shared/directives/mx-table/mx-table.html","<table class=\"mx-table simple\" ms-responsive-table><thead><tr><th ng-if=\"isFieldVisible(\'user\')\">Usuário</th><th \nng-if=\"isFieldVisible(\'date\')\">Data</th><th ng-if=\"isFieldVisible(\'time\')\" hide show-gt-sm>Hora</th><th \nng-if=\"isFieldVisible(\'type\')\">Tipo</th><th ng-if=\"isFieldVisible(\'action\')\"></th></tr></thead><tbody \nng-repeat=\"item in items | filter:query as results track by item.id\"><tr ng-click=\"onItemClick(item)\" \nng-class=\"{\'has-action\': action}\"><td class=\"user\" ng-if=\"isFieldVisible(\'user\')\"><div layout=\"row\" \nlayout-align=\"start center\"><img ng-src=\"{{item.user.avatar_url}}\" src=\"assets/images/avatars/profile.jpg\" \nclass=\"avatar small mr-10\" hide show-xs mx-img-orientation> <img ng-src=\"{{item.user.avatar_url}}\" \nsrc=\"assets/images/avatars/profile.jpg\" class=\"avatar medium mr-10\" hide-xs mx-img-orientation> <span>\n{{item.user.company_fantasy_name || item.user.name}}</span></div></td><td class=\"date\" ng-if=\"isFieldVisible(\'date\')\">\n{{item.date | date:\'dd/MM/yyyy\'}}</td><td class=\"time\" hide show-gt-sm ng-if=\"isFieldVisible(\'time\')\">\n{{item.time | date:\'HH:mm:ss\'}}</td><td class=\"type\" ng-if=\"isFieldVisible(\'type\')\">{{item.type}}</td><td \nclass=\"action text-right\" ng-if=\"isFieldVisible(\'action\')\"><md-icon class=\"md-accent-fg\" \nmd-font-icon=\"{{item.expanded ? \'icon-minus\' : \'icon-plus\'}}\" ng-if=\"action.id == ACTIONS.EXPAND\"></md-icon><md-icon \nclass=\"grey-300-fg\" md-font-icon=\"icon-chevron-right\" ng-if=\"action.id == ACTIONS.GO\"></md-icon></td></tr><tr \nng-if=\"action.id == ACTIONS.EXPAND && item.expanded && item.details\"><td class=\"details-td\" colspan=\"10\"><div \nclass=\"details\" layout=\"column\"><span>Detalhes</span><p>{{item.details.message}}</p><a href=\"\" \nclass=\"caps under text-center\" ng-click=\"onDetailsClick(item)\" ng-if=\"item.details.button\">{{item.details.button.text}}\n</a></div></td></tr></tbody><tfoot ng-if=\"query && (!results || !results.length)\"><tr><td colspan=\"10\" \nclass=\"text-center\">Nenhum item encontrado na busca por \"{{query}}\".</td></tr></tfoot></table>");
$templateCache.put("app/shared/directives/mx-zipcode-input/mx-zipcode-input.html","<md-input-container class=\"mx-zipcode-input md-accent\" ng-class=\"{\'disabled\': isDisabled}\"><input type=\"text\" \nname=\"zipcode\" ng-model=\"model\" placeholder=\"CEP\" ng-required=\"isRequired\" ng-disabled=\"isDisabled\" mask=\"99999-999\" \nmask-restrict=\"reject\" ng-blur=\"resolveZipcode()\" mx-focus=\"shouldFocus\"><div class=\"secondary\" layout=\"row\" \nlayout-align=\"center center\"><md-progress-circular class=\"md-accent\" md-diameter=\"15\" md-mode=\"indeterminate\" \nng-disabled=\"!searching\"></md-progress-circular><a href=\"http://www.buscacep.correios.com.br/sistemas/buscacep/\" \ntarget=\"_blank\" class=\"unknown-zipcode-btn\" ng-click=\"onUnknownZipcodeClick()\" ng-if=\"isRequired\">Não sei meu CEP</a>\n</div></md-input-container>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" flex layout-align=\"{{vm.simpleHeader ? \'center stretch\' : \'space-between center\'}}\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\" ui-sref=\"app.pages_home\"><img \nng-src=\"assets/images/logos/ags-white.png\" width=\"142\" height=\"43\"></div><div layout=\"row\" layout-align=\"start center\" \nng-if=\"!vm.simpleHeader\"><md-menu-bar id=\"notifications-menu\" ng-if=\"vm.isClient\"><md-menu \nmd-position-mode=\"right bottom\" md-offset=\"0 -10\"><md-button class=\"notifications-button\" \nng-click=\"$mdOpenMenu(); vm.onNotificationMenuOpen();\" ng-disabled=\"!vm.notifications.length\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-icon md-font-icon=\"icon-bell\" class=\"icon\" \nng-class=\"{\'notification-badge\': vm.showBadge}\"></md-icon></div></md-button><md-menu-content \nclass=\"notifications-menu-content\" width=\"2\"><md-menu-item ng-repeat=\"item in vm.notifications track by $index\" \nng-click=\"vm.openNotification(item)\" class=\"md-indent\" layout=\"column\" md-ink-ripple><div class=\"notification\" \nlayout-align=\"space-between-center\" layout=\"row\"><md-icon ng-if=\"item.icon\" md-font-icon=\"icon-{{item.icon}}\" \nclass=\"icon small\"></md-icon><img ng-if=\"item.image\" md-menu-align-target class=\"avatar small\" src=\"{{item.image}}\" \nmx-img-orientation><div class=\"message\">{{item.description}}</div><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"icon icon-chevron\"></md-icon></div><md-menu-divider \nng-if=\"vm.notifications.length > 1 && vm.notifications.length-1 != $index\"></md-menu-divider></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\" md-offset=\"10 -10\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img ng-if=\"!vm.currentUser.avatar_url\" \nmd-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><mx-avatar class=\"mt-20 mb-15 avatar\" \nng-if=\"vm.currentUser.avatar_url\"></mx-avatar><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs \nhide-sm>{{vm.currentUser.company_fantasy_name || vm.currentUser.name}}</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\"></md-icon></div></md-button><md-menu-content class=\"user-menu-content\" width=\"3\"><md-menu-item \nclass=\"item-profile md-indent\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.onMyProfileClick()\">Meus Dados</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item \nclass=\"item-logout md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.onLogoutClick()\">Sair</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n    <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n      <i class=\"icon s20 white-fg {{node.icon}}\" ng-if=\"node.icon\"></i>\n      <span class=\"title font-size-16 white-fg\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n      <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n      <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n    </div>\n\n    <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\" ng-if=\"node.uisref && node.title\">\n      <i class=\"icon s20 white-fg {{node.icon}}\" ng-if=\"node.icon\"></i>\n      <span class=\"title font-size-16 white-fg\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n      <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n      <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n    </a>\n\n  </div>\n\n  <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n    <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\" ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li>\n  </ul>\n</script>");
$templateCache.put("app/main/pages/auth/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><mx-panel class=\"forgot-password-form\" translucent=\"true\"><div \nclass=\"logo mb-30\"><img ng-src=\"assets/images/logos/ags.png\" width=\"240\" height=\"75\"></div><hr><h3><span>\nRecuperação de senha</span></h3><div ng-if=\"!vm.success\"><p class=\"insert-data\" ng-if=\"vm.isClient\">\nInsira seu CPF / CNPJ para recuperar sua senha</p><p class=\"insert-data\" ng-if=\"!vm.isClient\">\nInsira seu email para recuperar sua senha</p><form name=\"forgotPasswordForm\" \nng-submit=\"vm.onSubmit(forgotPasswordForm.$invalid)\" novalidate><div class=\"form-box\" layout=\"column\" \nng-if=\"!vm.clientLogin\"><md-input-container ng-if=\"!vm.isClient\" class=\"md-accent\" ng-show=\"!vm.clientLogin\"><input \ntype=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"E-mail\" ng-pattern=\"/^.+@.+\\..+$/\" required>\n</md-input-container><md-input-container ng-if=\"vm.isClient\" class=\"md-accent\" ng-show=\"!vm.clientLogin\"><input \ntype=\"text\" name=\"document\" ng-model=\"vm.form.document\" placeholder=\"CPF / CNPJ\" ng-change=\"vm.onDocumentChange()\" \nmask=\"{{vm.documentMask}}\" mask-restrict=\"reject\" required></md-input-container></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-btn\" aria-label=\"RESET MY PASSWORD\" \nng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\"><span ng-if=\"!vm.requestIn\">Enviar</span><div\n layout=\"row\" layout-align=\"space-around\"><md-progress-circular md-theme=\"whiteTheme\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.requestIn\"></md-progress-circular></div></md-button></form><hr><a \nclass=\"caps font-size-12\" ng-click=\"vm.onToggleLoginClick()\"><span ui-sref=\"app.pages_auth_login\">Voltar para Login\n</span></a></div><div ng-if=\"vm.success\"><p class=\"insert-data\">\nSe você estiver cadastrado, uma mensagem será enviada para o endereço abaixo para recuperação de acesso. Caso não receba, por favor, cheque sua caixa de Spam.\n</p><div class=\"form-box\" layout=\"column\"><md-input-container class=\"md-accent\"><input class=\"input-center\" \ntype=\"email\" ng-model=\"vm.emailToReset\" disabled=\"disabled\"></md-input-container></div><md-button \nng-click=\"vm.backToLogin()\" class=\"md-raised md-accent submit-btn\" aria-label=\"Voltar para Login\">Voltar para Login\n</md-button></div></mx-panel></div></div><mx-footer external=\"true\"></mx-footer>");
$templateCache.put("app/main/pages/auth/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><mx-panel class=\"login-panel\" translucent=\"true\"><div class=\"logo mb-30\"><img \nng-src=\"assets/images/logos/ags.png\" width=\"240\" height=\"75\"></div><hr><h3><span ng-if=\"vm.clientLogin\">Login</span> \n<span ng-if=\"!vm.clientLogin\">Acompanhamento</span></h3><p class=\"insert-data\">Insira seus dados para acessar o sistema\n</p><form name=\"vm.loginForm\" novalidate ng-submit=\"vm.onSubmit(vm.loginForm.$invalid)\"><div class=\"form-box\" \nlayout=\"column\" ng-if=\"vm.clientLogin\"><md-input-container class=\"md-accent\" ng-show=\"vm.clientLogin\"><input \ntype=\"text\" name=\"document\" ng-model=\"vm.login.document\" placeholder=\"CPF / CNPJ\" ng-change=\"vm.onDocumentChange()\" \nmask=\"{{vm.documentMask}}\" mask-restrict=\"reject\" required></md-input-container><mx-password-input \ninput-model=\"vm.login.password\" input-required=\"true\"></mx-password-input><div class=\"forgot-password\"><a \nng-click=\"vm.goForgotPassword()\" class=\"text-center font-size-12\">Esqueceu sua senha?</a></div></div><div \nclass=\"form-box\" layout=\"column\" ng-if=\"!vm.clientLogin\"><md-input-container class=\"md-accent\" \nng-show=\"!vm.clientLogin\"><input type=\"email\" name=\"email\" ng-model=\"vm.login.email\" placeholder=\"E-mail\" required>\n</md-input-container><mx-password-input input-model=\"vm.login.password\" input-required=\"true\"></mx-password-input><div \nclass=\"forgot-password\"><a ng-click=\"vm.goForgotPassword()\" class=\"text-center font-size-12\">Esqueceu sua senha?</a>\n</div></div><md-button type=\"submit\" class=\"md-raised md-accent submit-btn\" \nng-disabled=\"vm.loginForm.$invalid || vm.loginForm.$pristine\"><span ng-show=\"!vm.loggingIn\">Entrar</span><div \nlayout=\"row\" layout-align=\"space-around\"><md-progress-circular md-theme=\"whiteTheme\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.loggingIn\"></md-progress-circular></div></md-button></form><hr><a \nclass=\"caps font-size-12\" ng-click=\"vm.onToggleLoginClick()\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"vm.clientLogin\">Se você quer acompanhar um chamado, clique aqui</span> <span ng-if=\"!vm.clientLogin\">\nSe você é cliente, clique aqui</span> </a><a href=\"mailto:contato@segurocomseguro.com.br\" \nclass=\"mailto grey font-size-12\">contato@segurocomseguro.com.br</a></mx-panel></div><mx-loader loader-id=\"loginLoader\" \nlogin=\"true\"></mx-loader></div><mx-footer external=\"true\"></mx-footer>");
$templateCache.put("app/main/pages/auth/register/register.html","<div id=\"register\"><div class=\"main scrollable\" ms-scroll flex><mx-container small=\"true\"><mx-section-divider \nsection-title=\"\'Cadastro\'\"></mx-section-divider><mx-panel><md-tabs md-dynamic-height md-selected=\"vm.currentStep\">\n<md-tab label=\"Introdução\"><md-tab-body><ng-include src=\"\'app/main/pages/auth/register/tabs/welcome.html\'\">\n</ng-include></md-tab-body></md-tab><md-tab label=\"Dados\"><md-tab-body><ng-include \nsrc=\"\'app/main/pages/auth/register/tabs/info.html\'\"></ng-include></md-tab-body></md-tab><md-tab label=\"Senha\">\n<md-tab-body><ng-include src=\"\'app/main/pages/auth/register/tabs/password.html\'\"></ng-include></md-tab-body></md-tab>\n<md-tab label=\"Sucesso\"><md-tab-body><ng-include src=\"\'app/main/pages/auth/register/tabs/success.html\'\"></ng-include>\n</md-tab-body></md-tab></md-tabs></mx-panel></mx-container></div></div>");
$templateCache.put("app/main/pages/auth/reset-password/reset-password.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><mx-panel class=\"reset-password-form\" translucent=\"true\"><div \nclass=\"logo mb-30\"><img ng-src=\"assets/images/logos/ags.png\" width=\"240\" height=\"75\"></div><hr><div \nng-if=\"!vm.success\"><h3><span>Cadastrar nova senha</span></h3><p class=\"insert-data\">Escolha uma nova senha de acesso\n</p><form name=\"resetPasswordForm\" ng-submit=\"vm.onSubmit(resetPasswordForm.$invalid)\" novalidate><div \nclass=\"form-box\" layout=\"column\" ng-if=\"!vm.clientLogin\"><mx-password-input form=\"resetPasswordForm\" \ninput-model=\"vm.form.password\" input-required=\"true\" edit=\"true\"></mx-password-input><mx-password-input \nform=\"resetPasswordForm\" input-model=\"vm.form.passwordConfirm\" confirmation=\"true\" input-required=\"true\" edit=\"true\">\n</mx-password-input><md-button type=\"submit\" class=\"md-raised md-accent submit-btn\" aria-label=\"UPDATE MY PASSWORD\" \nng-disabled=\"resetPasswordForm.$invalid || resetPasswordForm.$pristine\"><span ng-if=\"!vm.requestIn\">Salvar</span><div \nlayout=\"row\" layout-align=\"space-around\"><md-progress-circular md-theme=\"whiteTheme\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"20\" ng-show=\"vm.requestIn\"></md-progress-circular></div></md-button></div></form>\n</div><div ng-if=\"vm.success\"><h3><span>Sua senha foi alterada com sucesso!</span></h3><div class=\"md-padding pb-30\" \nlayout=\"column\" layout-align=\"center center\"><img src=\"assets/images/etc/ic-success.png\"></div><md-button \nng-click=\"vm.backToLogin()\" type=\"submit\" class=\"md-raised md-accent submit-btn\" aria-label=\"Entrar\">Entrar</md-button>\n</div></mx-panel></div></div><mx-footer external=\"true\"></mx-footer>");
$templateCache.put("app/main/pages/home/issues/issue.html","<div class=\"container-issue\" ng-repeat=\"issue in vm.issues\"><mx-panel><md-tab-body><mx-activities issue=\"issue\" \nactivities=\"issue.activities.items\" action=\"issue.activities.action\" callback-details=\"vm.onClickIssue\" \ncallback-item=\"issue\" is-issue=\"true\" pagination=\"issue.activities.pagination\"></mx-activities></md-tab-body>\n</mx-panel></div>");
$templateCache.put("app/main/pages/home/tabs/activities.html","<mx-activities issue=\"issue\" activities=\"tables.activities.items\" action=\"tables.activities.action\" \nhidden-fields=\"tables.activities.hiddenFields\" last-access=\"lastAccess\" callback-details=\"onActivityDetailsClick\" \ncallback-more=\"onLoadMoreClick\" callback-search=\"onSearch\" pagination=\"tables.activities.pagination\"></mx-activities>");
$templateCache.put("app/main/pages/home/tabs/chat-history.html","<div class=\"tabs chat-history\"><div layout=\"column\"><div class=\"navigation-bar pv-10\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button md-accent\" ng-click=\"onChatBackClick()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><img ng-src=\"{{chatHistory.user.avatar}}\" \nsrc=\"assets/images/avatars/profile.jpg\" class=\"avatar medium\" noretina><div layout=\"column\" \nlayout-align=\"center start\"><span class=\"grey-700-fg\">{{chatHistory.user.name}}</span> <span \nclass=\"grey-500-fg font-size-10 text-italic text-truncate\">\nConversa encerrada em {{chatHistory.ended_at | date:\'dd/MM/yyyy - HH:mm:ss\'}}</span></div></div><mx-chat \nchat=\"chatHistory\" messages=\"chatHistory.messages\" show-users=\"true\" history=\"true\" \npagination=\"chatHistory.pagination\"></mx-chat></div></div>");
$templateCache.put("app/main/pages/home/tabs/chats.html","<div class=\"tabs chats\"><mx-loader loader-id=\"chatsLoader\" local=\"true\"></mx-loader><mx-search-input \ncallback=\"onSearch\" ng-if=\"!loading && (!tables.chats.items || !tables.chats.items.length)\"></mx-search-input><mx-table\n ng-if=\"tables.chats.items && tables.chats.items.length\" items=\"tables.chats.items\" action=\"tables.chats.action\" \nhidden-fields=\"tables.chats.hiddenFields\" query=\"query\"></mx-table><mx-empty icon=\"\'icon-comment\'\" \nng-if=\"!loading && (!tables.chats.items || !tables.chats.items.length)\">Nenhuma conversa encontrada.</mx-empty><div \nclass=\"pb-20\" ng-class=\"{\'pt-40\': tables.chats.items && tables.chats.items.length}\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised md-sm\" ng-click=\"onNewChatClick()\">Nova Conversa\n</md-button></div><div ng-show=\"fixDynamicHeight\">&nbsp;</div></div>");
$templateCache.put("app/main/pages/home/tabs/details.html","<mx-details issue=\"issue\" on-submit=\"onDetailsSubmit\"></mx-details>");
$templateCache.put("app/main/pages/home/tabs/documents.html","<div class=\"tabs documents\"><mx-loader loader-id=\"detailsLoader\" local=\"true\"></mx-loader><div \nng-if=\"tables.documents.items && tables.documents.items.length\"><h3>Documentos</h3><p>\nEnvie os documentos necessários para o encaminhamento do processo</p><mx-list-documents items=\"tables.documents.items\" \nng-if=\"tables.documents.items && tables.documents.items.length\"></mx-list-documents></div><mx-empty icon=\"\'icon-file\'\" \nng-if=\"!loading && (!tables.documents.items || !tables.documents.items.length)\">Nenhum documento encontrado.</mx-empty>\n</div>");
$templateCache.put("app/main/pages/issues/issue/issue.html","<div id=\"issue\" layout-fill><div class=\"main scrollable\" ms-scroll flex><mx-container class=\"content\"><mx-breadcrumb \ncrumbs=\"vm.breadcrumbs\"></mx-breadcrumb><div class=\"client\" ng-if=\"!vm.isClient\"><mx-section-divider \nsection-title=\"vm.occurrence.client.company_fantasy_name || vm.occurrence.client.name\"></mx-section-divider><hr \nclass=\"gray mb-10\"><div layout=\"column\" layout-align=\"center center\"><h3>\nChamado nº {{vm.occurrence.id | numberFixedLen:5}}</h3><div class=\"status-top\">Status: <span \nclass=\"{{vm.occurrence.readable_status.classes}}\">{{vm.occurrence.readable_status.value}}</span></div></div><mx-panel \ntabbed=\"true\" tab-badges=\"vm.tabBadges\"><md-tabs md-dynamic-height md-stretch-tabs=\"always\" \nmd-selected=\"vm.currentTab\"><md-tab label=\"Atividades\" md-on-select=\"vm.onTabChange()\"><md-tab-body><div class=\"tabs\">\n<div class=\"container-send-message\" layout=\"column\" layout-align=\"center center\"><div ng-if=\"!vm.successSendMessage\">\n<h3>Enviar mensagem</h3><p class=\"font-size-14\">\nCaso deseje, você pode enviar uma mensagem, que será incluida nas atividades do chamado</p></div><div \nng-if=\"vm.successSendMessage\"><h3>Mensagem enviada</h3><p class=\"font-size-14\">\nSua mensagem foi enviada e ficará registrada nas Atividades do Chamado.</p></div></div><mx-send-message \nsuccess=\"vm.successSendMessage\" on-send=\"vm.onMessageSend\"></mx-send-message><hr class=\"blue mb-10\"><mx-activities \nissue=\"vm.occurrence\" activities=\"vm.activities\" action=\"vm.action\" last-access=\"vm.lastAccess\" \ncallback-more=\"vm.onLoadMoreClick\" pagination=\"vm.pagination\"></mx-activities></div></md-tab-body></md-tab><md-tab \nlabel=\"Detalhes\" md-on-select=\"vm.onTabChange()\"><md-tab-body><mx-details issue=\"vm.occurrence\" \non-submit=\"vm.onDetailsSubmit\"></mx-details></md-tab-body></md-tab></md-tabs></mx-panel></div></mx-container></div>\n<mx-footer></mx-footer></div>");
$templateCache.put("app/main/partials/dialogs/chat-history/chat-history-dialog.html","<md-dialog class=\"chat-history-dialog\" aria-label=\"Detalhes da conversa\"><md-toolbar class=\"md-accent\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Detalhes da conversa</span><md-button class=\"md-icon-button\" ng-click=\"vm.onCloseDialogClick()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"APP.DIALOGS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><mx-loader \nloader-id=\"chatLoader\" local=\"true\"></mx-loader><div class=\"datetime-bar\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"grey-500-fg\">\nIniciada em {{vm.chat.created_at | date:\'dd/MM/yyyy - HH:mm:ss\'}}</span><md-button class=\"previous-btn md-primary\" \nng-click=\"vm.onViewPreviousChatClick()\" ng-if=\"vm.chat.previous_conversation_id\"><span class=\"view-previous\">\nVer anterior</span><md-icon md-font-icon=\"icon-history\"></md-icon></md-button></div><div class=\"dialog-content\" \nlayout=\"column\"><mx-chat chat=\"vm.chat\" contact=\"vm.chat.Staff\" user=\"vm.chat.Clients\" messages=\"vm.messages\" \nshow-users=\"true\" history=\"true\" pagination=\"vm.pagination\"></mx-chat></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/partials/dialogs/confirm/confirm-dialog.html","<md-dialog class=\"confirm-dialog\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 class=\"title\">\n{{vm.dialog.title}}</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Fechar\" translate translate-attr-aria-label=\"DIALOGS.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><md-content><p \nclass=\"message font-size-16 text-center grey-500-fg\">{{vm.dialog.message}}</p></md-content></md-dialog-content>\n<md-dialog-actions class=\"grey-50-bg\" layout=\"column\" layout-gt-xs=\"row\" layout-align=\"space-between stretch\" \nlayout-align-gt-xs=\"space-between center\"><md-button ng-click=\"vm.cancel()\" \nclass=\"cancel-btn md-accent md-outline md-raised\" flex-gt-xs=\"35\">{{vm.dialog.cancel}}</md-button><md-button \nng-click=\"vm.hide()\" class=\"ok-btn md-primary md-raised\" flex-gt-xs=\"35\">{{vm.dialog.ok}}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/partials/dialogs/document-preview/document-preview-dialog.html","<md-dialog class=\"document-preview-dialog\"><form name=\"documentPreview\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 class=\"white\"><span>Ver documento</span></h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.onCloseDialogClick()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><md-content><mx-loader loader-id=\"documentImageLoader\" \nstarts-on=\"true\"></mx-loader><div layout=\"column\"><div class=\"doc-preview\"><img ng-if=\"vm.document.type != \'pdf\'\" \nng-src=\"{{vm.document.img}}\" src=\"assets/images/etc/upload-fallback.jpg\" noretina mx-img-orientation></div></div>\n</md-content></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/partials/dialogs/terms/terms-dialog.html","<md-dialog class=\"terms-dialog\" aria-label=\"Termos de Uso e Privacidade\"><md-toolbar class=\"md-accent\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Termos de Uso e Privacidade</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Fechar\" translate translate-attr-aria-label=\"DIALOGS.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"dialog-content\" layout=\"column\"><h3 \nclass=\"gray-darkest bold\">1. Informações gerais</h3><p>\nA presente Política contém informações a respeito do modo como tratamos, total ou parcialmente, de forma automatizada ou não, os dados pessoais dos usuários que acessam nosso site. Seu objetivo é esclarecer os interessados acerca dos tipos de dados que são coletados, dos motivos da coleta e da forma como o usuário poderá atualizar, gerenciar ou excluir estas informações.\n</p><p>\nEsta Política foi elaborada em conformidade com a Lei Federal n. 12.965 de 23 de abril de 2014 (Marco Civil da Internet), com a Lei Federal n. 13.709, de 14 de agosto de 2018 (Lei de Proteção de Dados Pessoais).\n</p><p>\nEsta Política poderá ser atualizada em decorrência de eventual atualização normativa, razão pela qual se convida o usuário a consultar periodicamente esta seção.\n</p><br><h3 class=\"gray-darkest bold\">2. Direitos do usuário</h3><p>\nO site se compromete a cumprir as normas previstas em Lei, em respeito aos seguintes princípios:</p><ul><li>\nOs dados pessoais do usuário serão processados de forma lícita, leal e transparente (licitude, lealdade e transparência);\n</li><li>\nOs dados pessoais do usuário serão coletados apenas para finalidades determinadas, explícitas e legítimas, não podendo ser tratados posteriormente de uma forma incompatível com essas finalidades (limitação das finalidades);\n</li><li>\nOs dados pessoais do usuário serão coletados de forma adequada, pertinente e limitada às necessidades do objetivo para os quais eles são processados (minimização dos dados);\n</li><li>\nOs dados pessoais do usuário serão exatos e atualizados sempre que necessário, de maneira que os dados inexatos sejam apagados ou retificados quando possível (exatidão);\n</li><li>\nOs dados pessoais do usuário serão conservados de uma forma que permita a identificação dos titulares dos dados apenas durante o período necessário para as finalidades para as quais são tratados (limitação da conservação);\n</li><li>\nOs dados pessoais do usuário serão tratados de forma segura, protegidos do tratamento não autorizado ou ilícito e contra a sua perda, destruição ou danificação acidental, adotando as medidas técnicas ou organizativas adequadas (integridade e confidencialidade).\n</li></ul><p>O usuário do site possui os seguintes direitos, conferidos pela Lei de Proteção de Dados Pessoais:</p><ul>\n<li>\nDireito de confirmação e acesso: é o direito do usuário de obter do site a confirmação de que os dados pessoais que lhe digam respeito são ou não objeto de tratamento e, se for esse o caso, o direito de acessar os seus dados pessoais;\n</li><li>\nDireito de retificação: é o direito do usuário de obter do site, sem demora injustificada, a retificação dos dados pessoais inexatos que lhe digam respeito;\n</li><li>\nDireito à eliminação dos dados (direito ao esquecimento): é o direito do usuário de ter seus dados apagados do site;\n</li><li>\nDireito à limitação do tratamento dos dados: é o direito do usuário de limitar o tratamento de seus dados pessoais, podendo obtê-la quando contesta a exatidão dos dados, quando o tratamento for ilícito, quando o site não precisar mais dos dados para as finalidades propostas e quando tiver se oposto ao tratamento dos dados e em caso de tratamento de dados desnecessários;\n</li><li>\nDireito de oposição: é o direito do usuário de, a qualquer momento, se opor por motivos relacionados com a sua situação particular, ao tratamento dos dados pessoais que lhe digam respeito, podendo se opor ainda ao uso de seus dados pessoais para definição de perfil de marketing (profiling);\n</li><li>\nDireito de portabilidade dos dados: é o direito do usuário de receber os dados pessoais que lhe digam respeito e que tenha fornecido ao site, num formato estruturado, de uso corrente e de leitura automática;\n</li><li>\nDireito de não ser submetido a decisões automatizadas: é o direito do usuário de não ficar sujeito a nenhuma decisão tomada exclusivamente com base no tratamento automatizado, incluindo a definição de perfis (profiling), que produza efeitos na sua esfera jurídica ou que o afete significativamente de forma similar.\n</li></ul><p>\nO usuário poderá exercer os seus direitos por meio de comunicação escrita enviada ao site com o assunto \"www.segurocomseguro.com.br\", especificando:\n</p><p>O pedido deverá ser enviado ao e-mail: <a href=\"mailto:contato@segurocomseguro.com.br\">\ncontato@segurocomseguro.com.br</a>, ou por correio, ao seguinte endereço:</p><blockquote><b>Affonso e Affonso</b><br>\nRua Gal Jardim, 482 - 31, São Paulo - SP</blockquote><p>\nO usuário será informado em caso de retificação ou eliminação dos seus dados.</p><br><h3 class=\"gray-darkest bold\">\n3. Dever de não fornecer dados de terceiros</h3><p>\nDurante a utilização do site, a fim de resguardar e de proteger os direitos de terceiros, o usuário do site deverá fornecer somente seus dados pessoais, e não os de terceiros, salvo mediante a apresentação de procuração específica.\n</p><br><h3 class=\"gray-darkest bold\">4. Informações coletadas</h3><p>\nA coleta de dados dos usuários se dará em conformidade com o disposto nesta Política de Privacidade e dependerá do consentimento do usuário, sendo este dispensável somente nas hipóteses previstas no art. 11, inciso II, da Lei de Proteção de Dados Pessoais.\n</p><br><h4 class=\"gray-darkest bold\">4.1. Tipos de dados coletados</h4><br><h4 class=\"gray-darkest bold italic\">\n4.1.1. Tipos de dados coletados</h4><p>\nA utilização, pelo usuário, de determinadas funcionalidades do site dependerá de cadastro, sendo que, nestes casos, os seguintes dados do usuário serão coletados e armazenados:\n</p><ul><li>nome;</li><li>data de nascimento;</li><li>endereço de e-mail;</li><li>endereço postal;</li><li>\nnúmero de telefone;</li><li>número de CPF;</li><li>número de CNPJ, se aplicável.</li></ul><br><h4 \nclass=\"gray-darkest bold italic\">4.1.2. Dados sensíveis</h4><p>\nO site poderá coletar os seguintes dados sensíveis dos usuários:</p><ul><li>dados relativos à saúde do usuário.</li>\n</ul><br><h4 class=\"gray-darkest bold italic\">4.1.3. Coleta de dados não previstos expressamente</h4><p>\nEventualmente, outros tipos de dados não previstos expressamente nesta Política de Privacidade poderão ser coletados, desde que sejam fornecidos com o consentimento do usuário, ou, ainda, que a coleta seja permitida ou imposta por lei.\n</p><br><h4 class=\"gray-darkest bold\">4.2. Fundamento jurídico para o tratamento dos dados pessoais</h4><p>\nAo utilizar os serviços do site, o usuário está consentindo com a presente Política de Privacidade.</p><p>\nO usuário tem o direito de retirar seu consentimento a qualquer momento, não comprometendo a licitude do tratamento de seus dados pessoais antes da retirada. A retirada do consentimento poderá ser feita pelo e-mail: \n<a href=\"mailto:contato@segurocomseguro.com.br\">contato@segurocomseguro.com.br</a>\n, ou por correio enviado ao seguinte endereço:</p><blockquote>Rua Gal Jardim, 482 - 31, São Paulo - SP</blockquote><p>\nO consentimento dos relativamente ou absolutamente incapazes, especialmente de crianças menores de 16 (dezesseis) anos, apenas poderá ser feito, respectivamente, se devidamente assistidos ou representados.\n</p><p>\nO tratamento de dados pessoais sem o consentimento do usuário apenas será realizado em razão de interesse legítimo ou para as hipóteses previstas em lei, ou seja, dentre outras, as seguintes:\n</p><ul><li>para o cumprimento de obrigação legal ou regulatória pelo controlador;</li><li>\npara a realização de estudos por órgão de pesquisa, garantida, sempre que possível, a anonimização dos dados pessoais;\n</li><li>\nquando necessário para a execução de contrato ou de procedimentos preliminares relacionados a contrato do qual seja parte o usuário, a pedido do titular dos dados;\n</li><li>\npara o exercício regular de direitos em processo judicial, administrativo ou arbitral, esse último nos termos da Lei nº 9.307, de 23 de setembro de 1996 (Lei de Arbitragem);\n</li><li>para a proteção da vida ou da incolumidade física do titular dos dados ou de terceiro;</li><li>\npara a tutela da saúde, em procedimento realizado por profissionais da área da saúde ou por entidades sanitárias;</li>\n<li>\nquando necessário para atender aos interesses legítimos do controlador ou de terceiro, exceto no caso de prevalecerem direitos e liberdades fundamentais do titular dos dados que exijam a proteção dos dados pessoais;\n</li><li>para a proteção do crédito, inclusive quanto ao disposto na legislação pertinente.</li></ul><br><h4 \nclass=\"gray-darkest bold\">4.3. Finalidades do tratamento dos dados pessoais</h4><p>\nOs dados pessoais do usuário coletados pelo site têm por finalidade facilitar, agilizar e cumprir os compromissos estabelecidos com o usuário e a fazer cumprir as solicitações realizadas por meio do preenchimento de formulários.\n</p><p>\nOs dados de cadastro serão utilizados para permitir o acesso do usuário a determinados conteúdos do site, exclusivos para usuários cadastrados.\n</p><p>\nO tratamento de dados pessoais para finalidades não previstas nesta Política de Privacidade somente ocorrerá mediante comunicação prévia ao usuário, sendo que, em qualquer caso, os direitos e obrigações aqui previstos permanecerão aplicáveis.\n</p><br><h4 class=\"gray-darkest bold\">4.4. Prazo de conservação dos dados pessoais</h4><p>\nOs dados pessoais do usuário serão conservados pelo prazo máximo de: 3 anos, exceto se o usuário solicitar a sua supressão antes do final deste prazo.\n</p><p>\nOs dados pessoais dos usuários apenas poderão ser conservados após o término de seu tratamento nas seguintes hipóteses:\n</p><ul><li>para o cumprimento de obrigação legal ou regulatória pelo controlador;</li><li>\npara estudo por órgão de pesquisa, garantida, sempre que possível, a anonimização dos dados pessoais;</li><li>\npara a transferência a terceiro, desde que respeitados os requisitos de tratamento de dados dispostos na legislação;\n</li><li>para uso exclusivo do controlador, vedado seu acesso por terceiro, e desde que anonimizados os dados.</li>\n</ul><br><h4 class=\"gray-darkest bold\">4.5. Destinatários e transferência dos dados pessoais</h4><p>\nOs dados pessoais do usuário não serão compartilhadas com terceiros. Serão, portanto, tratados apenas por este site.\n</p><br><h3 class=\"gray-darkest bold\">5. Do tratamento dos dados pessoais</h3><br><h4 class=\"gray-darkest bold\">\n5.1. Do responsável pelo tratamento dos dados <span class=\"italic\">(data controller)</span></h4><p>\nO controlador, responsável pelo tratamento dos dados pessoais do usuário, é a pessoa física ou jurídica, a autoridade pública, a agência ou outro organismo que, individualmente ou em conjunto com outras, determina as finalidades e os meios de tratamento de dados pessoais.\n</p><p>Neste site, o responsável pelo tratamento dos dados pessoais coletados é <b>Affonso e Affonso</b>\n, representada por Fábio Affonso, que poderá ser contactado pelo e-mail: <a \nhref=\"mailto:contato@segurocomseguro.com.br\">contato@segurocomseguro.com.br</a> ou no endereço:</p><blockquote>\nRua Gal Jardim, 482 - 31, São Paulo - SP</blockquote><p>\nO responsável pelo tratamento dos dados se encarregará diretamente do tratamento dos dados pessoais do usuário.</p><br>\n<h4 class=\"gray-darkest bold\">5.2. Do encarregado de proteção de dados <span class=\"italic\">(data protection officer)\n</span></h4><p>O encarregado de proteção de dados <span class=\"italic\">(data protection officer)</span>\n é o profissional encarregado de informar, aconselhar e controlar o responsável pelo tratamento dos dados, bem como os trabalhadores que tratem os dados, a respeito das obrigações do site nos termos do RGDP, da Lei de Proteção de Dados Pessoais e de outras disposições de proteção de dados presentes na legislação nacional e internacional, em cooperação com a autoridade de controle competente.\n</p><p>Neste site o encarregado de proteção de dados <span class=\"italic\">(data protection officer)</span> é <b>\nFábio Affonso</b>, que poderá ser contactado pelo e-mail: <a href=\"mailto:contato@segurocomseguro.com.br\">\ncontato@segurocomseguro.com.br</a>.</p><br><h3 class=\"gray-darkest bold\">\n6. Segurança no tratamento dos dados pessoais do usuário</h3><p>\nO site se compromete a aplicar as medidas técnicas e organizativas aptas a proteger os dados pessoais de acessos não autorizados e de situações de destruição, perda, alteração, comunicação ou difusão de tais dados.\n</p><p>\nPara a garantia da segurança, serão adotadas soluções que levem em consideração: as técnicas adequadas; os custos de aplicação; a natureza, o âmbito, o contexto e as finalidades do tratamento; e os riscos para os direitos e liberdades do usuário.\n</p><p>\nO site utiliza certificado SSL (Secure Socket Layer) que garante que os dados pessoais se transmitam de forma segura e confidencial, de maneira que a transmissão dos dados entre o servidor e o usuário, e em retroalimentação, ocorra de maneira totalmente cifrada ou encriptada.\n</p><p>\nNo entanto, o site se exime de responsabilidade por culpa exclusiva de terceiro, como em caso de ataque de hackers ou crackers, ou culpa exclusiva do usuário, como no caso em que ele mesmo transfere seus dados a terceiro. O site se compromete, ainda, a comunicar o usuário em prazo adequado caso ocorra algum tipo de violação da segurança de seus dados pessoais que possa lhe causar um alto risco para seus direitos e liberdades pessoais.\n</p><p>\nA violação de dados pessoais é uma violação de segurança que provoque, de modo acidental ou ilícito, a destruição, a perda, a alteração, a divulgação ou o acesso não autorizados a dados pessoais transmitidos, conservados ou sujeitos a qualquer outro tipo de tratamento.\n</p><p>\nPor fim, o site se compromete a tratar os dados pessoais do usuário com confidencialidade, dentro dos limites legais.\n</p><br><h3 class=\"gray-darkest bold\">7. Dados de navegação <span class=\"italic\">(cookies)</span></h3><p><span \nclass=\"italic\">Cookies</span>\n são pequenos arquivos de texto enviados pelo site ao computador do usuário e que nele ficam armazenados, com informações relacionadas à navegação do site.\n</p><p>Por meio dos <span class=\"italic\">cookies</span>\n, pequenas quantidades de informação são armazenadas pelo navegador do usuário para que nosso servidor possa lê-las posteriormente. Podem ser armazenados, por exemplo, dados sobre o dispositivo utilizado pelo usuário, bem como seu local e horário de acesso ao site.\n</p><p>Os <span class=\"italic\">cookies</span>\n não permitem que qualquer arquivo ou informação sejam extraídos do disco rígido do usuário, não sendo possível, ainda, que, por meio deles, se tenha acesso a informações pessoais que não tenham partido do usuário ou da forma como utiliza os recursos do site.\n</p><p>\nÉ importante ressaltar que nem todo cookie contém informações que permitem a identificação do usuário, sendo que determinados tipos de \n<span class=\"italic\">cookies</span>\n podem ser empregados simplesmente para que o site sejam carregado corretamente ou para que suas funcionalidades funcionem do modo esperado.\n</p><p>As informações eventualmente armazenadas em <span class=\"italic\">cookies</span>\n que permitam identificar um usuário são consideradas dados pessoais. Dessa forma, todas as regras previstas nesta Política de Privacidade também lhes são aplicáveis.\n</p><br><h4 class=\"gray-darkest bold\">7.1. Cookies do site</h4><p>Os <span class=\"italic\">cookies</span>\n do site são aqueles enviados ao computador ou dispositivo do usuário e administrador exclusivamente pelo site.</p><p>\nAs informações coletadas por meio destes <span class=\"italic\">cookies</span>\n são utilizadas para melhorar e personalizar a experiência do usuário, sendo que alguns <span class=\"italic\">cookies\n</span>\n podem, por exemplo, ser utilizados para lembrar as preferências e escolhas do usuário, bem como para o oferecimento de conteúdo personalizado.\n</p><p>\nEstes dados de navegação poderão, ainda, ser compartilhados com eventuais parceiros do site, buscando o aprimoramento dos produtos e serviços ofertados ao usuário.\n</p><br><h4 class=\"gray-darkest bold\">7.2. Gestão dos cookies e configurações do navegador</h4><p>\nO usuário poderá se opor ao registro de cookies pelo site, bastando que desative esta opção no seu próprio navegador ou aparelho.\n</p><p>\nA desativação dos cookies, no entanto, pode afetar a disponibilidade de algumas ferramentas e funcionalidades do site, comprometendo seu correto e esperado funcionamento. Outra consequência possível é remoção das preferências do usuário que eventualmente tiverem sido salvas, prejudicando sua experiência.\n</p><p>\nA seguir, são disponibilizados alguns links para as páginas de ajuda e suporte dos navegadores mais utilizados, que poderão ser acessadas pelo usuário interessado em obter mais informações sobre a gestão de cookies em seu navegador:\n</p><blockquote>Internet Explorer<br><a \nhref=\"https://support.microsoft.com/pt-br/help/17442/windows-internet-explorer-delete-manage-cookies\">\nhttps://support.microsoft.com/pt-br/help/17442/windows-internet-explorer-delete-manage-cookies</a></blockquote>\n<blockquote>Safari<br><a href=\"https://support.apple.com/pt-br/guide/safari/sfri11471/mac\">\nhttps://support.apple.com/pt-br/guide/safari/sfri11471/mac</a></blockquote><blockquote>Google Chrome<br><a \nhref=\"https://support.google.com/chrome/answer/95647?hl=pt-BR&hlrm=pt\">\nhttps://support.google.com/chrome/answer/95647?hl=pt-BR&hlrm=pt</a></blockquote><blockquote>Mozila Firefox<br><a \nhref=\"https://support.mozilla.org/pt-BR/kb/ative-e-desative-os-cookies-que-os-sites-usa\">\nhttps://support.mozilla.org/pt-BR/kb/ative-e-desative-os-cookies-que-os-sites-usa</a></blockquote><blockquote>Opera<br>\n<a href=\"https://www.opera.com/help/tutorials/security/privacy/\">https://www.opera.com/help/tutorials/security/privacy/\n</a></blockquote><br><h3 class=\"gray-darkest bold\">8. Reclamação a uma autoridade de controle</h3><p>\nSem prejuízo de qualquer outra via de recurso administrativo ou judicial, todos os titulares de dados têm direito a apresentar reclamação a uma autoridade de controle. A reclamação poderá ser feita à autoridade da sede do site, do país de residência habitual do usuário, do seu local de trabalho ou do local onde foi alegadamente praticada a infração.\n</p><br><h3 class=\"gray-darkest bold\">9. Das alterações</h3><p>\nA presente versão desta Política de Privacidade foi atualizada pela última vez em: 27/03/2019.</p><p>\nO editor se reserva o direito de modificar, a qualquer momento o site as presentes normas, especialmente para adaptá-las às evoluções do site \n<b>segurocomseguro</b>\n, seja pela disponibilização de novas funcionalidades, seja pela supressão ou modificação daquelas já existentes.</p>\n<p>O usuário será explicitamente notificado em caso de alteração desta política.</p><p>\nAo utilizar o serviço após eventuais modificações, o usuário demonstra sua concordância com as novas normas. Caso discorde de alguma das modificações, deverá pedir, imediatamente, o cancelamento de sua conta e apresentar a sua ressalva ao serviço de atendimento, se assim o desejar.\n</p><br><h3 class=\"gray-darkest bold\">10. Do Direito aplicável e do foro</h3><p>\nPara a solução das controvérsias decorrentes do presente instrumento, será aplicado integralmente a legislação brasileira.\n</p><p>\nOs eventuais litígios deverão ser apresentados no foro da comarca da Capital do Estado de São Paulo, em que se encontra a sede do editor do site.\n</p><br><h3 class=\"gray-darkest bold center\">TERMO DE USO</h3><br><h3 class=\"gray-darkest bold center\">\nDA ACEITAÇÃO DOS TERMOS E CONDIÇÕES GERAIS DE USO GRATUITO</h3><p>\nTodos aqueles que desejarem ter acesso aos serviços ofertados através do site <a \nhref=\"https://www.segurocomseguro.com.br\">www.segurocomseguro.com.br</a>\n deverão, primeiramente, se informar sobre as regras que compõe o presente instrumento.</p><p>Ao utilizar o site <a \nhref=\"https://www.segurocomseguro.com.br\">www.segurocomseguro.com.br</a>\n, o usuário aceita integralmente as presentes normas e compromete-se a observá-las, sob risco de aplicação das penalidades cabíveis. Antes de iniciar qualquer navegação no site, o usuário deverá cientificar-se de eventuais modificações ou atualizações ocorridas neste termo.\n</p><p>\nO usuário poderá ainda ser avisado por e-mail ou diretamente no próprio site sobre eventuais mudanças nas presentes normas.\n</p><p>\nCaso não concorde com quaisquer das regras aqui descritas, o usuário deve, imediatamente, abster-se de utilizar o serviço. Se for de seu interesse, poderá, ainda, entrar em contato com o serviço de atendimento ao cliente, para apresentar-lhes as suas ressalvas.\n</p><p>Para boa gestão, o editor do site <a href=\"https://www.segurocomseguro.com.br\">www.segurocomseguro.com.br</a>\n poderá, a qualquer momento:</p><ul class=\"letters\"><li>\nSuspender, interromper ou limitar o acesso a todo ou a parte do site a uma categoria específica de internautas;</li>\n<li>\nRemover toda informação que possa perturbar o funcionamento do site ou que esteja em conflito com normas de direito brasileiro ou de direito internacional;\n</li><li>Suspender o site, a fim de realizar atualizações e modificações.</li></ul><p>\nOs serviços disponibilizados no site <a href=\"https://www.segurocomseguro.com.br\">www.segurocomseguro.com.br</a>\n apenas poderão ser acessados por pessoas plenamente capazes, conforme o Direito brasileiro. Todos aqueles que não possuírem plena capacidade civil - menores de 18 anos não emancipados, pródigos, ébrios habituais ou viciados em tóxicos e pessoas que não puderem exprimir sua vontade, por motivo transitório ou permanente - deverão ser devidamente assistidos por seus representantes legais, que se responsabilizarão pelo cumprimento das presentes regras.\n</p><p>Ao usuário, será permitido manter apenas uma conta junto ao site <a href=\"https://www.segurocomseguro.com.br\">\nwww.segurocomseguro.com.br</a>\n. Contas duplicadas serão automaticamente desativadas pelo editor do site, sem prejuízo de demais penalidades cabíveis.\n</p><p>\nPara o devido cadastramento junto ao serviço, o usuário deverá fornecer integralmente os dados requeridos. Todas as informações fornecidas pelo usuário devem ser precisas, verdadeiras e atualizadas. Em qualquer caso, o usuário responderá, em âmbito cível e criminal, pela veracidade, exatidão e autenticidade dos dados informados.\n</p><p>\nO usuário deverá fornecer um endereço de e-mail válido, através do qual o site realizará todos os contatos necessários. Todas as comunicações enviadas para o referido endereço serão consideradas lidas pelo usuário, que se compromete, assim, a consultar regularmente suas mensagens recebidas e a respondê-las em prazo razoável.\n</p><p>\nApós a confirmação de seu cadastro, o usuário possuirá um login (apelido) e uma senha pessoais, que deverão ser por ele utilizados para o acesso a sua conta no site. Estes dados de conexão não poderão ser informados pelo usuário a terceiros, sendo de sua inteira responsabilidade o uso que deles seja feito. O usuário compromete-se a comunicar imediatamente ao editor do site quaisquer atividades suspeitas ou inesperadas em sua conta.\n</p><p>\nNão será permitido ceder, vender, alugar ou transferir, de qualquer forma, a conta, que é pessoal e intransferível.</p>\n<p>\nSerá automaticamente descadastrado o usuário que descumprir quaisquer das normas contidas no presente instrumento, sendo-lhe vedado realizar nova inscrição no site.\n</p><p>\nO usuário poderá, a qualquer tempo e sem necessidade de justificação, requerer o cancelamento de seu cadastro junto ao site \n<a href=\"https://www.segurocomseguro.com.br\">www.segurocomseguro.com.br</a>\n. O seu descadastramento será realizado o mais rapidamente possível.</p><p>\nQuaisquer informações incluídas pelos usuários serão de inteira responsabilidade dos próprios.</p><p>\nO usuário é responsável, ainda:</p><ul class=\"letters\"><li>\nPela correta utilização do site e de seus serviços, prezando pela boa convivência, pelo respeito e pela cordialidade;\n</li><li>\nPelo cumprimento das regras contidas neste instrumento, bem como normas de direito nacional e de direito internacional;\n</li><li>Pela proteção dos dados de acesso à sua conta (login e senha).</li></ul><p>O editor não será responsável:</p>\n<ul class=\"letters\"><li>\nPelas características intrínsecas da internet, principalmente relativas à confiabilidade e à procedência das informações circulando nesta rede;\n</li><li>Pelos conteúdos ou atividades ilícitas praticadas através de seu site.</li></ul><p>A estrutura do site <a \nhref=\"https://www.segurocomseguro.com.br\">www.segurocomseguro.com.br</a>\n, bem como os textos, os gráficos, as imagens, as fotografias, os sons, os vídeos e as demais aplicações informáticas que o compõe são de propriedade do editor e são protegidas pela legislação brasileira e internacional referente à propriedade intelectual.\n</p><p>\nQualquer representação, reprodução, adaptação ou exploração parcial ou total dos conteúdos, marcas e serviços propostos pelo site, por qualquer meio que seja, sem autorização prévia, expressa e escrita do editor, é estritamente vedada podendo-se recorrer às medidas cíveis e penais cabíveis. Estão excluídos desta previsão apenas os elementos que estejam expressamente designados no site como livres de direitos autorais.\n</p><p>\nO acesso não gera para o usuário qualquer direito de propriedade intelectual relativo a elementos do site, os quais restam sob a propriedade exclusiva do editor.\n</p><p>É vedado ao usuário incluir no site dados que possam modificar o seu conteúdo ou sua aparência.</p><br></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/partials/dialogs/user-profile/user-profile-dialog.html","<md-dialog class=\"user-profile-dialog\" translate-attr-aria-label=\"DIALOGS.PROFILE.MY_PROFILE\" aria-label=\"Meu perfil\">\n<form name=\"userProfileForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"DIALOGS.PROFILE.MY_PROFILE\" ng-if=\"!vm.isCreation && vm.isLoggedProfile\">Meu Perfil</span> \n<span class=\"title\" translate=\"DIALOGS.PROFILE.PROFILE\" ng-if=\"!vm.isCreation && !vm.isLoggedProfile\">Perfil</span> \n<span class=\"title\" translate=\"DIALOGS.PROFILE.NEW_USER\" ng-if=\"vm.isCreation\">Novo usuário</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Fechar\" translate \ntranslate-attr-aria-label=\"DIALOGS.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"avatar-container\"><div \nclass=\"md-avatar avatar contact-avatar huge\"></div></div><div class=\"contact-name\">{{vm.dialog.user.first_name}}</div>\n<div class=\"contact-role grey-200-fg\">{{vm.dialog.user.role_id | roleName}}</div></div></div></md-toolbar>\n<md-dialog-content ms-scroll><md-content><mx-loader loader-id=\"userProfileDialogLoader\" starts-on=\"true\" modal=\"true\">\n</mx-loader><div layout=\"column\"><md-input-container flex><label translate=\"DIALOGS.PROFILE.FIRST_NAME\">Nome</label>\n<md-icon md-font-icon=\"icon-account\" class=\"grey-700-fg\"></md-icon><input name=\"first_name\" \nng-model=\"vm.user.first_name\" ng-disabled=\"vm.isReadOnly\" required><div \nng-messages=\"userProfileForm.first_name.$error\" ng-if=\"userProfileForm.first_name.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"DIALOGS.PROFILE.FIRST_NAME\">Nome</span> <span \ntranslate=\"APP.ERRORS.FIELD_REQUIRED\">é obrigatório</span></div></div></md-input-container><md-input-container flex>\n<label translate=\"DIALOGS.PROFILE.LAST_NAME\">Sobrenome</label><md-icon></md-icon><input name=\"last_name\" \nng-model=\"vm.user.last_name\" ng-disabled=\"vm.isReadOnly\" required><div ng-messages=\"userProfileForm.last_name.$error\" \nng-if=\"userProfileForm.last_name.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"DIALOGS.PROFILE.LAST_NAME\">Nome</span> <span translate=\"APP.ERRORS.FIELD_REQUIRED\">é obrigatório</span>\n</div></div></md-input-container><md-input-container flex><label translate=\"DIALOGS.PROFILE.EMAIL\">E-mail</label>\n<md-icon md-font-icon=\"icon-email\" class=\"grey-700-fg\"></md-icon><input name=\"email\" type=\"email\" \nng-model=\"vm.user.email\" ng-pattern=\"/^.+@.+\\..+$/\" required ng-disabled=\"vm.isReadOnly\"><div \nng-messages=\"userProfileForm.email.$error\" ng-if=\"userProfileForm.email.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"DIALOGS.PROFILE.EMAIL\">E-mail</span> <span \ntranslate=\"APP.ERRORS.FIELD_REQUIRED\">é obrigatório</span></div><div ng-message=\"pattern\"><span \ntranslate=\"DIALOGS.PROFILE.EMAIL\">E-mail</span> <span translate=\"APP.ERRORS.MUST_BE_VALID\">deve ser válido</span></div>\n</div></md-input-container><md-button class=\"md-primary\" ng-click=\"vm.onChangePasswordClick()\" \ntranslate=\"DIALOGS.PROFILE.CHANGE_PASSWORD\" ng-if=\"!vm.isCreation\">Alterar senha</md-button></div><div \nclass=\"temp-password\" layout=\"column\" ng-if=\"vm.isCreation\"><label class=\"mx-label\" \ntranslate=\"DIALOGS.PROFILE.TEMP_PASSWORD\">Senha provisória</label><md-input-container flex><label \ntranslate=\"DIALOGS.PROFILE.PASSWORD\">Senha</label><input type=\"password\" name=\"password\" ng-model=\"vm.user.password\" \nrequired><div ng-messages=\"userProfileForm.password.$error\" ng-if=\"userProfileForm.password.$touched\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"DIALOGS.PROFILE.PASSWORD\">Senha</span> <span \ntranslate=\"APP.ERRORS.FIELD_REQUIRED_F\">é obrigatória</span></div></div></md-input-container><md-input-container flex>\n<label translate=\"DIALOGS.PROFILE.CONFIRM_PASSWORD\">Confirmar senha</label><input type=\"password\" \nname=\"confirm_password\" ng-model=\"vm.user.confirm_password\" mx-confirm-password=\"{{vm.user.password}}\" required><div \nng-messages=\"userProfileForm.confirm_password.$error\" ng-if=\"userProfileForm.confirm_password.$touched\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"DIALOGS.PROFILE.CONFIRM_PASSWORD\">Confirmar senha</span> <span \ntranslate=\"APP.ERRORS.FIELD_REQUIRED\">é obrigatório</span></div><div ng-message=\"mxConfirmPassword\"><span \ntranslate=\"DIALOGS.PROFILE.ERRORS.PASSWORDS_DONT_MATCH\">A confirmação está diferente da nova senha</span></div></div>\n</md-input-container></div></md-content></md-dialog-content><md-dialog-actions class=\"grey-50-bg\" layout=\"row\" \nlayout-align=\"end center\" ng-if=\"!vm.isReadOnly\"><md-button ng-click=\"vm.onSaveClick()\" \nng-disabled=\"!userProfileForm.$valid || userProfileForm.$pristine || vm.loading\" \nclass=\"save-button md-primary md-hue-1 md-raised\" aria-label=\"SAVE\" translate=\"DIALOGS.SAVE\" \ntranslate-attr-aria-label=\"DIALOGS.SAVE\">Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/pages/auth/register/tabs/info.html","<div class=\"steps info\" layout=\"column\"><mx-loader loader-id=\"infoFormLoader\" local=\"true\"></mx-loader><form \nname=\"vm.infoForm\"><h3>Precisamos de mais informações...</h3><p>\nPor favor, preencha mais alguns dados necessários para completar o cadastro</p><mx-profile-info-form \nedit=\"!vm.isClient ? true : null\" form=\"vm.infoForm\" model=\"vm.user\" client=\"vm.isClient\" \nprogress-callback=\"vm.onUpdateProgress\" states=\"vm.states\" ng-if=\"vm.isClient !== null\"></mx-profile-info-form><div \nclass=\"actions\" layout=\"column\" layout-align=\"stretch center\"><md-button type=\"submit\" class=\"md-accent md-raised\" \nng-click=\"vm.onInfoSubmit(vm.infoForm.$invalid)\">Enviar</md-button></div></form></div>");
$templateCache.put("app/main/pages/auth/register/tabs/password.html","<div class=\"steps password\" layout=\"column\"><mx-loader loader-id=\"passwordFormLoader\" local=\"true\"></mx-loader><form \nname=\"vm.passwordForm\"><h3>Quase pronto...</h3><p>Agora, escolha uma senha de acesso:</p><mx-profile-password-form \nform=\"vm.passwordForm\" model=\"vm.user\" progress-callback=\"vm.onUpdateProgress\" ng-if=\"vm.isClient !== null\">\n</mx-profile-password-form><div class=\"actions\" layout=\"column\" layout-align=\"stretch center\"><md-button type=\"submit\" \nclass=\"md-accent md-raised\" ng-click=\"vm.onPasswordSubmit(vm.passwordForm.$invalid)\">Concluir cadastro</md-button>\n</div></form></div>");
$templateCache.put("app/main/pages/auth/register/tabs/success.html","<div class=\"steps success\" layout=\"column\"><mx-loader loader-id=\"successLoader\" local=\"true\"></mx-loader><h1>\nSeu cadastro foi realizado com sucesso!</h1><hr><div class=\"mt-10 mb-30\" layout=\"row\" layout-align=\"center center\"><img\n ng-src=\"assets/images/etc/ic-success.png\" width=\"80\" height=\"80\"></div><div class=\"actions\" layout=\"column\" \nlayout-align=\"stretch center\"><p>Clique no botão abaixo para acessar o sistema</p><md-button \nclass=\"md-accent md-raised\" ng-click=\"vm.onLoginClick()\">Entrar</md-button></div></div>");
$templateCache.put("app/main/pages/auth/register/tabs/welcome.html","<div class=\"steps welcome\" layout=\"column\"><mx-loader loader-id=\"welcomeLoader\" local=\"true\"></mx-loader><h1>\nBem-vindo(a), {{vm.user.company_fantasy_name || vm.user.name}}</h1><hr><p>Já temos alguns dados seus cadastrados:</p>\n<mx-readonly-data name=\"\'E-mail\'\" value=\"vm.user.email\"></mx-readonly-data><mx-readonly-data name=\"vm.clientDocName\" \nvalue=\"vm.user.document\" ng-if=\"vm.isClient\"></mx-readonly-data><hr><div class=\"actions\" layout=\"column\" \nlayout-align=\"stretch center\"><p>Mas para continuar, precisamos de mais algumas informações...</p><md-button \nclass=\"md-accent md-raised\" ng-click=\"vm.onStartClick()\">Começar</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");}]);